<template>
  <div class="sff-2023-interactive-viz-2">
    <div id="g-UOB-2023-2-box" class="ai2html">
      <!-- Artboard: _1140px -->
      <div
        id="g-UOB-2023-2-_1140px"
        class="g-artboard"
        style="width: 1140px; height: 671px"
        data-aspect-ratio="1.699"
        data-min-width="1138.5"
      >
        <svg
          class="g-UOB-2-_1140px-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-2-_1140px-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1140 671"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g id="bg-1140px" data-name="bg-1140px">
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M997.809,661.51c26.938-58.937,41.957-124.464,41.957-193.5
        c0-257.365-208.635-466-466-466s-466,208.635-466,466c0,69.036,15.019,134.563,41.957,193.5H997.809z"
              />
              <path fill="#A1E6BD" d="M719,523.545h345.5l43,61.5l-43,61.5H719v-61.5V523.545z" />
              <path fill="#BFC9FF" d="M420.5,523.545H75l-43,61.5l43,61.5h345.5v-61.5V523.545z" />
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M779.987,670.545c-0.539-116.071-94.789-210-210.986-210
        s-210.447,93.929-210.986,210H779.987z"
              />
              <line fill="none" stroke="#A7A8A9" stroke-dasharray="2,2" x1="570" y1="556.545" x2="570" y2="650.545" />
              <path
                fill="#005EB8"
                d="M538.5,449.331c0-2.011,1.668-3.786,3.812-3.786h7.626c2.025,0,3.812,1.775,3.812,3.786v17.982
        l18.586-10.056c1.906-0.946,4.289,0.355,4.289,2.603v7.453l18.586-10.056c1.906-0.946,4.289,0.355,4.289,2.603v17.864v15.142
        c0,3.195-2.621,5.679-5.719,5.679h-49.562c-3.217,0-5.719-2.484-5.719-5.679v-9.464v-5.678V449.331z M566.141,478.67
        c-1.073,0-1.907,0.946-1.907,1.893v5.678c0,1.065,0.834,1.893,1.907,1.893h5.718c0.953,0,1.907-0.828,1.907-1.893v-5.678
        c0-0.947-0.954-1.893-1.907-1.893H566.141z M548.984,480.563v5.678c0,1.065,0.834,1.893,1.907,1.893h5.718
        c0.953,0,1.907-0.828,1.907-1.893v-5.678c0-0.947-0.954-1.893-1.907-1.893h-5.718C549.818,478.67,548.984,479.616,548.984,480.563
        z M581.391,478.67c-1.073,0-1.907,0.946-1.907,1.893v5.678c0,1.065,0.834,1.893,1.907,1.893h5.718
        c0.953,0,1.907-0.828,1.907-1.893v-5.678c0-0.947-0.954-1.893-1.907-1.893H581.391z"
              />
              <path
                fill="#005EB8"
                d="M545.075,413.295c1.898,0,3.64,1.237,4.336,3.079l0.295,0.78l0.745-0.375
        c0.465-0.235,1.018-0.359,1.599-0.359c2.15,0,3.9,1.766,3.9,3.937c0,0.399-0.071,0.75-0.167,1.072
        c-0.282,0.077-0.558,0.177-0.822,0.297c-1.406-1.354-3.283-2.12-5.236-2.12c-3.739,0-6.903,2.643-7.618,6.25h-2.457
        c-2.151,0-3.9-1.766-3.9-3.937s1.75-3.937,3.948-3.937h0.659l0.084-0.654C540.738,415.029,542.73,413.295,545.075,413.295
        M549.725,422.67c1.708,0,3.293,0.972,4.135,2.536l0.532,0.988l0.71-0.869c0.567-0.694,1.432-1.091,2.374-1.091
        c1.723,0,3.125,1.416,3.125,3.156c0,0.224-0.04,0.423-0.082,0.633l-0.18,0.898h0.916h0.097c2.151,0,3.9,1.766,3.9,3.937
        c0,2.171-1.75,3.938-3.9,3.938h-15.5c-2.15,0-3.9-1.767-3.9-3.938c0-1.688,1.062-3.189,2.643-3.734l0.598-0.206l-0.102-0.624
        c-0.038-0.233-0.038-0.544-0.038-0.904C545.05,424.787,547.147,422.67,549.725,422.67 M545.075,412.545
        c-2.761,0-5.037,2.051-5.377,4.688h-0.048c-2.567,0-4.65,2.099-4.65,4.687s2.083,4.687,4.65,4.687h3.1
        c0.388-3.515,3.342-6.25,6.975-6.25c1.986,0,3.827,0.879,5.086,2.295c0.484-0.293,1.017-0.488,1.55-0.586
        c0.194-0.537,0.339-1.074,0.339-1.709c0-2.587-2.083-4.687-4.65-4.687c-0.678,0-1.356,0.146-1.937,0.439
        C549.338,414.059,547.352,412.545,545.075,412.545L545.075,412.545z M549.725,421.92c-3.003,0-5.425,2.49-5.425,5.469
        c0,0.39,0,0.732,0.048,1.025c-1.84,0.635-3.148,2.393-3.148,4.443c0,2.588,2.083,4.688,4.65,4.688h15.5
        c2.567,0,4.65-2.1,4.65-4.688c0-2.587-2.083-4.687-4.65-4.687c-0.048,0-0.097,0-0.097,0c0.049-0.244,0.097-0.488,0.097-0.781
        c0-2.149-1.744-3.906-3.875-3.906c-1.211,0-2.277,0.537-2.955,1.367C553.6,423.141,551.808,421.92,549.725,421.92L549.725,421.92z
        "
              />
              <path
                fill="#005EB8"
                d="M570.075,393.295c1.898,0,3.64,1.237,4.336,3.079l0.295,0.78l0.745-0.375
        c0.465-0.235,1.018-0.359,1.599-0.359c2.15,0,3.9,1.766,3.9,3.937c0,0.399-0.071,0.75-0.167,1.072
        c-0.282,0.077-0.558,0.177-0.822,0.297c-1.406-1.354-3.283-2.12-5.236-2.12c-3.739,0-6.903,2.643-7.618,6.25h-2.457
        c-2.151,0-3.9-1.766-3.9-3.937s1.75-3.937,3.948-3.937h0.659l0.084-0.654C565.738,395.029,567.73,393.295,570.075,393.295
        M574.725,402.67c1.708,0,3.293,0.972,4.135,2.536l0.532,0.988l0.71-0.869c0.567-0.694,1.432-1.091,2.374-1.091
        c1.723,0,3.125,1.416,3.125,3.156c0,0.224-0.04,0.423-0.082,0.633l-0.18,0.898h0.916h0.097c2.151,0,3.9,1.766,3.9,3.937
        c0,2.171-1.75,3.938-3.9,3.938h-15.5c-2.15,0-3.9-1.767-3.9-3.938c0-1.688,1.062-3.189,2.643-3.734l0.598-0.206l-0.102-0.624
        c-0.038-0.233-0.038-0.544-0.038-0.904C570.05,404.787,572.147,402.67,574.725,402.67 M570.075,392.545
        c-2.761,0-5.037,2.051-5.377,4.688h-0.048c-2.567,0-4.65,2.099-4.65,4.687s2.083,4.687,4.65,4.687h3.1
        c0.388-3.515,3.342-6.25,6.975-6.25c1.986,0,3.827,0.879,5.086,2.295c0.484-0.293,1.017-0.488,1.55-0.586
        c0.194-0.537,0.339-1.074,0.339-1.709c0-2.587-2.083-4.687-4.65-4.687c-0.678,0-1.356,0.146-1.937,0.439
        C574.338,394.059,572.352,392.545,570.075,392.545L570.075,392.545z M574.725,401.92c-3.003,0-5.425,2.49-5.425,5.469
        c0,0.39,0,0.732,0.048,1.025c-1.84,0.635-3.148,2.393-3.148,4.443c0,2.588,2.083,4.688,4.65,4.688h15.5
        c2.567,0,4.65-2.1,4.65-4.688c0-2.587-2.083-4.687-4.65-4.687c-0.048,0-0.097,0-0.097,0c0.049-0.244,0.097-0.488,0.097-0.781
        c0-2.149-1.744-3.906-3.875-3.906c-1.211,0-2.277,0.537-2.955,1.367C578.6,403.141,576.808,401.92,574.725,401.92L574.725,401.92z
        "
              />
              <g>
                <g>
                  <rect x="591.086" y="634.511" fill="none" width="139.587" height="18.765" />
                </g>
                <g>
                  <rect x="591.086" y="614.511" fill="none" width="140.295" height="18.765" />
                </g>
              </g>
              <g>
                <circle fill="#121212" cx="409.236" cy="622.76" r="1.965" />
              </g>
            </g>
            <g id="d-circle_d-transportation" data-name="circle_d-transportation">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M956.856,387.297L956.856,387.297
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C896.856,414.16,923.719,387.297,956.856,387.297z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M945.356,432.984c-1.586,0-2.875-1.289-2.875-2.875v-12.938c0-1.586,1.289-2.875,2.875-2.875h12.938
          c1.586,0,2.875,1.289,2.875,2.875v1.438h2.934c0.629,0,1.227,0.274,1.635,0.755l3.535,4.124c0.338,0.391,0.521,0.889,0.521,1.401
          v6.657h0.719c0.396,0,0.719,0.323,0.719,0.719s-0.323,0.719-0.719,0.719h-2.156c0,2.381-1.932,4.312-4.312,4.312
          s-4.312-1.932-4.312-4.312h-5.75c0,2.381-1.932,4.312-4.312,4.312S945.356,435.365,945.356,432.984z M945.356,415.734
          c-0.795,0-1.438,0.643-1.438,1.438v12.938c0,0.795,0.643,1.438,1.438,1.438h0.247c0.593-1.676,2.188-2.875,4.065-2.875
          s3.477,1.199,4.065,2.875h5.997v-14.375c0-0.795-0.643-1.438-1.438-1.438H945.356z M952.544,432.984
          c0-1.027-0.548-1.977-1.438-2.49c-0.89-0.513-1.985-0.513-2.875,0c-0.89,0.514-1.438,1.463-1.438,2.49s0.548,1.977,1.438,2.49
          c0.89,0.513,1.985,0.513,2.875,0C951.996,434.961,952.544,434.012,952.544,432.984z M964.044,435.859
          c1.027,0,1.977-0.548,2.49-1.438s0.514-1.985,0-2.875s-1.463-1.438-2.49-1.438s-1.977,0.548-2.49,1.438s-0.514,1.985,0,2.875
          S963.016,435.859,964.044,435.859z M961.169,424.359h6.959l-3.482-4.061c-0.135-0.157-0.336-0.252-0.543-0.252h-2.934V424.359z
          M961.169,425.797v3.971c0.764-0.683,1.77-1.096,2.875-1.096c1.878,0,3.477,1.199,4.065,2.875h0.247v-5.75H961.169z"
                />
              </g>
            </g>
            <g id="d-circle_d-use" data-name="circle_d-use">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M816.036,387.297L816.036,387.297
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C756.036,414.16,782.899,387.297,816.036,387.297z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M816.036,422.796l10.768-1.249c0.634-0.071,1.235,0.279,1.487,0.863l1.438,3.355
          c0.44,1.028-0.157,2.205-1.249,2.457l-7.151,1.657c-0.849,0.193-1.734-0.139-2.242-0.849l-3.05-4.272l-3.05,4.264
          c-0.507,0.71-1.393,1.047-2.242,0.849l-7.151-1.648c-1.092-0.252-1.689-1.429-1.244-2.453l1.438-3.355
          c0.251-0.584,0.854-0.935,1.487-0.862L816.036,422.796z M805.102,422.981l-1.438,3.355c-0.085,0.202,0.032,0.44,0.251,0.489
          l7.156,1.649c0.283,0.062,0.575-0.045,0.746-0.283l2.924-4.097l-9.636-1.114H805.102z M826.103,429.961l1.438-0.408v3.189
          c0,0.992-0.674,1.854-1.635,2.093l-9.344,2.336c-0.346,0.086-0.705,0.086-1.046,0l-9.344-2.336
          c-0.961-0.242-1.635-1.104-1.635-2.093v-3.189l1.437,0.408v2.776c0,0.332,0.225,0.62,0.544,0.696l8.8,2.201v-6.244
          c0-0.396,0.323-0.719,0.719-0.719s0.719,0.323,0.719,0.719v6.244l8.8-2.201c0.319-0.081,0.543-0.368,0.543-0.696v-2.776H826.103z
          M808.849,420.047c0,0.396-0.323,0.719-0.719,0.719s-0.719-0.323-0.719-0.719c0-3.176,2.574-5.75,5.75-5.75s5.75,2.574,5.75,5.75
          c0,0.396-0.323,0.719-0.719,0.719s-0.719-0.323-0.719-0.719c0-2.381-1.932-4.312-4.312-4.312S808.849,417.666,808.849,420.047z
          M817.335,424.095l2.924,4.097c0.166,0.238,0.463,0.351,0.746,0.283l7.147-1.649c0.22-0.049,0.342-0.282,0.252-0.489
          l-1.438-3.355l-9.636,1.114H817.335z M822.469,420.276c-0.125,0.377-0.53,0.579-0.907,0.453s-0.58-0.53-0.454-0.907l1.438-4.312
          c0.125-0.377,0.53-0.579,0.907-0.454c0.377,0.126,0.58,0.53,0.454,0.908L822.469,420.276z"
                />
              </g>
            </g>
            <g id="d-circle_d-end" data-name="circle_d-end">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M675.731,346.321L675.731,346.321
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C615.731,373.184,642.594,346.321,675.731,346.321z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M662.793,359.177c0-0.993,0.804-1.797,1.797-1.797h22.281c0.993,0,1.797,0.804,1.797,1.797v0.719
          c0,0.912-0.678,1.662-1.559,1.779v0.018l-1.096,13.176c-0.126,1.491-1.37,2.637-2.866,2.637h-14.833
          c-1.496,0-2.74-1.146-2.866-2.637l-1.101-13.176v-0.018c-0.876-0.117-1.554-0.867-1.554-1.779V359.177z M664.59,358.818
          c-0.198,0-0.359,0.162-0.359,0.359v0.719c0,0.197,0.162,0.359,0.359,0.359h1.083h20.116h1.083c0.198,0,0.359-0.162,0.359-0.359
          v-0.719c0-0.197-0.162-0.359-0.359-0.359H664.59z M668.314,376.068h14.833c0.75,0,1.37-0.57,1.433-1.316l1.087-13.059h-19.873
          l1.087,13.059C666.944,375.493,667.569,376.068,668.314,376.068z M671.867,368.027c0.355,0.225,0.445,0.701,0.198,1.038
          l-1.24,1.68c-0.081,0.112-0.126,0.242-0.126,0.377c0,0.351,0.283,0.634,0.633,0.634h2.96c0.396,0,0.719,0.323,0.719,0.719
          s-0.323,0.719-0.719,0.719h-2.96c-1.146,0-2.071-0.926-2.071-2.071c0-0.444,0.144-0.876,0.404-1.23l1.235-1.676
          c0.225-0.306,0.643-0.382,0.961-0.184L671.867,368.027z M675.165,364.855l-1.393,1.892c-0.225,0.306-0.643,0.382-0.961,0.185
          c-0.355-0.225-0.445-0.701-0.198-1.038l1.393-1.892c0.404-0.548,1.042-0.871,1.725-0.871s1.321,0.323,1.725,0.871l1.393,1.892
          c0.247,0.337,0.157,0.817-0.198,1.038c-0.319,0.197-0.737,0.116-0.961-0.185l-1.393-1.892c-0.13-0.18-0.341-0.287-0.566-0.287
          S675.3,364.675,675.165,364.855z M677.168,371.755h2.956c0.35,0,0.633-0.283,0.633-0.634c0-0.135-0.041-0.27-0.122-0.377
          l-1.24-1.68c-0.247-0.337-0.157-0.818,0.198-1.038c0.319-0.197,0.737-0.117,0.961,0.185l1.24,1.68
          c0.265,0.359,0.404,0.791,0.404,1.23c0,1.146-0.925,2.071-2.071,2.071h-2.96c-0.396,0-0.719-0.323-0.719-0.719
          S676.773,371.755,677.168,371.755z"
                />
              </g>
            </g>
            <g id="d-circle_d-processing" data-name="circle_d-processing">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M756.036,235.573L756.036,235.573
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C696.036,262.436,722.899,235.573,756.036,235.573z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M769.692,253.779c0.396,0,0.719,0.323,0.719,0.719s-0.323,0.719-0.719,0.719h-8.625
          c-1.19,0-2.156,0.966-2.156,2.156v13.437l1.608-0.437l0.022-0.004c0.597-2.107,2.538-3.652,4.838-3.652
          c2.781,0,5.031,2.251,5.031,5.031s-2.25,5.031-5.031,5.031c-2.727,0-4.946-2.165-5.027-4.869l-17.785,4.842
          c-0.382,0.108-0.772-0.121-0.88-0.503s0.122-0.777,0.503-0.88l15.3-4.174c-0.009-0.054-0.018-0.107-0.018-0.166v-13.656
          c0-1.985,1.608-3.594,3.594-3.594H769.692z M750.659,259.489c0.768-0.207,1.554,0.247,1.761,1.015l1.855,6.945
          c0.207,0.768-0.247,1.554-1.016,1.761l-6.94,1.859c-0.768,0.207-1.554-0.247-1.761-1.015l-1.86-6.945
          c-0.207-0.768,0.247-1.554,1.015-1.761L750.659,259.489z M745.475,262.364l-1.388,0.372l1.86,6.945l6.945-1.859l-1.86-6.94
          l-1.388,0.372l0.651,2.431c0.153,0.575-0.188,1.168-0.764,1.32l-2.084,0.558c-0.575,0.152-1.168-0.188-1.321-0.764l-0.651-2.431
          V262.364z M746.868,261.995l0.557,2.085l1.388-0.373l-0.562-2.084l-1.388,0.372H746.868z M762.268,269.951
          c-0.642,1.112-0.642,2.481,0,3.594s1.829,1.797,3.112,1.797s2.47-0.685,3.112-1.797s0.642-2.481,0-3.594
          s-1.829-1.797-3.112-1.797S762.91,268.839,762.268,269.951z"
                />
              </g>
            </g>
            <g id="d-circle_d-franchises" data-name="circle_d-franchises">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M888.978,267.632L888.978,267.632
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C828.978,294.495,855.841,267.632,888.978,267.632z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M874.603,312.479c0-0.288,0.072-0.57,0.211-0.822l3.49-6.401c0.378-0.691,1.102-1.123,1.892-1.123h17.564
          c0.79,0,1.514,0.432,1.892,1.123l3.49,6.396c0.139,0.252,0.211,0.535,0.211,0.822c0,0.948-0.768,1.716-1.716,1.716h-1.159v12.224
          c0,0.396-0.323,0.719-0.719,0.719s-0.719-0.323-0.719-0.719v-12.219h-20.125v5.75h11.5v-3.594v-0.719h1.438v0.719v8.625
          c0,1.19-0.966,2.156-2.156,2.156h-10.062c-1.19,0-2.156-0.966-2.156-2.156v-10.781h-1.159
          C875.371,314.195,874.603,313.426,874.603,312.479z M878.197,312.757h21.562h1.878c0.152,0,0.278-0.126,0.278-0.278
          c0-0.045-0.014-0.095-0.036-0.135l-3.485-6.401c-0.126-0.229-0.369-0.373-0.629-0.373h-17.564c-0.266,0-0.504,0.144-0.629,0.373
          l-3.495,6.401c-0.022,0.04-0.036,0.085-0.036,0.135c0,0.152,0.126,0.278,0.278,0.278H878.197z M878.916,324.976
          c0,0.396,0.323,0.719,0.719,0.719h10.062c0.396,0,0.719-0.323,0.719-0.719v-3.594h-11.5V324.976z"
                />
              </g>
            </g>
            <g id="d-circle_d-leased" data-name="circle_d-leased">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M851.147,135.029L851.147,135.029
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C791.147,161.891,818.01,135.029,851.147,135.029z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M853.662,175.685c1.388,0,2.516,1.128,2.516,2.516c0,0.387-0.085,0.75-0.243,1.078h0.251l4.254-2.533
          c0.377-0.225,0.799-0.342,1.235-0.342h0.058c1.298,0,2.35,1.051,2.35,2.35c0,0.795-0.404,1.536-1.074,1.968l-5.373,3.494
          c-0.813,0.53-1.766,0.813-2.74,0.813h-15.97c-0.396,0-0.719-0.323-0.719-0.719s0.323-0.719,0.719-0.719h15.97
          c0.696,0,1.375-0.202,1.958-0.579l5.377-3.495c0.256-0.166,0.413-0.454,0.413-0.764c0-0.503-0.409-0.912-0.912-0.912h-0.058
          c-0.175,0-0.346,0.045-0.499,0.135l-4.425,2.633c-0.112,0.067-0.238,0.103-0.369,0.103h-2.722h-1.078h-2.875
          c-0.396,0-0.719-0.323-0.719-0.719c0-0.395,0.323-0.719,0.719-0.719h2.875h1.078c0.598,0,1.078-0.48,1.078-1.078
          c0-0.597-0.48-1.078-1.078-1.078h-6.675c-0.427,0-0.84,0.126-1.195,0.364l-3.589,2.395c-0.122,0.081-0.256,0.121-0.4,0.121
          h-2.875c-0.396,0-0.719-0.323-0.719-0.719s0.323-0.719,0.719-0.719h2.659l3.405-2.273c0.593-0.391,1.285-0.602,1.995-0.602
          H853.662z M854.021,162.029h3.594c1.19,0,2.156,0.966,2.156,2.156v7.188c0,1.19-0.966,2.156-2.156,2.156h-12.938
          c-1.19,0-2.156-0.966-2.156-2.156v-7.188c0-1.19,0.966-2.156,2.156-2.156h3.594H854.021z M844.678,163.466
          c-0.396,0-0.719,0.323-0.719,0.719v7.188c0,0.396,0.323,0.719,0.719,0.719h12.938c0.396,0,0.719-0.323,0.719-0.719v-7.188
          c0-0.396-0.323-0.719-0.719-0.719h-2.875v4.312c0,0.247-0.13,0.48-0.341,0.611c-0.211,0.13-0.476,0.144-0.701,0.031l-2.552-1.276
          l-2.552,1.276c-0.225,0.112-0.489,0.099-0.701-0.031c-0.211-0.131-0.341-0.364-0.341-0.611v-4.312H844.678z M848.99,166.615
          l1.837-0.917c0.202-0.104,0.44-0.104,0.642,0l1.833,0.917v-3.149h-4.312V166.615z"
                />
              </g>
            </g>
            <g id="d-circle_d-investments" data-name="circle_d-investments">
              <path
                id="d-circle"
                data-name="circle"
                fill="#A1E6BD"
                d="M701.75,113.529L701.75,113.529
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C641.75,140.391,668.613,113.529,701.75,113.529z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M713.061,150.396c0.265,0.292,0.247,0.75-0.05,1.016l-7.906,7.188c-0.283,0.256-0.719,0.247-0.993-0.022
          l-5.31-5.314l-7.412,5.386c-0.319,0.234-0.773,0.162-1.006-0.157c-0.233-0.318-0.162-0.772,0.157-1.006l7.906-5.75
          c0.288-0.207,0.683-0.175,0.93,0.072l5.27,5.269l7.398-6.725c0.292-0.265,0.75-0.247,1.016,0.05V150.396z M693.125,163.1
          c1.19,0,2.156,0.966,2.156,2.156v2.875c0,1.19-0.966,2.156-2.156,2.156s-2.156-0.966-2.156-2.156v-2.875
          C690.969,164.065,691.935,163.1,693.125,163.1z M693.844,168.131v-2.875c0-0.396-0.323-0.719-0.719-0.719
          s-0.719,0.323-0.719,0.719v2.875c0,0.396,0.323,0.719,0.719,0.719S693.844,168.526,693.844,168.131z M696.719,160.943
          c0-1.19,0.966-2.156,2.156-2.156s2.156,0.966,2.156,2.156v7.188c0,1.19-0.966,2.156-2.156,2.156s-2.156-0.966-2.156-2.156
          V160.943z M699.594,160.943c0-0.396-0.323-0.719-0.719-0.719s-0.719,0.323-0.719,0.719v7.188c0,0.396,0.323,0.719,0.719,0.719
          s0.719-0.323,0.719-0.719V160.943z M704.625,161.662c1.19,0,2.156,0.966,2.156,2.156v4.312c0,1.19-0.966,2.156-2.156,2.156
          s-2.156-0.966-2.156-2.156v-4.312C702.469,162.628,703.435,161.662,704.625,161.662z M705.344,168.131v-4.312
          c0-0.396-0.323-0.719-0.719-0.719s-0.719,0.323-0.719,0.719v4.312c0,0.396,0.323,0.719,0.719,0.719
          S705.344,168.526,705.344,168.131z M708.219,160.943c0-1.19,0.966-2.156,2.156-2.156s2.156,0.966,2.156,2.156v7.188
          c0,1.19-0.966,2.156-2.156,2.156s-2.156-0.966-2.156-2.156V160.943z M711.094,160.943c0-0.396-0.323-0.719-0.719-0.719
          s-0.719,0.323-0.719,0.719v7.188c0,0.396,0.323,0.719,0.719,0.719s0.719-0.323,0.719-0.719V160.943z"
                />
              </g>
            </g>
            <g id="u-circle_u-fuel" data-name="circle_u-fuel">
              <path
                id="u-circle"
                data-name="circle"
                fill="#BFC9FF"
                d="M251.246,267.632L251.246,267.632
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C191.246,294.495,218.108,267.632,251.246,267.632z"
              />
              <g id="icon:svg" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M254.966,285.415c0.207-0.185,0.472-0.283,0.746-0.283c0.772,0,1.312,0.769,1.051,1.496l-3.06,8.566
          h4.955c0.669,0,1.213,0.544,1.213,1.213c0,0.351-0.148,0.679-0.409,0.912l-11.94,10.534c-0.202,0.18-0.467,0.278-0.741,0.278
          c-0.772,0-1.312-0.769-1.056-1.496l3.064-8.566h-5.009c-0.638,0-1.159-0.521-1.159-1.159c0-0.332,0.144-0.646,0.391-0.867
          L254.966,285.415z M254.988,287.32l-10.476,9.312h5.296c0.233,0,0.454,0.112,0.588,0.306s0.167,0.436,0.09,0.655l-2.987,8.365
          l10.566-9.326h-5.382c-0.233,0-0.454-0.112-0.588-0.306s-0.167-0.436-0.09-0.655l2.983-8.355V287.32z"
                />
              </g>
            </g>
            <g id="u-circle_u-transportation" data-name="circle_u-transportation">
              <path
                id="u-circle-2"
                data-name="circle"
                fill="#BFC9FF"
                d="M183.144,387.297L183.144,387.297
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C123.144,414.16,150.007,387.297,183.144,387.297z"
              />
              <g id="icon:svg-2" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M171.644,432.984c-1.586,0-2.875-1.289-2.875-2.875l0-12.938c0-1.586,1.289-2.875,2.875-2.875h12.938
          c1.586,0,2.875,1.289,2.875,2.875v1.438h2.934c0.629,0,1.226,0.274,1.635,0.755l3.536,4.124c0.337,0.391,0.521,0.889,0.521,1.401
          v6.657h0.719c0.396,0,0.719,0.323,0.719,0.719s-0.323,0.719-0.719,0.719h-2.156c0,2.381-1.932,4.312-4.312,4.312
          s-4.312-1.932-4.312-4.312h-5.75c0,2.381-1.932,4.312-4.312,4.312S171.644,435.365,171.644,432.984z M171.644,415.734
          c-0.795,0-1.438,0.643-1.438,1.438l0,12.938c0,0.795,0.643,1.438,1.438,1.438h0.247c0.593-1.676,2.188-2.875,4.065-2.875
          s3.477,1.199,4.065,2.875h5.997l0-14.375c0-0.795-0.643-1.438-1.438-1.438H171.644z M178.831,432.984
          c0-1.027-0.548-1.977-1.438-2.49c-0.89-0.513-1.985-0.513-2.875,0c-0.89,0.514-1.438,1.463-1.438,2.49s0.548,1.977,1.438,2.49
          c0.89,0.513,1.985,0.513,2.875,0C178.284,434.961,178.831,434.012,178.831,432.984z M187.456,424.359h6.958l-3.481-4.061
          c-0.135-0.157-0.337-0.252-0.543-0.252h-2.934L187.456,424.359z M187.456,425.797v3.971c0.764-0.683,1.77-1.096,2.875-1.096
          c1.878,0,3.477,1.199,4.065,2.875h0.247v-5.75H187.456z M190.331,435.859c1.027,0,1.976-0.548,2.49-1.438s0.514-1.985,0-2.875
          s-1.462-1.438-2.49-1.438s-1.976,0.548-2.49,1.438s-0.514,1.985,0,2.875S189.304,435.859,190.331,435.859z"
                />
              </g>
            </g>
            <g id="u-circle_u-operational" data-name="circle_u-operational">
              <path
                id="u-circle-3"
                data-name="circle"
                fill="#BFC9FF"
                d="M323.964,387.297L323.964,387.297
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C263.964,414.16,290.827,387.297,323.964,387.297z"
              />
              <g id="icon:svg-3" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M327.873,415.313l1.164,1.859h2.116h1.438h0.719c0.396,0,0.719,0.323,0.719,0.719
          s-0.323,0.719-0.719,0.719h-0.719v15.094c0,1.985-1.608,3.594-3.594,3.594h-10.062c-1.985,0-3.594-1.608-3.594-3.594v-15.094
          h-0.719c-0.396,0-0.719-0.323-0.719-0.719s0.323-0.719,0.719-0.719h0.719h1.438h2.116l1.164-1.859
          c0.396-0.634,1.087-1.016,1.828-1.016h4.155c0.746,0,1.433,0.382,1.829,1.016H327.873z M316.777,418.609v15.094
          c0,1.19,0.966,2.156,2.156,2.156h10.062c1.19,0,2.156-0.966,2.156-2.156v-15.094H316.777z M320.371,422.203v10.062
          c0,0.396-0.323,0.719-0.719,0.719s-0.719-0.323-0.719-0.719v-10.062c0-0.396,0.323-0.719,0.719-0.719
          S320.371,421.808,320.371,422.203z M321.278,416.071l-0.687,1.101h6.747l-0.687-1.101c-0.13-0.211-0.364-0.337-0.611-0.337
          h-4.155c-0.247,0-0.476,0.126-0.611,0.337H321.278z M324.683,422.203v10.062c0,0.396-0.323,0.719-0.719,0.719
          s-0.719-0.323-0.719-0.719v-10.062c0-0.396,0.323-0.719,0.719-0.719S324.683,421.808,324.683,422.203z M328.996,422.203v10.062
          c0,0.396-0.323,0.719-0.719,0.719s-0.719-0.323-0.719-0.719v-10.062c0-0.396,0.323-0.719,0.719-0.719
          S328.996,421.808,328.996,422.203z"
                />
              </g>
            </g>
            <g id="u-circle_u-leased" data-name="circle_u-leased">
              <path
                id="u-circle-4"
                data-name="circle"
                fill="#BFC9FF"
                d="M464.784,346.321L464.784,346.321
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C404.784,373.184,431.647,346.321,464.784,346.321z"
              />
              <g id="icon:svg-4" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M467.299,386.977c1.388,0,2.516,1.128,2.516,2.516c0,0.387-0.085,0.75-0.243,1.078h0.251l4.254-2.533
          c0.377-0.225,0.799-0.342,1.235-0.342h0.058c1.298,0,2.35,1.051,2.35,2.35c0,0.795-0.404,1.536-1.074,1.968l-5.373,3.494
          c-0.813,0.53-1.766,0.813-2.74,0.813l-15.97,0c-0.396,0-0.719-0.323-0.719-0.719s0.323-0.719,0.719-0.719h15.97
          c0.696,0,1.375-0.202,1.958-0.579l5.377-3.495c0.256-0.166,0.413-0.454,0.413-0.764c0-0.503-0.409-0.912-0.912-0.912h-0.058
          c-0.175,0-0.346,0.045-0.499,0.135l-4.425,2.633c-0.112,0.067-0.238,0.103-0.369,0.103h-2.722h-1.078h-2.875
          c-0.396,0-0.719-0.323-0.719-0.719c0-0.395,0.323-0.719,0.719-0.719h2.875h1.078c0.598,0,1.078-0.48,1.078-1.078
          c0-0.597-0.48-1.078-1.078-1.078h-6.675c-0.427,0-0.84,0.126-1.195,0.364l-3.589,2.395c-0.122,0.081-0.256,0.121-0.4,0.121
          l-2.875,0c-0.396,0-0.719-0.323-0.719-0.719s0.323-0.719,0.719-0.719l2.659,0l3.405-2.273c0.593-0.391,1.285-0.602,1.995-0.602
          H467.299z M467.658,373.321h3.594c1.19,0,2.156,0.966,2.156,2.156v7.188c0,1.19-0.966,2.156-2.156,2.156h-12.938
          c-1.19,0-2.156-0.966-2.156-2.156v-7.188c0-1.19,0.966-2.156,2.156-2.156h3.594H467.658z M458.315,374.759
          c-0.396,0-0.719,0.323-0.719,0.719v7.188c0,0.396,0.323,0.719,0.719,0.719h12.938c0.396,0,0.719-0.323,0.719-0.719v-7.188
          c0-0.396-0.323-0.719-0.719-0.719h-2.875v4.312c0,0.247-0.13,0.48-0.341,0.611c-0.211,0.13-0.476,0.144-0.701,0.031l-2.552-1.276
          l-2.552,1.276c-0.225,0.112-0.489,0.099-0.701-0.031c-0.211-0.131-0.341-0.364-0.341-0.611v-4.312H458.315z M462.627,377.908
          l1.837-0.917c0.202-0.104,0.44-0.104,0.642,0l1.833,0.917v-3.149h-4.312V377.908z"
                />
              </g>
            </g>
            <g id="u-circle_u-capital" data-name="circle_u-capital">
              <path
                id="u-circle-5"
                data-name="circle"
                fill="#BFC9FF"
                d="M383.964,235.573L383.964,235.573
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C323.964,262.436,350.827,235.573,383.964,235.573z"
              />
              <g id="icon:svg-5" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M372.464,271.917c0-0.688,0.386-1.244,0.872-1.662c0.49-0.422,1.154-0.769,1.918-1.042
          c1.527-0.562,3.589-0.89,5.835-0.89s4.308,0.328,5.835,0.885c0.759,0.278,1.428,0.625,1.918,1.042
          c0.49,0.418,0.872,0.979,0.872,1.662v4.672v5.117c0,0.691-0.368,1.267-0.858,1.707s-1.155,0.804-1.918,1.096
          c-1.532,0.589-3.603,0.935-5.849,0.935s-4.317-0.346-5.844-0.93c-0.764-0.292-1.429-0.656-1.918-1.097
          c-0.489-0.439-0.862-1.015-0.862-1.707v-5.116V271.917z M373.901,271.917c0,0.107,0.059,0.306,0.373,0.575
          c0.31,0.265,0.799,0.539,1.473,0.781c1.33,0.485,3.221,0.8,5.341,0.8s4.012-0.314,5.346-0.8c0.669-0.242,1.159-0.517,1.474-0.781
          c0.314-0.27,0.373-0.468,0.373-0.575s-0.058-0.306-0.373-0.575c-0.31-0.265-0.8-0.539-1.474-0.781
          c-1.334-0.485-3.226-0.8-5.346-0.8s-4.012,0.314-5.346,0.8c-0.669,0.242-1.159,0.517-1.474,0.781
          c-0.314,0.27-0.373,0.468-0.373,0.575H373.901z M388.276,273.988c-0.396,0.242-0.854,0.453-1.352,0.633
          c-1.527,0.562-3.589,0.89-5.835,0.89s-4.308-0.328-5.835-0.885c-0.499-0.18-0.957-0.391-1.352-0.634v2.597
          c0,0.14,0.072,0.359,0.382,0.638s0.8,0.566,1.469,0.817c1.334,0.508,3.217,0.836,5.337,0.836s4.002-0.328,5.337-0.836
          c0.669-0.256,1.159-0.539,1.469-0.817s0.382-0.498,0.382-0.638V273.988z M373.901,281.705c0,0.14,0.072,0.359,0.382,0.639
          c0.31,0.278,0.8,0.565,1.469,0.817c1.334,0.508,3.217,0.84,5.337,0.84s4.002-0.328,5.337-0.836
          c0.669-0.256,1.159-0.539,1.469-0.817s0.382-0.498,0.382-0.638v-2.979c-0.391,0.252-0.845,0.472-1.343,0.66
          c-1.527,0.584-3.598,0.926-5.844,0.926s-4.317-0.346-5.844-0.93c-0.494-0.188-0.948-0.409-1.343-0.66v2.974V281.705z
          M379.651,266.167c0,0.107,0.059,0.306,0.373,0.575c0.062,0.054,0.13,0.107,0.207,0.161c-0.692,0.027-1.366,0.086-2.017,0.176
          v-0.912c0-0.688,0.386-1.244,0.872-1.662c0.49-0.422,1.154-0.769,1.918-1.042c1.527-0.562,3.589-0.89,5.835-0.89
          s4.308,0.328,5.835,0.885c0.759,0.278,1.428,0.625,1.918,1.042c0.485,0.423,0.872,0.979,0.872,1.667v4.672v5.116
          c0,0.692-0.368,1.268-0.858,1.707c-0.49,0.44-1.155,0.805-1.918,1.097c-0.467,0.175-0.979,0.332-1.532,0.463v-1.482
          c0.369-0.1,0.71-0.207,1.024-0.324c0.669-0.256,1.159-0.539,1.469-0.817s0.382-0.498,0.382-0.638v-2.979
          c-0.391,0.252-0.844,0.472-1.343,0.66c-0.467,0.176-0.979,0.333-1.532,0.463v-1.482c0.369-0.099,0.71-0.206,1.024-0.323
          c0.669-0.256,1.159-0.539,1.469-0.817s0.382-0.499,0.382-0.638v-2.605c-0.395,0.242-0.854,0.453-1.352,0.633
          c-0.777,0.283-1.689,0.508-2.695,0.656c-0.085-0.086-0.171-0.171-0.256-0.247c-0.454-0.409-0.975-0.737-1.519-1.011
          c1.563-0.104,2.938-0.378,3.976-0.755c0.669-0.242,1.159-0.517,1.474-0.781c0.314-0.27,0.373-0.468,0.373-0.575
          c0-0.108-0.058-0.306-0.373-0.575c-0.31-0.265-0.8-0.539-1.474-0.781c-1.334-0.477-3.226-0.791-5.346-0.791
          s-4.012,0.314-5.346,0.8c-0.669,0.242-1.159,0.517-1.474,0.781c-0.314,0.27-0.373,0.468-0.373,0.575H379.651z"
                />
              </g>
            </g>
            <g id="u-circle_u-employee" data-name="circle_u-employee">
              <path
                id="u-circle-6"
                data-name="circle"
                fill="#BFC9FF"
                d="M528.573,218.497L528.573,218.497
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C468.573,245.36,495.436,218.497,528.573,218.497z"
              />
              <g id="icon:svg-6" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M534.323,245.498c2.381,0,4.312,1.932,4.312,4.312v11.5c0,2.066-1.456,3.791-3.396,4.214l1.748,1.747
          c0.278,0.278,0.278,0.737,0,1.016c-0.279,0.278-0.737,0.278-1.016,0l-2.664-2.664h-9.47l-2.664,2.664
          c-0.279,0.278-0.737,0.278-1.016,0c-0.278-0.278-0.278-0.737,0-1.016l1.748-1.747c-1.94-0.423-3.396-2.147-3.396-4.214v-11.5
          c0-2.381,1.932-4.312,4.312-4.312H534.323z M522.823,246.935c-1.586,0-2.875,1.289-2.875,2.875v5.75h17.25v-5.75
          c0-1.586-1.289-2.875-2.875-2.875H522.823z M522.823,264.185h11.5c1.586,0,2.875-1.289,2.875-2.875v-4.312h-17.25v4.312
          C519.948,262.896,521.238,264.185,522.823,264.185z M527.136,260.591c0-0.794,0.644-1.438,1.438-1.438s1.438,0.644,1.438,1.438
          s-0.644,1.438-1.438,1.438S527.136,261.385,527.136,260.591z"
                />
              </g>
            </g>
            <g id="u-circle_u-business" data-name="circle_u-business">
              <path
                id="u-circle-7"
                data-name="circle"
                fill="#BFC9FF"
                d="M288.853,135.029L288.853,135.029
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C228.853,161.891,255.716,135.029,288.853,135.029z"
              />
              <g id="icon:svg-7" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M301.193,171.965c0.342,0.427,0.598,0.957,0.598,1.563c0,1.208-0.97,2.116-1.878,2.659
          c-0.948,0.57-2.125,0.935-3.05,0.935h-4.51l-3.899,6.819c-0.382,0.674-1.101,1.087-1.873,1.087h-2.525
          c-0.957,0-1.644-0.912-1.383-1.833l1.738-6.073h-2.385l-1.725,2.3c-0.27,0.364-0.696,0.575-1.15,0.575h-1.887
          c-0.746,0-1.348-0.602-1.348-1.348c0-0.126,0.018-0.252,0.054-0.368l1.357-4.753l-1.357-4.748
          c-0.036-0.121-0.054-0.247-0.054-0.373c0-0.746,0.602-1.348,1.348-1.348h1.887c0.454,0,0.88,0.211,1.15,0.575l1.725,2.3h2.385
          l-1.738-6.073c-0.261-0.921,0.431-1.833,1.383-1.833h2.525c0.772,0,1.487,0.413,1.873,1.087l3.899,6.819h4.51
          c0.93,0,2.106,0.377,3.055,0.952C300.398,171.179,300.852,171.538,301.193,171.965z M299.172,172.114
          c-0.777-0.472-1.702-0.746-2.304-0.746h-4.933c-0.256,0-0.494-0.139-0.625-0.363l-4.105-7.174l0.624-0.355l-0.624,0.355
          c-0.126-0.225-0.369-0.364-0.625-0.364h-2.525l1.999,6.99c0.063,0.215,0.018,0.449-0.117,0.629s-0.35,0.287-0.575,0.287h-3.697
          c-0.225,0-0.44-0.107-0.575-0.287l-1.94-2.588h-1.77l1.384,4.834c0.036,0.13,0.036,0.265,0,0.395l-1.384,4.834h1.77l1.94-2.588
          c0.135-0.18,0.351-0.287,0.575-0.287h3.697c0.225,0,0.44,0.107,0.575,0.287s0.18,0.414,0.117,0.629l-1.999,6.99h2.525
          c0.256,0,0.494-0.14,0.625-0.364l4.105-7.183c0.13-0.225,0.369-0.364,0.625-0.364h4.928c0.611,0,1.536-0.265,2.309-0.728
          c0.813-0.485,1.182-1.015,1.182-1.424c0-0.185-0.076-0.404-0.283-0.665C299.863,172.603,299.553,172.347,299.172,172.114z"
                />
              </g>
            </g>
            <g id="u-circle_u-purchased" data-name="circle_u-purchased">
              <path
                id="u-circle-8"
                data-name="circle"
                fill="#BFC9FF"
                d="M440.419,113.529L440.419,113.529
        c33.137,0,60,26.863,60,60l0,0c0,33.137-26.863,60-60,60l0,0c-33.137,0-60-26.863-60-60l0,0
        C380.419,140.391,407.282,113.529,440.419,113.529z"
              />
              <g id="icon:svg-8" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M428.919,140.372c0-3.571,5.148-6.469,11.5-6.469c6.352,0,11.5,2.897,11.5,6.469v1.438l0,3.594
          c0,3.176-5.148,5.75-11.5,5.75c-6.352,0-11.5-2.574-11.5-5.75l0-3.594V140.372z M440.419,145.404
          c2.974,0,5.597-0.683,7.426-1.712c1.873-1.051,2.637-2.281,2.637-3.319s-0.764-2.269-2.637-3.319
          c-1.829-1.029-4.452-1.712-7.426-1.712s-5.597,0.683-7.426,1.712c-1.873,1.051-2.637,2.281-2.637,3.319s0.764,2.269,2.637,3.319
          C434.822,144.721,437.445,145.404,440.419,145.404z M430.356,143.508l0,1.896c0,0.579,0.382,1.343,1.438,2.103v-2.857
          c-0.548-0.351-1.033-0.732-1.437-1.146V143.508z M449.044,140.193c0,0.691-0.368,1.271-0.854,1.721
          c-0.49,0.444-1.154,0.817-1.918,1.109c-1.532,0.593-3.603,0.943-5.849,0.943s-4.317-0.351-5.849-0.943
          c-0.764-0.297-1.433-0.665-1.918-1.109c-0.489-0.445-0.854-1.029-0.854-1.721s0.369-1.271,0.854-1.721
          c0.49-0.444,1.155-0.817,1.918-1.109c1.532-0.593,3.603-0.943,5.849-0.943s4.317,0.351,5.849,0.943
          c0.764,0.297,1.433,0.665,1.918,1.109C448.68,138.917,449.044,139.501,449.044,140.193z M440.419,137.857
          c-2.116,0-4.002,0.332-5.332,0.845c-0.665,0.256-1.159,0.548-1.469,0.831c-0.31,0.287-0.386,0.508-0.386,0.66
          s0.076,0.373,0.386,0.66c0.31,0.283,0.8,0.575,1.469,0.831c1.33,0.513,3.216,0.845,5.332,0.845s4.002-0.332,5.332-0.845
          c0.665-0.256,1.159-0.548,1.469-0.831s0.386-0.508,0.386-0.66s-0.076-0.373-0.386-0.66c-0.31-0.283-0.8-0.575-1.469-0.831
          C444.421,138.189,442.534,137.857,440.419,137.857z M435.387,146.19c-0.772-0.211-1.491-0.472-2.156-0.769v2.907
          c0.638,0.292,1.361,0.552,2.156,0.764V146.19z M436.825,146.518v2.889c0.898,0.161,1.864,0.26,2.875,0.296v-2.875
          C438.703,146.791,437.737,146.689,436.825,146.518z M441.137,146.832v2.875c1.011-0.031,1.977-0.135,2.875-0.297v-2.889
          C443.1,146.693,442.134,146.796,441.137,146.832z M445.45,146.19v2.902c0.795-0.212,1.519-0.472,2.156-0.764v-2.907
          C446.941,145.723,446.222,145.979,445.45,146.19z M450.481,143.508c-0.404,0.413-0.89,0.795-1.438,1.146v2.856
          c1.056-0.759,1.438-1.527,1.438-2.102l0-1.896V143.508z"
                />
              </g>
            </g>
          </g>
        </svg>

        <div class="viz-scope-3-header">
          <div
            id="g-ai0-1"
            class="g-bg g-aiAbs"
            style="top: 4.769%; left: 50.0055%; margin-left: -10.8333%; width: 21.6667%"
          >
            <p class="g-pstyle0">Scope 3</p>
          </div>
          <div
            id="g-ai0-2"
            class="g-bg g-aiAbs"
            style="top: 9.0909%; left: 50.1222%; margin-left: -15.7018%; width: 31.4035%"
          >
            <p class="g-pstyle1">
              Indirect emissions from the value chain typically make up 90% of a company&rsquo;s emissions
            </p>
          </div>
        </div>

        <div class="viz-scrope-3-bubbles upstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-purchased')"
            @mouseover="handleMouseover('u-purchased')"
            @mouseleave="handleMouseleave"
            style="top: 16.96%; left: 33.35%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-purchased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Purchased goods & services</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-business')"
            @mouseover="handleMouseover('u-business')"
            @mouseleave="handleMouseleave"
            style="top: 20.2%; left: 20.1%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-business"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Business travel</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-fuel')"
            @mouseover="handleMouseover('u-fuel')"
            @mouseleave="handleMouseleave"
            style="top: 40%; left: 16.75%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-fuel"
          >
            <div class="g-aiAbs circle-label" style="width: 85%">
              <p class="g-pstyle2">Fuel & energy-related activities</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-capital')"
            @mouseover="handleMouseover('u-capital')"
            @mouseleave="handleMouseleave"
            style="top: 35.2%; left: 28.4%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-capital"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Capital goods</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-employee')"
            @mouseover="handleMouseover('u-employee')"
            @mouseleave="handleMouseleave"
            style="top: 32.7%; left: 41.1%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-employee"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Employee commuting</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-leased')"
            @mouseover="handleMouseover('u-leased')"
            @mouseleave="handleMouseleave"
            style="top: 51.6%; left: 35.5%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-leased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-operational')"
            @mouseover="handleMouseover('u-operational')"
            @mouseleave="handleMouseleave"
            style="top: 57.7%; left: 23.2%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-operational"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Operational waste</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-transportation')"
            @mouseover="handleMouseover('u-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 57.7%; left: 10.9%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-transportation"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Transportation & distribution</p>
            </div>
          </div>
        </div>

        <div class="viz-scrope-3-bubbles downstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-investments')"
            @mouseover="handleMouseover('d-investments')"
            @mouseleave="handleMouseleave"
            style="top: 16.96%; left: 56.3%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-investments"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Investments</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-leased')"
            @mouseover="handleMouseover('d-leased')"
            @mouseleave="handleMouseleave"
            style="top: 20.2%; left: 69.35%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-leased"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-processing')"
            @mouseover="handleMouseover('d-processing')"
            @mouseleave="handleMouseleave"
            style="top: 35.14%; left: 61.05%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-processing"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Processing of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-franchises')"
            @mouseover="handleMouseover('d-franchises')"
            @mouseleave="handleMouseleave"
            style="top: 39.95%; left: 72.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-franchises"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 85%">
              <p class="g-pstyle2">Franchises</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-use')"
            @mouseover="handleMouseover('d-use')"
            @mouseleave="handleMouseleave"
            style="top: 57.7%; left: 66.3%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-use"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Use of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-transportation')"
            @mouseover="handleMouseover('d-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 57.75%; left: 78.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-transportation"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Transportation & distribution</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-end')"
            @mouseover="handleMouseover('d-end')"
            @mouseleave="handleMouseleave"
            style="top: 52%; left: 54%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-end"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 75%">
              <p class="g-pstyle2">End-of-life treatment of sold products</p>
            </div>
          </div>
        </div>

        <div class="viz-scope-3-footer">
          <div
            id="g-ai0-18"
            class="g-bg g-aiAbs"
            style="top: 76.4531%; left: 50.0072%; margin-left: -13.7719%; width: 27.5439%"
          >
            <p class="g-pstyle3">Reporting company</p>
          </div>
          <div
            id="g-ai0-19"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 82.341%; margin-top: -11.5px; left: 75.1754%; width: 124px"
          >
            <p class="g-pstyle4">Downstream</p>
          </div>
          <div
            id="g-ai0-20"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 83.8313%; margin-top: -11.5px; left: 16.3862%; width: 101px"
          >
            <p class="g-pstyle4">Upstream</p>
          </div>
          <div id="g-ai0-21" class="g-bg g-aiAbs" style="top: 83.3085%; left: 38.9836%; width: 24.8772%">
            <p class="g-pstyle5">Scope 2</p>
          </div>
          <div id="g-ai0-22" class="g-bg g-aiAbs" style="top: 83.3085%; left: 55.0801%; width: 25.8772%">
            <p class="g-pstyle5">Scope 1</p>
          </div>
          <div
            id="g-ai0-23"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 86.2716%; margin-top: -10.9px; left: 72.4009%; width: 188px"
          >
            <p class="g-pstyle6">&bull; Distribution & storage</p>
          </div>
          <div
            id="g-ai0-24"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 87.7619%; margin-top: -10.9px; left: 15.0735%; width: 131px"
          >
            <p class="g-pstyle6">&bull; Raw materials</p>
          </div>
          <div
            id="g-ai0-25"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 89.2522%; margin-top: -10.9px; left: 72.3977%; width: 143px"
          >
            <p class="g-pstyle6">&bull; Use of products</p>
          </div>
          <div id="g-ai0-26" class="g-bg g-aiAbs" style="top: 87.6304%; left: 36.0273%; width: 30.7544%">
            <p class="g-pstyle7">Indirect emissions</p>
          </div>
          <div id="g-ai0-27" class="g-bg g-aiAbs" style="top: 87.6304%; left: 52.7168%; width: 16.614%">
            <p class="g-pstyle7">Direct emissions</p>
          </div>
          <div
            id="g-ai0-28"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 90.7425%; margin-top: -10.9px; left: 14.8294%; width: 136px"
          >
            <p class="g-pstyle6">&bull; Pre-processing</p>
          </div>
          <div
            id="g-ai0-29"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 92.2328%; margin-top: -10.9px; left: 72.4006%; width: 104px"
          >
            <p class="g-pstyle6">&bull; End-of-life</p>
          </div>
          <div id="g-ai0-30" class="g-bg g-aiAbs" style="top: 91.3562%; left: 51.8496%; width: 12.2807%">
            <p class="g-pstyle8">&bull; Company facilities</p>
          </div>
          <div
            id="g-ai0-31"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 92.978%; margin-top: -10.9px; left: 36.9474%; width: 149px"
          >
            <p class="g-pstyle6">Purchased energy</p>
          </div>
          <div id="g-ai0-32" class="g-bg g-aiAbs" style="top: 94.3368%; left: 51.8496%; width: 12.2807%">
            <p class="g-pstyle8">&bull; Company vehicles</p>
          </div>
        </div>
      </div>

      <!-- Artboard: _720px -->
      <div
        id="g-UOB-2023-2-_720px"
        class="g-artboard"
        style="width: 720px; height: 646px"
        data-aspect-ratio="1.115"
        data-min-width="720"
        data-max-width="1138"
      >
        <svg
          class="g-UOB-2-_720px-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-2-_720px-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 720 646"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g id="bg-720px" data-name="bg-720px">
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M530.751,641.778c96.257-60.301,160.623-169.904,160.623-295.116
                c0-190.236-148.57-344.452-331.84-344.452S27.695,156.427,27.695,346.662c0,125.212,64.366,234.815,160.623,295.116H530.751z"
              />
              <path fill="#A1E6BD" d="M479.248,526.231h182.67l33.202,49.247l-33.202,49.247h-182.67v-49.247V526.231z" />
              <path fill="#BFC9FF" d="M240.221,526.427H58.022l-33.143,49.247l33.143,49.247h182.199v-49.247V526.427z" />

              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M528.085,645.011c-0.432-92.945-75.903-168.16-168.95-168.16
                s-168.518,75.215-168.95,168.16H528.085z"
              />

              <path
                fill="#005EB8"
                d="M334.711,467.872c0-1.61,1.336-3.032,3.053-3.032h6.107c1.622,0,3.052,1.421,3.052,3.032v14.399
                l14.883-8.052c1.526-0.758,3.434,0.284,3.434,2.084v5.968l14.883-8.052c1.526-0.758,3.434,0.284,3.434,2.084v14.305v12.125
                c0,2.558-2.099,4.548-4.58,4.548H339.29c-2.576,0-4.58-1.989-4.58-4.548v-7.578v-4.547V467.872z M356.845,491.365
                c-0.859,0-1.527,0.758-1.527,1.516v4.547c0,0.853,0.668,1.516,1.527,1.516h4.579c0.763,0,1.527-0.663,1.527-1.516v-4.547
                c0-0.758-0.764-1.516-1.527-1.516H356.845z M343.106,492.881v4.547c0,0.853,0.668,1.516,1.527,1.516h4.579
                c0.763,0,1.527-0.663,1.527-1.516v-4.547c0-0.758-0.764-1.516-1.527-1.516h-4.579
                C343.774,491.365,343.106,492.123,343.106,492.881z M369.056,491.365c-0.859,0-1.527,0.758-1.527,1.516v4.547
                c0,0.853,0.668,1.516,1.527,1.516h4.579c0.763,0,1.527-0.663,1.527-1.516v-4.547c0-0.758-0.764-1.516-1.527-1.516H369.056z"
              />
              <g>
                <g>
                  <rect x="380.778" y="618.949" fill="none" width="122.231" height="15.026" />
                </g>
                <g>
                  <rect x="380.778" y="600.141" fill="none" width="122.231" height="15.026" />
                </g>
              </g>
              <path
                fill="#005EB8"
                d="M339.976,439.165c1.458,0,2.797,0.952,3.333,2.369l0.295,0.78l0.744-0.375
                c0.352-0.177,0.771-0.271,1.213-0.271c1.64,0,2.974,1.347,2.974,3.003c0,0.27-0.044,0.513-0.105,0.738
                c-0.172,0.051-0.342,0.112-0.507,0.182c-1.145-1.068-2.655-1.67-4.223-1.67c-3.024,0-5.59,2.109-6.221,5.005h-1.846
                c-1.64,0-2.974-1.347-2.974-3.003s1.334-3.003,3.012-3.003h0.659l0.084-0.654C336.642,440.497,338.173,439.165,339.976,439.165
                M343.699,446.672c1.313,0,2.531,0.748,3.179,1.952l0.532,0.988l0.71-0.869c0.425-0.521,1.076-0.819,1.785-0.819
                c1.297,0,2.353,1.067,2.353,2.378c0,0.164-0.029,0.31-0.063,0.478l-0.18,0.898h0.916h0.078c1.64,0,2.974,1.347,2.974,3.003
                c0,1.656-1.334,3.004-2.974,3.004h-12.412c-1.64,0-2.974-1.348-2.974-3.004c0-1.288,0.81-2.433,2.016-2.849l0.598-0.206
                l-0.102-0.624c-0.029-0.174-0.029-0.418-0.029-0.699C340.105,448.3,341.718,446.672,343.699,446.672 M339.976,438.415
                c-2.211,0-4.033,1.642-4.306,3.754h-0.038c-2.056,0-3.724,1.681-3.724,3.753c0,2.072,1.668,3.753,3.724,3.753h2.482
                c0.311-2.815,2.676-5.005,5.585-5.005c1.59,0,3.065,0.704,4.073,1.838c0.388-0.235,0.814-0.391,1.241-0.469
                c0.155-0.43,0.271-0.86,0.271-1.368c0-2.072-1.668-3.753-3.724-3.753c-0.543,0-1.086,0.117-1.551,0.351
                C343.39,439.627,341.799,438.415,339.976,438.415L339.976,438.415z M343.699,445.922c-2.405,0-4.344,1.994-4.344,4.379
                c0,0.312,0,0.586,0.038,0.821c-1.473,0.509-2.521,1.916-2.521,3.558c0,2.072,1.668,3.754,3.724,3.754h12.412
                c2.056,0,3.724-1.682,3.724-3.754c0-2.072-1.668-3.753-3.724-3.753c-0.038,0-0.078,0-0.078,0c0.039-0.195,0.078-0.391,0.078-0.625
                c0-1.721-1.397-3.128-3.103-3.128c-0.97,0-1.823,0.43-2.366,1.095C346.802,446.9,345.367,445.922,343.699,445.922L343.699,445.922
                z"
              />
              <path
                fill="#005EB8"
                d="M359.995,423.15c1.458,0,2.797,0.952,3.333,2.369l0.295,0.78l0.745-0.376
                c0.352-0.177,0.771-0.271,1.213-0.271c1.64,0,2.974,1.347,2.974,3.003c0,0.27-0.043,0.513-0.105,0.738
                c-0.172,0.051-0.342,0.112-0.507,0.182c-1.145-1.067-2.655-1.67-4.223-1.67c-3.024,0-5.59,2.109-6.221,5.005h-1.846
                c-1.64,0-2.974-1.347-2.974-3.003s1.334-3.003,3.012-3.003h0.659l0.084-0.654C356.661,424.482,358.192,423.15,359.995,423.15
                M363.719,430.657c1.313,0,2.531,0.748,3.179,1.952l0.532,0.988l0.71-0.869c0.425-0.521,1.076-0.819,1.785-0.819
                c1.297,0,2.353,1.067,2.353,2.378c0,0.164-0.029,0.31-0.063,0.478l-0.18,0.898h0.916h0.078c1.64,0,2.974,1.347,2.974,3.003
                c0,1.656-1.334,3.004-2.974,3.004h-12.412c-1.64,0-2.974-1.348-2.974-3.004c0-1.288,0.81-2.433,2.016-2.849l0.598-0.206
                l-0.102-0.624c-0.029-0.174-0.029-0.418-0.029-0.699C360.124,432.285,361.737,430.657,363.719,430.657 M359.995,422.4
                c-2.211,0-4.033,1.642-4.306,3.754h-0.038c-2.056,0-3.724,1.681-3.724,3.753s1.668,3.753,3.724,3.753h2.482
                c0.311-2.815,2.676-5.005,5.585-5.005c1.59,0,3.065,0.704,4.073,1.838c0.388-0.234,0.814-0.391,1.241-0.469
                c0.155-0.43,0.271-0.86,0.271-1.368c0-2.072-1.668-3.753-3.724-3.753c-0.543,0-1.086,0.117-1.551,0.352
                C363.409,423.612,361.818,422.4,359.995,422.4L359.995,422.4z M363.719,429.907c-2.405,0-4.344,1.994-4.344,4.379
                c0,0.312,0,0.586,0.038,0.821c-1.473,0.509-2.521,1.916-2.521,3.558c0,2.072,1.668,3.754,3.724,3.754h12.412
                c2.056,0,3.724-1.682,3.724-3.754c0-2.072-1.668-3.753-3.724-3.753c-0.038,0-0.078,0-0.078,0c0.039-0.195,0.078-0.391,0.078-0.625
                c0-1.721-1.397-3.128-3.103-3.128c-0.97,0-1.823,0.43-2.366,1.095C366.821,430.884,365.387,429.907,363.719,429.907
                L363.719,429.907z"
              />
              <line fill="none" stroke="#A7A8A9" stroke-dasharray="2,2" x1="360" y1="553.724" x2="360" y2="628.996" />
            </g>
            <g id="d-circle_d-transportation-2" data-name="circle_d-transportation">
              <path
                id="d-circle-8"
                data-name="circle"
                fill="#A1E6BD"
                d="M623.241,330.95L623.241,330.95
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C570.391,354.612,594.053,330.95,623.241,330.95z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M613.112,367.696c-1.397,0-2.532-1.135-2.532-2.532v-11.396c0-1.397,1.135-2.532,2.532-2.532h11.396
                  c1.397,0,2.532,1.135,2.532,2.532v1.266h2.584c0.554,0,1.08,0.242,1.44,0.665l3.114,3.633c0.298,0.344,0.459,0.783,0.459,1.234
                  v5.864h0.633c0.348,0,0.633,0.285,0.633,0.633c0,0.348-0.285,0.633-0.633,0.633h-1.899c0,2.097-1.701,3.799-3.799,3.799
                  s-3.799-1.701-3.799-3.799h-5.065c0,2.097-1.701,3.799-3.799,3.799S613.112,369.793,613.112,367.696z M613.112,352.502
                  c-0.7,0-1.266,0.566-1.266,1.266v11.396c0,0.7,0.566,1.266,1.266,1.266h0.218c0.522-1.476,1.927-2.532,3.581-2.532
                  s3.062,1.056,3.581,2.532h5.282v-12.662c0-0.7-0.566-1.266-1.266-1.266H613.112z M619.443,367.696
                  c0-0.905-0.483-1.741-1.266-2.193c-0.784-0.452-1.749-0.452-2.532,0c-0.784,0.452-1.266,1.289-1.266,2.193
                  c0,0.905,0.483,1.741,1.266,2.193c0.784,0.452,1.749,0.452,2.532,0C618.96,369.437,619.443,368.601,619.443,367.696z
                  M629.572,370.228c0.905,0,1.741-0.483,2.193-1.266s0.452-1.749,0-2.532s-1.289-1.266-2.193-1.266s-1.741,0.483-2.193,1.266
                  s-0.452,1.749,0,2.532S628.667,370.228,629.572,370.228z M627.04,360.099h6.13l-3.068-3.577
                  c-0.119-0.138-0.296-0.222-0.478-0.222h-2.584V360.099z M627.04,361.365v3.498c0.673-0.601,1.559-0.965,2.532-0.965
                  c1.654,0,3.062,1.056,3.581,2.532h0.218v-5.065H627.04z"
                />
              </g>
            </g>
            <g id="d-circle_d-use-2" data-name="circle_d-use">
              <path
                id="d-circle-9"
                data-name="circle"
                fill="#A1E6BD"
                d="M539.273,407.442L539.273,407.442
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C486.422,431.104,510.084,407.442,539.273,407.442z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M539.273,436.903l9.484-1.1c0.558-0.063,1.088,0.246,1.31,0.76l1.266,2.956
                  c0.388,0.906-0.138,1.942-1.1,2.164l-6.299,1.46c-0.748,0.17-1.528-0.122-1.975-0.748l-2.687-3.763l-2.687,3.756
                  c-0.447,0.625-1.227,0.922-1.975,0.747l-6.299-1.452c-0.962-0.222-1.488-1.258-1.096-2.161l1.266-2.956
                  c0.221-0.514,0.752-0.823,1.31-0.76L539.273,436.903z M529.641,437.066l-1.266,2.956c-0.075,0.178,0.028,0.388,0.221,0.431
                  l6.303,1.453c0.249,0.055,0.507-0.04,0.657-0.249l2.576-3.609l-8.487-0.981H529.641z M548.14,443.214l1.266-0.36v2.809
                  c0,0.874-0.594,1.634-1.44,1.843l-8.23,2.058c-0.305,0.076-0.621,0.076-0.922,0l-8.23-2.058c-0.847-0.213-1.44-0.973-1.44-1.843
                  v-2.809l1.266,0.36v2.446c0,0.292,0.198,0.546,0.479,0.613l7.752,1.939v-5.5c0-0.348,0.285-0.633,0.633-0.633
                  s0.633,0.285,0.633,0.633v5.5l7.752-1.939c0.281-0.071,0.479-0.324,0.479-0.613v-2.446H548.14z M532.942,434.482
                  c0,0.348-0.285,0.633-0.633,0.633s-0.633-0.285-0.633-0.633c0-2.797,2.267-5.065,5.065-5.065s5.065,2.267,5.065,5.065
                  c0,0.348-0.285,0.633-0.633,0.633s-0.633-0.285-0.633-0.633c0-2.097-1.701-3.799-3.799-3.799S532.942,432.384,532.942,434.482z
                  M540.416,438.047l2.576,3.609c0.146,0.21,0.408,0.309,0.657,0.249l6.295-1.453c0.194-0.043,0.301-0.249,0.222-0.431
                  l-1.266-2.956l-8.487,0.981H540.416z M544.939,434.684c-0.111,0.332-0.467,0.51-0.799,0.399c-0.333-0.111-0.511-0.467-0.4-0.799
                  l1.266-3.799c0.111-0.332,0.467-0.51,0.799-0.4c0.333,0.111,0.511,0.467,0.4,0.8L544.939,434.684z"
                />
              </g>
            </g>
            <g id="d-circle_d-end-2" data-name="circle_d-end">
              <path
                id="d-circle-10"
                data-name="circle"
                fill="#A1E6BD"
                d="M437.109,354.591L437.109,354.591
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C384.259,378.253,407.921,354.591,437.109,354.591z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M425.713,365.915c0-0.875,0.708-1.583,1.583-1.583h19.626c0.874,0,1.583,0.708,1.583,1.583v0.633
                  c0,0.803-0.597,1.464-1.373,1.567v0.015l-0.966,11.606c-0.111,1.314-1.207,2.323-2.525,2.323h-13.065
                  c-1.318,0-2.414-1.009-2.525-2.323l-0.969-11.606v-0.015c-0.772-0.103-1.369-0.764-1.369-1.567V365.915z M427.296,365.599
                  c-0.174,0-0.317,0.143-0.317,0.317v0.633c0,0.174,0.142,0.317,0.317,0.317h0.954h17.719h0.954c0.174,0,0.317-0.143,0.317-0.317
                  v-0.633c0-0.174-0.142-0.317-0.317-0.317H427.296z M430.576,380.793h13.065c0.661,0,1.207-0.502,1.262-1.16l0.957-11.503h-17.505
                  l0.957,11.503C429.369,380.287,429.919,380.793,430.576,380.793z M433.706,373.711c0.313,0.198,0.392,0.618,0.174,0.914
                  l-1.092,1.48c-0.071,0.099-0.111,0.213-0.111,0.332c0,0.309,0.249,0.558,0.558,0.558h2.608c0.348,0,0.633,0.285,0.633,0.633
                  c0,0.348-0.285,0.633-0.633,0.633h-2.608c-1.009,0-1.824-0.815-1.824-1.824c0-0.391,0.126-0.772,0.356-1.084l1.088-1.476
                  c0.198-0.269,0.566-0.336,0.847-0.162L433.706,373.711z M436.61,370.917l-1.227,1.666c-0.198,0.269-0.566,0.336-0.847,0.163
                  c-0.313-0.198-0.392-0.618-0.174-0.914l1.227-1.666c0.356-0.483,0.918-0.767,1.52-0.767c0.601,0,1.163,0.285,1.52,0.767
                  l1.227,1.666c0.218,0.297,0.138,0.72-0.174,0.914c-0.281,0.174-0.649,0.102-0.847-0.163l-1.227-1.666
                  c-0.115-0.158-0.301-0.253-0.498-0.253S436.729,370.758,436.61,370.917z M438.375,376.995h2.604c0.308,0,0.558-0.249,0.558-0.558
                  c0-0.119-0.036-0.237-0.107-0.332l-1.092-1.48c-0.218-0.297-0.138-0.721,0.174-0.914c0.281-0.174,0.649-0.103,0.847,0.163
                  l1.092,1.48c0.234,0.317,0.356,0.697,0.356,1.084c0,1.009-0.815,1.824-1.824,1.824h-2.608c-0.348,0-0.633-0.285-0.633-0.633
                  C437.742,377.28,438.027,376.995,438.375,376.995z"
                />
              </g>
            </g>
            <g id="d-circle_d-processing-2" data-name="circle_d-processing">
              <path
                id="d-circle-11"
                data-name="circle"
                fill="#A1E6BD"
                d="M525.697,272.12L525.697,272.12
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C472.847,295.782,496.509,272.12,525.697,272.12z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M537.726,284.991c0.348,0,0.633,0.285,0.633,0.633c0,0.348-0.285,0.633-0.633,0.633h-7.597
                  c-1.049,0-1.899,0.851-1.899,1.899v11.835l1.417-0.385l0.02-0.003c0.526-1.856,2.236-3.217,4.261-3.217
                  c2.449,0,4.432,1.983,4.432,4.432s-1.982,4.432-4.432,4.432c-2.402,0-4.356-1.907-4.428-4.289l-15.665,4.265
                  c-0.336,0.095-0.68-0.107-0.775-0.443s0.107-0.685,0.443-0.775l13.477-3.676c-0.008-0.047-0.016-0.095-0.016-0.146v-12.029
                  c0-1.749,1.417-3.165,3.165-3.165H537.726z M520.961,290.021c0.677-0.182,1.369,0.218,1.551,0.894l1.634,6.118
                  c0.182,0.676-0.218,1.369-0.895,1.551l-6.113,1.638c-0.677,0.182-1.369-0.218-1.551-0.894l-1.638-6.118
                  c-0.182-0.676,0.218-1.369,0.894-1.551L520.961,290.021z M516.394,292.553l-1.223,0.328l1.638,6.118l6.117-1.638l-1.638-6.113
                  l-1.223,0.328l0.574,2.141c0.135,0.507-0.166,1.029-0.673,1.163l-1.836,0.491c-0.507,0.134-1.029-0.166-1.163-0.673l-0.574-2.141
                  V292.553z M517.621,292.228l0.491,1.837l1.222-0.329l-0.495-1.836l-1.222,0.328H517.621z M531.186,299.236
                  c-0.566,0.98-0.566,2.186,0,3.166c0.566,0.98,1.611,1.583,2.741,1.583s2.176-0.603,2.741-1.583c0.566-0.98,0.566-2.186,0-3.166
                  c-0.566-0.98-1.611-1.583-2.741-1.583S531.751,298.256,531.186,299.236z"
                />
              </g>
            </g>
            <g id="d-circle_d-franchises-2" data-name="circle_d-franchises">
              <path
                id="d-circle-12"
                data-name="circle"
                fill="#A1E6BD"
                d="M621.424,208.15L621.424,208.15
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C568.573,231.812,592.235,208.15,621.424,208.15z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M608.762,247.653c0-0.254,0.064-0.502,0.186-0.724l3.074-5.639c0.333-0.609,0.97-0.989,1.666-0.989
                  h15.471c0.696,0,1.333,0.38,1.666,0.989l3.074,5.634c0.122,0.222,0.186,0.471,0.186,0.724c0,0.835-0.676,1.511-1.511,1.511
                  h-1.021v10.767c0,0.348-0.285,0.633-0.633,0.633s-0.633-0.285-0.633-0.633v-10.763H612.56v5.065h10.13v-3.166v-0.633h1.266v0.633
                  v7.597c0,1.049-0.851,1.899-1.899,1.899h-8.863c-1.049,0-1.899-0.851-1.899-1.899v-9.497h-1.021
                  C609.438,249.164,608.762,248.487,608.762,247.653z M611.927,247.898h18.993h1.654c0.134,0,0.245-0.111,0.245-0.245
                  c0-0.04-0.012-0.083-0.032-0.119l-3.07-5.639c-0.111-0.202-0.325-0.329-0.554-0.329h-15.471c-0.234,0-0.444,0.126-0.554,0.329
                  l-3.079,5.639c-0.02,0.035-0.032,0.075-0.032,0.119c0,0.134,0.111,0.245,0.245,0.245H611.927z M612.56,258.66
                  c0,0.348,0.285,0.633,0.633,0.633h8.863c0.348,0,0.633-0.285,0.633-0.633v-3.166h-10.13V258.66z"
                />
              </g>
            </g>
            <g id="d-circle_d-leased-2" data-name="circle_d-leased">
              <path
                id="d-circle-13"
                data-name="circle"
                fill="#A1E6BD"
                d="M517.334,158.792L517.334,158.792
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C464.483,182.454,488.145,158.792,517.334,158.792z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M519.549,194.603c1.223,0,2.216,0.994,2.216,2.216c0,0.341-0.075,0.661-0.214,0.95h0.221l3.747-2.231
                  c0.332-0.198,0.704-0.301,1.088-0.301h0.051c1.144,0,2.07,0.926,2.07,2.07c0,0.7-0.356,1.353-0.946,1.733l-4.732,3.078
                  c-0.716,0.467-1.555,0.717-2.414,0.717h-14.067c-0.348,0-0.633-0.285-0.633-0.633s0.285-0.633,0.633-0.633h14.067
                  c0.613,0,1.211-0.178,1.725-0.51l4.737-3.079c0.225-0.146,0.364-0.4,0.364-0.673c0-0.443-0.36-0.803-0.803-0.803h-0.051
                  c-0.154,0-0.305,0.04-0.439,0.119l-3.898,2.319c-0.099,0.059-0.21,0.09-0.325,0.09h-2.398h-0.95h-2.532
                  c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h2.532h0.95c0.526,0,0.95-0.423,0.95-0.95
                  c0-0.526-0.423-0.95-0.95-0.95h-5.88c-0.376,0-0.74,0.111-1.052,0.321l-3.162,2.109c-0.107,0.071-0.226,0.107-0.352,0.107h-2.532
                  c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h2.342l3-2.003c0.522-0.344,1.132-0.53,1.757-0.53H519.549z
                  M519.866,182.574h3.165c1.049,0,1.899,0.851,1.899,1.899v6.331c0,1.049-0.851,1.899-1.899,1.899h-11.396
                  c-1.049,0-1.899-0.851-1.899-1.899v-6.331c0-1.049,0.851-1.899,1.899-1.899h3.166H519.866z M511.635,183.841
                  c-0.348,0-0.633,0.285-0.633,0.633v6.331c0,0.348,0.285,0.633,0.633,0.633h11.396c0.348,0,0.633-0.285,0.633-0.633v-6.331
                  c0-0.348-0.285-0.633-0.633-0.633h-2.532v3.799c0,0.218-0.115,0.423-0.301,0.538c-0.186,0.114-0.419,0.126-0.617,0.028
                  l-2.248-1.124l-2.248,1.124c-0.198,0.099-0.431,0.087-0.617-0.028c-0.186-0.115-0.301-0.321-0.301-0.538v-3.799H511.635z
                  M515.434,186.615l1.618-0.808c0.178-0.091,0.388-0.091,0.566,0l1.615,0.808v-2.774h-3.799V186.615z"
                />
              </g>
            </g>
            <g id="d-circle_d-investments-2" data-name="circle_d-investments">
              <path
                id="d-circle-14"
                data-name="circle"
                fill="#A1E6BD"
                d="M414.497,240.429L414.497,240.429
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C361.647,264.091,385.308,240.429,414.497,240.429z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M424.46,269.302c0.233,0.257,0.218,0.661-0.044,0.895l-6.964,6.331c-0.249,0.225-0.633,0.218-0.874-0.02
                  l-4.677-4.681l-6.529,4.744c-0.281,0.206-0.681,0.143-0.886-0.138c-0.206-0.28-0.142-0.68,0.138-0.886l6.964-5.065
                  c0.253-0.182,0.601-0.154,0.819,0.064l4.642,4.641l6.517-5.923c0.257-0.233,0.661-0.218,0.895,0.044V269.302z M406.9,280.493
                  c1.049,0,1.899,0.851,1.899,1.899v2.532c0,1.049-0.851,1.899-1.899,1.899S405,285.973,405,284.924v-2.532
                  C405,281.343,405.851,280.493,406.9,280.493z M407.533,284.924v-2.532c0-0.348-0.285-0.633-0.633-0.633
                  c-0.348,0-0.633,0.285-0.633,0.633v2.532c0,0.348,0.285,0.633,0.633,0.633C407.248,285.557,407.533,285.273,407.533,284.924z
                  M410.065,278.593c0-1.049,0.851-1.899,1.899-1.899s1.899,0.851,1.899,1.899v6.331c0,1.049-0.851,1.899-1.899,1.899
                  s-1.899-0.851-1.899-1.899V278.593z M412.598,278.593c0-0.348-0.285-0.633-0.633-0.633s-0.633,0.285-0.633,0.633v6.331
                  c0,0.348,0.285,0.633,0.633,0.633s0.633-0.285,0.633-0.633V278.593z M417.029,279.226c1.049,0,1.899,0.851,1.899,1.899v3.799
                  c0,1.049-0.851,1.899-1.899,1.899s-1.899-0.851-1.899-1.899v-3.799C415.13,280.077,415.981,279.226,417.029,279.226z
                  M417.662,284.924v-3.799c0-0.348-0.285-0.633-0.633-0.633s-0.633,0.285-0.633,0.633v3.799c0,0.348,0.285,0.633,0.633,0.633
                  S417.662,285.273,417.662,284.924z M420.195,278.593c0-1.049,0.851-1.899,1.899-1.899s1.899,0.851,1.899,1.899v6.331
                  c0,1.049-0.851,1.899-1.899,1.899s-1.899-0.851-1.899-1.899V278.593z M422.727,278.593c0-0.348-0.285-0.633-0.633-0.633
                  s-0.633,0.285-0.633,0.633v6.331c0,0.348,0.285,0.633,0.633,0.633s0.633-0.285,0.633-0.633V278.593z"
                />
              </g>
            </g>
            <g id="u-circle_u-fuel-2" data-name="circle_u-fuel">
              <path
                id="u-circle-9"
                data-name="circle"
                fill="#BFC9FF"
                d="M98.164,208.15L98.164,208.15
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C45.314,231.812,68.975,208.15,98.164,208.15z"
              />
              <g id="icon:svg-9" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M101.441,216.113c0.182-0.163,0.415-0.249,0.657-0.249c0.68,0,1.155,0.677,0.926,1.318l-2.695,7.546
                  h4.365c0.59,0,1.068,0.479,1.068,1.068c0,0.309-0.131,0.598-0.36,0.803l-10.518,9.279c-0.178,0.158-0.412,0.245-0.653,0.245
                  c-0.68,0-1.155-0.677-0.93-1.318L96,227.26h-4.412c-0.562,0-1.021-0.459-1.021-1.021c0-0.292,0.126-0.569,0.344-0.764
                  L101.441,216.113z M101.461,217.791l-9.228,8.203h4.665c0.206,0,0.4,0.099,0.518,0.269s0.147,0.384,0.079,0.577l-2.631,7.368
                  l9.307-8.215H99.43c-0.206,0-0.4-0.099-0.518-0.269c-0.119-0.17-0.147-0.384-0.079-0.577l2.627-7.36V217.791z"
                />
              </g>
            </g>
            <g id="u-circle_u-transportation-2" data-name="circle_u-transportation">
              <path
                id="u-circle-10"
                data-name="circle"
                fill="#BFC9FF"
                d="M95.433,330.95L95.433,330.95
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C42.583,354.612,66.245,330.95,95.433,330.95z"
              />
              <g id="icon:svg-10" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M85.303,368.127c-1.397,0-2.532-1.135-2.532-2.532v-11.396c0-1.397,1.135-2.532,2.532-2.532h11.396
                  c1.397,0,2.532,1.135,2.532,2.532v1.266h2.584c0.554,0,1.08,0.242,1.44,0.665l3.114,3.633c0.297,0.344,0.459,0.783,0.459,1.234
                  v5.864h0.633c0.348,0,0.633,0.285,0.633,0.633c0,0.348-0.285,0.633-0.633,0.633h-1.899c0,2.097-1.701,3.799-3.799,3.799
                  s-3.799-1.701-3.799-3.799h-5.065c0,2.097-1.701,3.799-3.799,3.799C87.005,371.926,85.303,370.224,85.303,368.127z
                  M85.303,352.932c-0.7,0-1.266,0.566-1.266,1.266v11.396c0,0.7,0.566,1.266,1.266,1.266h0.218
                  c0.522-1.476,1.927-2.532,3.581-2.532s3.063,1.056,3.581,2.532h5.282v-12.662c0-0.7-0.566-1.266-1.266-1.266H85.303z
                  M91.634,368.127c0-0.905-0.483-1.741-1.266-2.193c-0.784-0.452-1.749-0.452-2.532,0c-0.784,0.452-1.266,1.289-1.266,2.193
                  c0,0.905,0.483,1.741,1.266,2.194c0.784,0.452,1.749,0.452,2.532,0C91.152,369.868,91.634,369.032,91.634,368.127z
                  M99.232,360.53h6.129l-3.067-3.577c-0.119-0.138-0.297-0.222-0.479-0.222h-2.584V360.53z M99.232,361.796v3.498
                  c0.673-0.601,1.559-0.965,2.532-0.965c1.654,0,3.063,1.056,3.581,2.532h0.218v-5.065H99.232z M101.764,370.659
                  c0.905,0,1.741-0.483,2.193-1.266s0.452-1.749,0-2.532s-1.288-1.266-2.193-1.266s-1.741,0.483-2.193,1.266s-0.452,1.749,0,2.532
                  S100.859,370.659,101.764,370.659z"
                />
              </g>
            </g>
            <g id="u-circle_u-operational-2" data-name="circle_u-operational">
              <path
                id="u-circle-11"
                data-name="circle"
                fill="#BFC9FF"
                d="M181.025,407.442L181.025,407.442
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C128.174,431.104,151.836,407.442,181.025,407.442z"
              />
              <g id="icon:svg-11" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M184.468,429.658l1.025,1.638h1.864h1.266h0.633c0.348,0,0.633,0.285,0.633,0.633
                  c0,0.348-0.285,0.633-0.633,0.633h-0.633v13.295c0,1.749-1.417,3.165-3.166,3.165h-8.863c-1.749,0-3.166-1.417-3.166-3.165
                  v-13.295h-0.633c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h0.633h1.266h1.864l1.025-1.638
                  c0.348-0.558,0.957-0.895,1.61-0.895h3.66c0.657,0,1.262,0.336,1.611,0.895H184.468z M174.694,432.562v13.295
                  c0,1.049,0.851,1.899,1.899,1.899h8.863c1.049,0,1.899-0.851,1.899-1.899v-13.295H174.694z M177.86,435.727v8.863
                  c0,0.348-0.285,0.633-0.633,0.633s-0.633-0.285-0.633-0.633v-8.863c0-0.348,0.285-0.633,0.633-0.633
                  S177.86,435.379,177.86,435.727z M178.659,430.326l-0.605,0.969h5.943l-0.605-0.969c-0.115-0.186-0.321-0.297-0.538-0.297h-3.66
                  c-0.218,0-0.419,0.111-0.538,0.297H178.659z M181.658,435.727v8.863c0,0.348-0.285,0.633-0.633,0.633s-0.633-0.285-0.633-0.633
                  v-8.863c0-0.348,0.285-0.633,0.633-0.633S181.658,435.379,181.658,435.727z M185.457,435.727v8.863
                  c0,0.348-0.285,0.633-0.633,0.633c-0.348,0-0.633-0.285-0.633-0.633v-8.863c0-0.348,0.285-0.633,0.633-0.633
                  C185.172,435.094,185.457,435.379,185.457,435.727z"
                />
              </g>
            </g>
            <g id="u-circle_u-leadsed-2" data-name="circle_u-leased">
              <path
                id="u-circle-12"
                data-name="circle"
                fill="#BFC9FF"
                d="M282.54,354.591L282.54,354.591
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C229.69,378.253,253.352,354.591,282.54,354.591z"
              />
              <g id="icon:svg-12" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M284.756,388.919c1.223,0,2.216,0.993,2.216,2.216c0,0.341-0.075,0.661-0.214,0.95h0.222l3.747-2.231
                  c0.332-0.198,0.704-0.301,1.088-0.301h0.051c1.144,0,2.07,0.926,2.07,2.07c0,0.7-0.356,1.353-0.946,1.733l-4.732,3.078
                  c-0.716,0.467-1.555,0.717-2.414,0.717h-14.067c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h14.067
                  c0.613,0,1.211-0.178,1.725-0.51l4.737-3.079c0.225-0.146,0.364-0.4,0.364-0.673c0-0.443-0.36-0.803-0.803-0.803h-0.051
                  c-0.154,0-0.305,0.04-0.439,0.119l-3.898,2.319c-0.099,0.059-0.21,0.09-0.325,0.09h-2.398h-0.95h-2.532
                  c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h2.532h0.95c0.526,0,0.95-0.423,0.95-0.95
                  c0-0.526-0.423-0.95-0.95-0.95h-5.88c-0.376,0-0.74,0.111-1.052,0.321l-3.162,2.109c-0.107,0.071-0.226,0.107-0.352,0.107h-2.532
                  c-0.348,0-0.633-0.285-0.633-0.633c0-0.348,0.285-0.633,0.633-0.633h2.342l2.999-2.003c0.522-0.344,1.132-0.53,1.757-0.53
                  H284.756z M285.072,376.89h3.166c1.049,0,1.899,0.851,1.899,1.899v6.331c0,1.049-0.851,1.899-1.899,1.899h-11.396
                  c-1.049,0-1.899-0.851-1.899-1.899v-6.331c0-1.049,0.851-1.899,1.899-1.899h3.165H285.072z M276.842,378.156
                  c-0.348,0-0.633,0.285-0.633,0.633v6.331c0,0.348,0.285,0.633,0.633,0.633h11.396c0.348,0,0.633-0.285,0.633-0.633v-6.331
                  c0-0.348-0.285-0.633-0.633-0.633h-2.532v3.799c0,0.218-0.115,0.423-0.301,0.538c-0.186,0.114-0.419,0.126-0.617,0.028
                  l-2.248-1.124l-2.248,1.124c-0.198,0.099-0.431,0.087-0.617-0.028c-0.186-0.115-0.301-0.321-0.301-0.538v-3.799H276.842z
                  M280.64,380.93l1.618-0.808c0.178-0.091,0.388-0.091,0.566,0l1.615,0.808v-2.774h-3.799V380.93z"
                />
              </g>
            </g>
            <g id="u-circle_u-capital-2" data-name="circle_u-capital">
              <path
                id="u-circle-13"
                data-name="circle"
                fill="#BFC9FF"
                d="M194.492,272.12L194.492,272.12
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C141.642,295.782,165.303,272.12,194.492,272.12z"
              />
              <g id="icon:svg-13" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M184.362,304.133c0-0.606,0.34-1.096,0.768-1.464c0.431-0.372,1.017-0.677,1.689-0.918
                  c1.345-0.495,3.162-0.784,5.14-0.784c1.978,0,3.795,0.289,5.14,0.779c0.669,0.245,1.258,0.551,1.689,0.918
                  c0.431,0.368,0.768,0.863,0.768,1.464v4.115v4.507c0,0.609-0.324,1.116-0.756,1.504c-0.431,0.388-1.017,0.708-1.69,0.965
                  c-1.349,0.519-3.173,0.823-5.152,0.823c-1.978,0-3.802-0.305-5.148-0.819c-0.673-0.257-1.258-0.578-1.69-0.966
                  c-0.431-0.387-0.76-0.894-0.76-1.504v-4.507V304.133z M185.628,304.133c0,0.095,0.052,0.269,0.329,0.507
                  c0.273,0.233,0.704,0.475,1.298,0.688c1.171,0.428,2.837,0.704,4.705,0.704s3.534-0.277,4.709-0.704
                  c0.59-0.213,1.021-0.455,1.298-0.688c0.277-0.237,0.328-0.412,0.328-0.507c0-0.095-0.051-0.269-0.328-0.507
                  c-0.273-0.233-0.704-0.475-1.298-0.688c-1.175-0.428-2.841-0.704-4.709-0.704s-3.534,0.277-4.709,0.704
                  c-0.59,0.213-1.021,0.455-1.298,0.688c-0.277,0.237-0.328,0.412-0.328,0.507H185.628z M198.29,305.958
                  c-0.348,0.213-0.752,0.399-1.191,0.557c-1.345,0.495-3.162,0.784-5.14,0.784c-1.978,0-3.795-0.289-5.14-0.779
                  c-0.439-0.158-0.843-0.344-1.191-0.558v2.287c0,0.123,0.063,0.317,0.336,0.562c0.273,0.245,0.704,0.499,1.294,0.72
                  c1.175,0.447,2.833,0.736,4.701,0.736s3.526-0.289,4.701-0.736c0.589-0.225,1.021-0.475,1.294-0.72
                  c0.273-0.245,0.336-0.439,0.336-0.562V305.958z M185.628,312.755c0,0.123,0.063,0.317,0.336,0.563
                  c0.273,0.245,0.704,0.498,1.294,0.72c1.175,0.447,2.833,0.74,4.701,0.74s3.526-0.289,4.701-0.736
                  c0.589-0.225,1.021-0.475,1.294-0.72s0.336-0.439,0.336-0.562v-2.624c-0.344,0.222-0.744,0.415-1.183,0.582
                  c-1.345,0.514-3.169,0.815-5.148,0.815c-1.978,0-3.802-0.305-5.148-0.819c-0.435-0.166-0.835-0.36-1.183-0.581v2.619V312.755z
                  M190.693,299.068c0,0.095,0.052,0.269,0.329,0.507c0.055,0.047,0.114,0.095,0.182,0.142c-0.609,0.024-1.203,0.076-1.777,0.155
                  v-0.803c0-0.606,0.34-1.096,0.768-1.464c0.431-0.372,1.017-0.677,1.689-0.918c1.345-0.495,3.162-0.784,5.14-0.784
                  s3.795,0.289,5.14,0.779c0.669,0.245,1.258,0.551,1.689,0.918c0.428,0.372,0.768,0.863,0.768,1.468v4.115v4.507
                  c0,0.61-0.324,1.117-0.756,1.504c-0.431,0.388-1.017,0.709-1.69,0.966c-0.411,0.154-0.862,0.292-1.349,0.408v-1.306
                  c0.325-0.088,0.625-0.182,0.902-0.286c0.59-0.225,1.021-0.475,1.294-0.72c0.273-0.245,0.336-0.439,0.336-0.562v-2.624
                  c-0.344,0.222-0.744,0.415-1.183,0.582c-0.411,0.155-0.862,0.293-1.349,0.408v-1.306c0.325-0.087,0.625-0.182,0.902-0.285
                  c0.59-0.225,1.021-0.475,1.294-0.72c0.273-0.245,0.336-0.44,0.336-0.562v-2.295c-0.348,0.213-0.752,0.399-1.191,0.557
                  c-0.685,0.249-1.488,0.447-2.374,0.578c-0.075-0.076-0.151-0.151-0.225-0.218c-0.4-0.36-0.859-0.649-1.338-0.89
                  c1.377-0.091,2.588-0.333,3.502-0.665c0.59-0.213,1.021-0.455,1.298-0.688c0.277-0.237,0.328-0.412,0.328-0.507
                  c0-0.095-0.051-0.269-0.328-0.507c-0.273-0.233-0.704-0.475-1.298-0.688c-1.175-0.42-2.841-0.697-4.709-0.697
                  s-3.534,0.277-4.709,0.704c-0.59,0.213-1.021,0.455-1.298,0.688c-0.277,0.237-0.328,0.412-0.328,0.507H190.693z"
                />
              </g>
            </g>
            <g id="u-circle_u-employee-2" data-name="circle_u-employee">
              <path
                id="u-circle-14"
                data-name="circle"
                fill="#BFC9FF"
                d="M304.209,240.429L304.209,240.429
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C251.358,264.091,275.02,240.429,304.209,240.429z"
              />
              <g id="icon:svg-14" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M309.274,258.825c2.097,0,3.799,1.701,3.799,3.799v10.13c0,1.82-1.282,3.339-2.991,3.712l1.539,1.539
                  c0.245,0.245,0.245,0.649,0,0.895c-0.246,0.245-0.649,0.245-0.895,0l-2.346-2.347h-8.341l-2.346,2.347
                  c-0.246,0.245-0.649,0.245-0.895,0c-0.245-0.245-0.245-0.649,0-0.895l1.539-1.539c-1.709-0.372-2.991-1.892-2.991-3.712v-10.13
                  c0-2.097,1.701-3.799,3.799-3.799H309.274z M299.144,260.091c-1.397,0-2.532,1.135-2.532,2.532v5.065h15.194v-5.065
                  c0-1.397-1.135-2.532-2.532-2.532H299.144z M299.144,275.286h10.13c1.397,0,2.532-1.135,2.532-2.532v-3.799h-15.194v3.799
                  C296.612,274.15,297.747,275.286,299.144,275.286z M302.943,272.12c0-0.699,0.567-1.266,1.266-1.266
                  c0.699,0,1.266,0.567,1.266,1.266c0,0.699-0.567,1.266-1.266,1.266C303.51,273.386,302.943,272.82,302.943,272.12z"
                />
              </g>
            </g>
            <g id="u-circle_u-business-2" data-name="circle_u-business">
              <path
                id="u-circle-15"
                data-name="circle"
                fill="#BFC9FF"
                d="M202.134,158.792L202.134,158.792
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C149.283,182.454,172.945,158.792,202.134,158.792z"
              />
              <g id="icon:svg-15" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M213.003,191.327c0.301,0.376,0.526,0.843,0.526,1.377c0,1.064-0.855,1.864-1.654,2.342
                  c-0.835,0.502-1.871,0.823-2.686,0.823h-3.973l-3.435,6.007c-0.336,0.594-0.969,0.957-1.65,0.957h-2.224
                  c-0.843,0-1.448-0.803-1.218-1.615l1.531-5.35h-2.101l-1.52,2.026c-0.237,0.321-0.613,0.507-1.013,0.507h-1.662
                  c-0.657,0-1.187-0.53-1.187-1.187c0-0.111,0.016-0.222,0.047-0.324l1.195-4.187l-1.195-4.182
                  c-0.031-0.107-0.047-0.218-0.047-0.329c0-0.657,0.53-1.187,1.187-1.187h1.662c0.4,0,0.775,0.186,1.013,0.507l1.52,2.026h2.101
                  l-1.531-5.35c-0.23-0.811,0.38-1.615,1.218-1.615h2.224c0.68,0,1.31,0.364,1.65,0.957l3.435,6.007h3.973
                  c0.819,0,1.855,0.332,2.691,0.839C212.303,190.634,212.702,190.951,213.003,191.327z M211.222,191.458
                  c-0.684-0.415-1.499-0.657-2.03-0.657h-4.345c-0.225,0-0.435-0.122-0.55-0.32l-3.616-6.319l0.55-0.313l-0.55,0.313
                  c-0.111-0.198-0.325-0.321-0.55-0.321h-2.224l1.761,6.157c0.055,0.189,0.016,0.396-0.103,0.554
                  c-0.119,0.158-0.308,0.253-0.506,0.253h-3.257c-0.198,0-0.388-0.095-0.507-0.253l-1.709-2.28h-1.559l1.219,4.258
                  c0.031,0.114,0.031,0.233,0,0.348l-1.219,4.258h1.559l1.709-2.28c0.119-0.158,0.309-0.253,0.507-0.253h3.257
                  c0.198,0,0.388,0.095,0.506,0.253c0.119,0.158,0.158,0.365,0.103,0.554l-1.761,6.157h2.224c0.225,0,0.435-0.123,0.55-0.321
                  l3.616-6.327c0.115-0.198,0.325-0.321,0.55-0.321h4.341c0.538,0,1.353-0.233,2.033-0.641c0.717-0.428,1.041-0.894,1.041-1.254
                  c0-0.163-0.067-0.356-0.249-0.586C211.832,191.889,211.559,191.663,211.222,191.458z"
                />
              </g>
            </g>
            <g id="u-circle_u-purchased-2" data-name="circle_u-purchased">
              <path
                id="u-circle-16"
                data-name="circle"
                fill="#BFC9FF"
                d="M311.806,126.267L311.806,126.267
                c29.188,0,52.85,23.662,52.85,52.85l0,0c0,29.188-23.662,52.85-52.85,52.85l0,0c-29.188,0-52.85-23.662-52.85-52.85l0,0
                C258.956,149.929,282.618,126.267,311.806,126.267z"
              />
              <g id="icon:svg-16" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M301.677,146.84c0-3.146,4.534-5.698,10.13-5.698c5.595,0,10.13,2.552,10.13,5.698v1.266v3.166
                  c0,2.797-4.534,5.065-10.13,5.065c-5.595,0-10.13-2.267-10.13-5.065v-3.166V146.84z M311.806,151.271
                  c2.619,0,4.93-0.601,6.541-1.508c1.65-0.926,2.323-2.009,2.323-2.924s-0.673-1.998-2.323-2.924
                  c-1.611-0.907-3.922-1.508-6.541-1.508c-2.619,0-4.93,0.601-6.541,1.508c-1.65,0.926-2.323,2.009-2.323,2.924
                  s0.673,1.998,2.323,2.924C306.876,150.67,309.187,151.271,311.806,151.271z M302.943,149.602v1.67
                  c0,0.51,0.336,1.183,1.266,1.852v-2.517c-0.483-0.309-0.91-0.645-1.266-1.009V149.602z M319.404,146.682
                  c0,0.609-0.324,1.12-0.752,1.516c-0.431,0.391-1.017,0.72-1.689,0.977c-1.35,0.522-3.174,0.831-5.152,0.831
                  c-1.978,0-3.802-0.309-5.152-0.831c-0.673-0.262-1.262-0.586-1.69-0.977c-0.431-0.392-0.752-0.907-0.752-1.516
                  c0-0.609,0.325-1.12,0.752-1.516c0.431-0.391,1.017-0.72,1.69-0.977c1.349-0.522,3.173-0.831,5.152-0.831
                  c1.978,0,3.802,0.309,5.152,0.831c0.673,0.262,1.262,0.586,1.689,0.977C319.083,145.558,319.404,146.072,319.404,146.682z
                  M311.806,144.624c-1.864,0-3.526,0.292-4.697,0.744c-0.586,0.225-1.021,0.483-1.294,0.732c-0.273,0.253-0.34,0.447-0.34,0.581
                  s0.067,0.329,0.34,0.581c0.273,0.249,0.704,0.507,1.294,0.732c1.171,0.452,2.833,0.744,4.697,0.744
                  c1.864,0,3.525-0.292,4.697-0.744c0.586-0.225,1.021-0.483,1.294-0.732c0.273-0.249,0.34-0.447,0.34-0.581
                  s-0.067-0.329-0.34-0.581c-0.273-0.249-0.704-0.507-1.294-0.732C315.332,144.916,313.67,144.624,311.806,144.624z
                  M307.375,151.964c-0.68-0.186-1.314-0.415-1.899-0.677v2.561c0.562,0.257,1.199,0.486,1.899,0.673V151.964z M308.641,152.253
                  v2.544c0.791,0.142,1.642,0.229,2.532,0.261v-2.532C310.295,152.494,309.444,152.404,308.641,152.253z M312.439,152.53v2.532
                  c0.89-0.028,1.741-0.119,2.532-0.261v-2.544C314.168,152.407,313.318,152.498,312.439,152.53z M316.238,151.964v2.556
                  c0.7-0.187,1.338-0.415,1.899-0.673v-2.561C317.552,151.553,316.918,151.778,316.238,151.964z M320.67,149.602
                  c-0.356,0.364-0.784,0.7-1.266,1.009v2.516c0.93-0.668,1.266-1.345,1.266-1.851v-1.671V149.602z"
                />
              </g>
            </g>
          </g>
        </svg>

        <div class="viz-scope-3-header">
          <div
            id="g-ai1-1"
            class="g-bg g-aiAbs"
            style="top: 5.418%; left: 49.9994%; margin-left: -7.3611%; width: 14.7222%"
          >
            <p class="g-pstyle0">Scope 3</p>
          </div>
          <div
            id="g-ai1-2"
            class="g-bg g-aiAbs"
            style="top: 9.2879%; left: 50.0079%; margin-left: -19.9306%; width: 39.8611%"
          >
            <p class="g-pstyle1">
              Indirect emissions from the value chain typically make up 90% of a company's emissions
            </p>
          </div>
        </div>

        <div class="viz-scrope-3-bubbles upstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-purchased')"
            @mouseover="handleMouseover('u-purchased')"
            @mouseleave="handleMouseleave"
            style="top: 19.6%; left: 36%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-purchased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle4">Purchased goods & services</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-business')"
            @mouseover="handleMouseover('u-business')"
            @mouseleave="handleMouseleave"
            style="top: 24.65%; left: 20.8%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-business"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Business travel</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-fuel')"
            @mouseover="handleMouseover('u-fuel')"
            @mouseleave="handleMouseleave"
            style="top: 32.3%; left: 6.36%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-fuel"
          >
            <div class="g-aiAbs circle-label" style="width: 85%">
              <p class="g-pstyle4">Fuel & energy-related activities</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-capital')"
            @mouseover="handleMouseover('u-capital')"
            @mouseleave="handleMouseleave"
            style="top: 42.2%; left: 19.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-capital"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Capital goods</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-employee')"
            @mouseover="handleMouseover('u-employee')"
            @mouseleave="handleMouseleave"
            style="top: 37.3%; left: 35%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-employee"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Employee commuting</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-leased')"
            @mouseover="handleMouseover('u-leased')"
            @mouseleave="handleMouseleave"
            style="top: 55%; left: 31.9%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-leased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-operational')"
            @mouseover="handleMouseover('u-operational')"
            @mouseleave="handleMouseleave"
            style="top: 63.1%; left: 17.9%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-operational"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Operational waste</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-transportation')"
            @mouseover="handleMouseover('u-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 51.3%; left: 6%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-transportation"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle4">Transportation & distribution</p>
            </div>
          </div>
        </div>

        <div class="viz-scrope-3-bubbles downstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-investments')"
            @mouseover="handleMouseover('d-investments')"
            @mouseleave="handleMouseleave"
            style="top: 37.3%; left: 50.3%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-investments"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Investments</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-leased')"
            @mouseover="handleMouseover('d-leased')"
            @mouseleave="handleMouseleave"
            style="top: 24.6%; left: 64.6%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-leased"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-processing')"
            @mouseover="handleMouseover('d-processing')"
            @mouseleave="handleMouseleave"
            style="top: 42.2%; left: 65.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-processing"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle4">Processing of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-franchises')"
            @mouseover="handleMouseover('d-franchises')"
            @mouseleave="handleMouseleave"
            style="top: 32.3%; left: 78.97%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-franchises"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 85%">
              <p class="g-pstyle2">Franchises</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-use')"
            @mouseover="handleMouseover('d-use')"
            @mouseleave="handleMouseleave"
            style="top: 63.2%; left: 67.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-use"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle3">Use of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-transportation')"
            @mouseover="handleMouseover('d-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 51.2%; left: 79.2%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-transportation"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle4">Transportation & distribution</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-end')"
            @mouseover="handleMouseover('d-end')"
            @mouseleave="handleMouseleave"
            style="top: 54.9%; left: 53.5%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-end"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 75%">
              <p class="g-pstyle4">End-of-life treatment of sold products</p>
            </div>
          </div>
        </div>

        <div class="viz-scope-3-footer">
          <div
            id="g-ai1-18"
            class="g-bg g-aiAbs"
            style="top: 80.3406%; left: 49.8528%; margin-left: -15.1389%; width: 30.2778%"
          >
            <p class="g-pstyle5">Reporting company</p>
          </div>
          <div
            id="g-ai1-19"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 85.0208%; margin-top: -10.2px; left: 77.5058%; width: 111px"
          >
            <p class="g-pstyle6">Downstream</p>
          </div>
          <div
            id="g-ai1-20"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 86.3798%; margin-top: -9px; left: 12.7296%; width: 85px"
          >
            <p class="g-pstyle7">Upstream</p>
          </div>
          <div
            id="g-ai1-21"
            class="g-bg g-aiAbs"
            style="top: 85.9133%; left: 38.8679%; margin-left: -7.6389%; width: 15.2778%"
          >
            <p class="g-pstyle0">Scope 2</p>
          </div>
          <div
            id="g-ai1-22"
            class="g-bg g-aiAbs"
            style="top: 85.9133%; left: 60.6636%; margin-left: -7.7778%; width: 15.5556%"
          >
            <p class="g-pstyle0">Scope 1</p>
          </div>
          <div
            id="g-ai1-23"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 88.1814%; margin-top: -9.7px; left: 73.7164%; width: 166px"
          >
            <p class="g-pstyle8">&bull; Distribution & storage</p>
          </div>
          <div
            id="g-ai1-24"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 89.5746%; margin-top: -9.7px; left: 10.5509%; width: 117px"
          >
            <p class="g-pstyle8">&bull; Raw materials</p>
          </div>
          <div
            id="g-ai1-25"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 90.6582%; margin-top: -9.7px; left: 73.7124%; width: 127px"
          >
            <p class="g-pstyle8">&bull; Use of products</p>
          </div>
          <div id="g-ai1-26" class="g-bg g-aiAbs" style="top: 89.6285%; left: 31.6116%; width: 35.25%">
            <p class="g-pstyle9">Indirect emissions</p>
          </div>
          <div id="g-ai1-27" class="g-bg g-aiAbs" style="top: 89.6285%; left: 53.9853%; width: 344.7222%">
            <p class="g-pstyle9">Direct emissions</p>
          </div>
          <div
            id="g-ai1-28"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 92.361%; margin-top: -9.7px; left: 10.2151%; width: 121px"
          >
            <p class="g-pstyle8">&bull; Pre-processing</p>
          </div>
          <div
            id="g-ai1-29"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 93.135%; margin-top: -9.7px; left: 73.716%; width: 93px"
          >
            <p class="g-pstyle8">&bull; End-of-life</p>
          </div>
          <div
            id="g-ai1-30"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 94.0638%; margin-top: -9.7px; left: 30.5829%; width: 155px"
          >
            <p class="g-pstyle8">&bull; Purchased energy</p>
          </div>
          <div id="g-ai1-31" class="g-bg g-aiAbs" style="top: 92.7245%; left: 52.8858%; width: 16.9444%">
            <p>&bull; Company facilities</p>
          </div>
          <div id="g-ai1-32" class="g-bg g-aiAbs" style="top: 95.5108%; left: 52.8858%; width: 16.9444%">
            <p>&bull; Company vehicles</p>
          </div>
        </div>
      </div>

      <!-- Artboard: _560px -->
      <div
        id="g-UOB-2023-2-_560px"
        class="g-artboard"
        style="width: 560px; height: 539px"
        data-aspect-ratio="1.039"
        data-min-width="560"
        data-max-width="719"
      >
        <svg
          class="g-UOB-2-_560px-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-2-_560px-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 560 539"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g id="bg-560px" data-name="bg-560px">
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M416.73,533.599C493.599,483.493,545,392.418,545,288.375
                C545,130.3,426.355,2.155,280,2.155S15,130.3,15,288.375c0,104.044,51.401,195.118,128.27,245.225H416.73z"
              />
              <path fill="#A1E6BD" d="M376.67,417.315h151.232l30.367,54.377l-30.367,54.377H376.67v-54.377V417.315z" />
              <path fill="#BFC9FF" d="M177.633,417.467H32.11L1.731,471.769L32.11,526.07h145.523v-54.301V417.467z" />
              <g>
                <rect x="439.72" y="453.29" fill="none" width="99.396" height="29.411" />
                <rect x="439.696" y="482.702" fill="none" width="96.539" height="15.012" />
                <rect x="439.717" y="497.714" fill="none" width="65.303" height="15.012" />
              </g>
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M437.98,538.117c-0.404-86.91-70.975-157.241-157.98-157.241
                s-157.576,70.331-157.98,157.241H437.98z"
              />
              <g>
                <rect x="48.166" y="444.153" fill="none" width="69.033" height="17.514" />
                <rect x="35.178" y="466.859" fill="none" width="94.313" height="16.263" />
                <rect x="35.178" y="483.121" fill="none" width="99.137" height="16.263" />
              </g>
              <path
                fill="#005EB8"
                d="M260.988,371.885c0-1.254,1.04-2.36,2.376-2.36h4.754c1.262,0,2.376,1.106,2.376,2.36v11.209l11.586-6.268
                c1.188-0.59,2.674,0.221,2.674,1.623v4.646l11.586-6.268c1.188-0.59,2.674,0.221,2.674,1.623v11.136v9.439
                c0,1.992-1.634,3.54-3.565,3.54h-30.895c-2.005,0-3.565-1.548-3.565-3.54v-5.899v-3.539V371.885z M278.218,390.174
                c-0.669,0-1.189,0.59-1.189,1.18v3.539c0,0.664,0.52,1.18,1.189,1.18h3.564c0.594,0,1.189-0.516,1.189-1.18v-3.539
                c0-0.59-0.595-1.18-1.189-1.18H278.218z M267.523,391.354v3.539c0,0.664,0.52,1.18,1.189,1.18h3.564
                c0.594,0,1.189-0.516,1.189-1.18v-3.539c0-0.59-0.595-1.18-1.189-1.18h-3.564C268.043,390.174,267.523,390.763,267.523,391.354z
                M287.724,390.174c-0.669,0-1.189,0.59-1.189,1.18v3.539c0,0.664,0.52,1.18,1.189,1.18h3.564c0.594,0,1.189-0.516,1.189-1.18
                v-3.539c0-0.59-0.595-1.18-1.189-1.18H287.724z"
              />
              <g>
                <rect x="294.113" y="512.076" fill="none" width="118.685" height="11.697" />
                <rect x="294.113" y="492.568" fill="none" width="121.409" height="11.697" />
              </g>
              <g>
                <rect x="149.478" y="492.568" fill="none" width="111.409" height="11.697" />
              </g>
              <path
                fill="#005EB8"
                d="M268.254,349.705c1.066,0,2.046,0.698,2.439,1.737l0.295,0.78l0.745-0.376
                c0.247-0.125,0.556-0.193,0.87-0.193c1.185,0,2.149,0.974,2.149,2.172c0,0.145-0.016,0.286-0.054,0.443
                c-0.075,0.024-0.149,0.051-0.222,0.079c-0.912-0.814-2.094-1.272-3.322-1.272c-2.387,0-4.419,1.633-4.975,3.896h-1.305
                c-1.185,0-2.149-0.974-2.149-2.172c0-1.197,0.964-2.172,2.178-2.172h0.659l0.084-0.654
                C265.812,350.68,266.934,349.705,268.254,349.705 M271.152,355.548c0.961,0,1.853,0.549,2.329,1.432l0.532,0.988l0.71-0.869
                c0.299-0.366,0.759-0.577,1.261-0.577c0.918,0,1.665,0.756,1.665,1.685c0,0.111-0.021,0.217-0.046,0.339l-0.18,0.898h0.915h0.06
                c1.185,0,2.149,0.974,2.149,2.172c0,1.198-0.964,2.172-2.149,2.172h-9.662c-1.185,0-2.149-0.974-2.149-2.172
                c0-0.932,0.586-1.76,1.457-2.061l0.598-0.206l-0.103-0.624c-0.02-0.122-0.02-0.305-0.02-0.517
                C268.521,356.741,269.701,355.548,271.152,355.548 M268.254,348.955c-1.721,0-3.14,1.279-3.352,2.922h-0.03
                c-1.6,0-2.899,1.308-2.899,2.922c0,1.613,1.298,2.922,2.899,2.922h1.932c0.242-2.191,2.083-3.896,4.348-3.896
                c1.238,0,2.386,0.548,3.17,1.431c0.302-0.183,0.634-0.304,0.966-0.365c0.121-0.335,0.211-0.669,0.211-1.065
                c0-1.613-1.298-2.922-2.899-2.922c-0.423,0-0.845,0.091-1.207,0.274C270.911,349.898,269.673,348.955,268.254,348.955
                L268.254,348.955z M271.152,354.798c-1.872,0-3.382,1.552-3.382,3.409c0,0.243,0,0.456,0.03,0.639
                c-1.147,0.396-1.962,1.492-1.962,2.77c0,1.613,1.298,2.922,2.899,2.922h9.662c1.6,0,2.899-1.309,2.899-2.922
                c0-1.613-1.298-2.922-2.899-2.922c-0.03,0-0.06,0-0.06,0c0.031-0.152,0.06-0.304,0.06-0.487c0-1.34-1.087-2.435-2.415-2.435
                c-0.755,0-1.419,0.335-1.842,0.852C273.568,355.56,272.451,354.798,271.152,354.798L271.152,354.798z"
              />
              <path
                fill="#005EB8"
                d="M283.838,337.238c1.066,0,2.046,0.698,2.439,1.737l0.295,0.78l0.745-0.376
                c0.247-0.125,0.556-0.193,0.87-0.193c1.185,0,2.149,0.974,2.149,2.172c0,0.145-0.017,0.286-0.054,0.443
                c-0.075,0.024-0.149,0.051-0.222,0.079c-0.912-0.814-2.094-1.272-3.322-1.272c-2.388,0-4.42,1.633-4.975,3.896h-1.305
                c-1.185,0-2.149-0.974-2.149-2.172c0-1.197,0.964-2.172,2.178-2.172h0.66l0.084-0.654
                C281.396,338.213,282.517,337.238,283.838,337.238 M286.736,343.081c0.961,0,1.853,0.549,2.329,1.432l0.532,0.987l0.709-0.869
                c0.299-0.366,0.759-0.577,1.261-0.577c0.918,0,1.666,0.756,1.666,1.685c0,0.111-0.021,0.217-0.046,0.339l-0.18,0.898h0.915h0.06
                c1.185,0,2.149,0.974,2.149,2.172c0,1.198-0.964,2.172-2.149,2.172h-9.662c-1.185,0-2.149-0.974-2.149-2.172
                c0-0.932,0.586-1.76,1.457-2.061l0.598-0.206l-0.102-0.624c-0.02-0.122-0.02-0.306-0.02-0.518
                C284.104,344.274,285.285,343.081,286.736,343.081 M283.838,336.488c-1.721,0-3.14,1.279-3.352,2.922h-0.03
                c-1.6,0-2.899,1.308-2.899,2.922c0,1.613,1.298,2.922,2.899,2.922h1.932c0.242-2.191,2.083-3.896,4.348-3.896
                c1.238,0,2.385,0.548,3.17,1.431c0.302-0.183,0.634-0.304,0.966-0.365c0.121-0.335,0.211-0.669,0.211-1.065
                c0-1.613-1.298-2.922-2.899-2.922c-0.423,0-0.845,0.091-1.207,0.274C286.495,337.431,285.257,336.488,283.838,336.488
                L283.838,336.488z M286.736,342.331c-1.872,0-3.382,1.552-3.382,3.409c0,0.243,0,0.456,0.03,0.639
                c-1.147,0.396-1.962,1.492-1.962,2.77c0,1.613,1.298,2.922,2.899,2.922h9.662c1.6,0,2.899-1.309,2.899-2.922
                c0-1.613-1.298-2.922-2.899-2.922c-0.03,0-0.06,0-0.06,0c0.031-0.152,0.06-0.304,0.06-0.487c0-1.34-1.087-2.435-2.416-2.435
                c-0.755,0-1.419,0.335-1.842,0.852C289.151,343.093,288.035,342.331,286.736,342.331L286.736,342.331z"
              />
              <line fill="none" stroke="#A7A8A9" stroke-dasharray="2,2" x1="280" y1="441.717" x2="280" y2="529.07" />
              <path fill="none" stroke="#008CFF" stroke-width="3" stroke-miterlimit="10" d="M138.554,364.538" />
              <path fill="none" stroke="#008CFF" stroke-width="3" stroke-miterlimit="10" d="M215.758,324.844" />
            </g>
            <g id="d-circle_d-transportation-3" data-name="circle_d-transportation">
              <path
                id="d-circle-15"
                data-name="circle"
                fill="#A1E6BD"
                d="M485.436,265.299L485.436,265.299
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C444.295,283.719,462.714,265.299,485.436,265.299z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M477.55,293.904c-1.087,0-1.971-0.884-1.971-1.971v-8.871c0-1.087,0.884-1.971,1.971-1.971h8.871
                  c1.087,0,1.971,0.884,1.971,1.971v0.986h2.012c0.431,0,0.841,0.188,1.121,0.518l2.424,2.828c0.232,0.268,0.358,0.609,0.358,0.961
                  v4.565h0.493c0.271,0,0.493,0.222,0.493,0.493c0,0.271-0.222,0.493-0.493,0.493h-1.479c0,1.633-1.324,2.957-2.957,2.957
                  c-1.633,0-2.957-1.325-2.957-2.957h-3.943c0,1.633-1.324,2.957-2.957,2.957C478.875,296.861,477.55,295.536,477.55,293.904z
                  M477.55,282.076c-0.545,0-0.986,0.441-0.986,0.986v8.871c0,0.545,0.441,0.986,0.986,0.986h0.169
                  c0.406-1.149,1.5-1.971,2.788-1.971c1.288,0,2.384,0.822,2.788,1.971h4.112v-9.857c0-0.545-0.441-0.986-0.986-0.986H477.55z
                  M482.479,293.904c0-0.704-0.376-1.355-0.986-1.708c-0.61-0.352-1.361-0.352-1.971,0c-0.61,0.352-0.986,1.003-0.986,1.708
                  s0.376,1.355,0.986,1.708c0.61,0.352,1.361,0.352,1.971,0C482.103,295.259,482.479,294.608,482.479,293.904z M490.364,295.875
                  c0.704,0,1.355-0.376,1.708-0.986c0.352-0.61,0.352-1.361,0-1.971c-0.352-0.61-1.003-0.986-1.708-0.986s-1.355,0.376-1.708,0.986
                  c-0.352,0.61-0.352,1.361,0,1.971C489.009,295.499,489.66,295.875,490.364,295.875z M488.393,287.99h4.772l-2.388-2.784
                  c-0.092-0.108-0.23-0.173-0.372-0.173h-2.012V287.99z M488.393,288.975v2.723c0.524-0.468,1.213-0.751,1.971-0.751
                  c1.288,0,2.384,0.822,2.788,1.971h0.169v-3.943H488.393z"
                />
              </g>
            </g>
            <g id="d-circle_d-use-3" data-name="circle_d-use">
              <path
                id="d-circle-16"
                data-name="circle"
                fill="#A1E6BD"
                d="M420.071,324.844L420.071,324.844
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C378.929,343.263,397.349,324.844,420.071,324.844z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M420.071,347.778l7.383-0.856c0.435-0.049,0.847,0.191,1.02,0.592l0.986,2.301
                  c0.302,0.705-0.108,1.512-0.856,1.685l-4.904,1.136c-0.582,0.133-1.189-0.095-1.537-0.582l-2.092-2.93l-2.092,2.924
                  c-0.348,0.487-0.955,0.718-1.537,0.582l-4.904-1.13c-0.749-0.173-1.158-0.98-0.853-1.682l0.986-2.301
                  c0.172-0.4,0.585-0.641,1.019-0.591L420.071,347.778z M412.573,347.904l-0.986,2.301c-0.059,0.139,0.022,0.302,0.172,0.335
                  l4.907,1.131c0.194,0.043,0.394-0.031,0.511-0.194l2.005-2.809l-6.607-0.764H412.573z M426.973,352.691l0.986-0.28v2.187
                  c0,0.68-0.462,1.272-1.121,1.435l-6.407,1.602c-0.237,0.059-0.483,0.059-0.717,0l-6.407-1.602
                  c-0.659-0.166-1.121-0.757-1.121-1.435v-2.187l0.986,0.28v1.904c0,0.228,0.154,0.425,0.373,0.477l6.034,1.509V352.3
                  c0-0.271,0.222-0.493,0.493-0.493c0.271,0,0.493,0.222,0.493,0.493v4.282l6.034-1.509c0.219-0.056,0.373-0.252,0.373-0.477
                  v-1.904H426.973z M415.142,345.893c0,0.271-0.222,0.493-0.493,0.493c-0.271,0-0.493-0.222-0.493-0.493
                  c0-2.178,1.765-3.943,3.943-3.943c2.178,0,3.943,1.765,3.943,3.943c0,0.271-0.222,0.493-0.493,0.493
                  c-0.271,0-0.493-0.222-0.493-0.493c0-1.633-1.325-2.957-2.957-2.957C416.467,342.936,415.142,344.26,415.142,345.893z
                  M420.961,348.668l2.005,2.809c0.114,0.163,0.317,0.24,0.511,0.194l4.901-1.131c0.151-0.033,0.234-0.194,0.173-0.335
                  l-0.986-2.301l-6.607,0.764H420.961z M424.481,346.05c-0.086,0.258-0.363,0.397-0.622,0.311
                  c-0.259-0.086-0.397-0.364-0.311-0.622l0.986-2.957c0.086-0.258,0.363-0.397,0.622-0.311c0.259,0.086,0.397,0.364,0.311,0.623
                  L424.481,346.05z"
                />
              </g>
            </g>
            <g id="d-circle_d-end-3" data-name="circle_d-end">
              <path
                id="d-circle-17"
                data-name="circle"
                fill="#A1E6BD"
                d="M340.162,283.702L340.162,283.702
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C299.021,302.122,317.44,283.702,340.162,283.702z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M331.291,292.518c0-0.681,0.551-1.232,1.232-1.232h15.278c0.681,0,1.232,0.551,1.232,1.232v0.493
                  c0,0.625-0.465,1.14-1.069,1.22v0.012l-0.752,9.034c-0.086,1.022-0.939,1.808-1.965,1.808h-10.171
                  c-1.026,0-1.879-0.785-1.965-1.808l-0.755-9.034v-0.012c-0.601-0.08-1.066-0.595-1.066-1.22V292.518z M332.523,292.271
                  c-0.136,0-0.246,0.111-0.246,0.246v0.493c0,0.135,0.111,0.246,0.246,0.246h0.742h13.793h0.742c0.136,0,0.246-0.111,0.246-0.246
                  v-0.493c0-0.135-0.111-0.246-0.246-0.246H332.523z M335.076,304.099h10.171c0.515,0,0.939-0.391,0.983-0.903l0.745-8.954h-13.627
                  l0.745,8.954C334.137,303.705,334.565,304.099,335.076,304.099z M337.513,298.586c0.243,0.154,0.305,0.481,0.136,0.712
                  l-0.85,1.152c-0.056,0.077-0.086,0.166-0.086,0.258c0,0.24,0.194,0.435,0.434,0.435h2.03c0.271,0,0.493,0.222,0.493,0.493
                  c0,0.271-0.222,0.493-0.493,0.493h-2.03c-0.785,0-1.42-0.635-1.42-1.42c0-0.305,0.098-0.601,0.277-0.844l0.847-1.149
                  c0.154-0.21,0.441-0.262,0.659-0.126L337.513,298.586z M339.774,296.411l-0.955,1.297c-0.154,0.21-0.441,0.262-0.659,0.127
                  c-0.243-0.154-0.305-0.481-0.136-0.712l0.955-1.297c0.277-0.376,0.715-0.597,1.183-0.597c0.468,0,0.906,0.222,1.183,0.597
                  l0.955,1.297c0.169,0.231,0.108,0.56-0.136,0.712c-0.219,0.135-0.505,0.08-0.659-0.127l-0.955-1.297
                  c-0.089-0.123-0.234-0.197-0.388-0.197C340.008,296.214,339.866,296.288,339.774,296.411z M341.147,301.142h2.027
                  c0.24,0,0.434-0.194,0.434-0.435c0-0.092-0.028-0.185-0.083-0.258l-0.85-1.152c-0.169-0.231-0.108-0.561,0.136-0.712
                  c0.219-0.135,0.505-0.08,0.659,0.127l0.85,1.152c0.182,0.246,0.277,0.542,0.277,0.844c0,0.785-0.634,1.42-1.42,1.42h-2.03
                  c-0.271,0-0.493-0.222-0.493-0.493C340.655,301.364,340.876,301.142,341.147,301.142z"
                />
              </g>
            </g>
            <g id="d-circle_d-processing-3" data-name="circle_d-processing">
              <path
                id="d-circle-18"
                data-name="circle"
                fill="#A1E6BD"
                d="M408.913,219.503L408.913,219.503
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C367.772,237.922,386.191,219.503,408.913,219.503z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M418.277,229.522c0.271,0,0.493,0.222,0.493,0.493s-0.222,0.493-0.493,0.493h-5.914
                  c-0.816,0-1.479,0.662-1.479,1.479v9.213l1.103-0.299l0.015-0.003c0.409-1.445,1.74-2.504,3.317-2.504
                  c1.907,0,3.45,1.543,3.45,3.45s-1.543,3.45-3.45,3.45c-1.87,0-3.391-1.485-3.447-3.339l-12.195,3.32
                  c-0.262,0.074-0.53-0.083-0.604-0.345c-0.074-0.262,0.083-0.533,0.345-0.603l10.491-2.862c-0.006-0.037-0.012-0.074-0.012-0.114
                  v-9.364c0-1.361,1.103-2.464,2.464-2.464H418.277z M405.226,233.437c0.527-0.142,1.066,0.169,1.207,0.696l1.272,4.762
                  c0.142,0.526-0.169,1.065-0.696,1.207l-4.759,1.275c-0.527,0.142-1.066-0.169-1.207-0.696l-1.275-4.762
                  c-0.142-0.526,0.169-1.065,0.696-1.207L405.226,233.437z M401.672,235.409l-0.952,0.255l1.275,4.762l4.762-1.275l-1.275-4.759
                  l-0.952,0.255l0.447,1.667c0.105,0.394-0.129,0.801-0.524,0.905l-1.429,0.382c-0.394,0.104-0.801-0.129-0.906-0.524l-0.447-1.667
                  V235.409z M402.626,235.156l0.382,1.43l0.952-0.256l-0.385-1.429l-0.952,0.255H402.626z M413.186,240.611
                  c-0.44,0.763-0.44,1.701,0,2.464s1.254,1.232,2.134,1.232s1.694-0.469,2.134-1.232s0.44-1.701,0-2.464s-1.254-1.232-2.134-1.232
                  S413.626,239.848,413.186,240.611z"
                />
              </g>
            </g>
            <g id="d-circle_d-franchises-3" data-name="circle_d-franchises">
              <path
                id="d-circle-19"
                data-name="circle"
                fill="#A1E6BD"
                d="M484.021,169.705L484.021,169.705
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C442.88,188.125,461.299,169.705,484.021,169.705z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M474.164,200.456c0-0.198,0.05-0.391,0.145-0.564l2.393-4.389c0.259-0.474,0.755-0.77,1.297-0.77h12.044
                  c0.542,0,1.038,0.296,1.297,0.77l2.393,4.386c0.095,0.173,0.145,0.367,0.145,0.564c0,0.65-0.526,1.177-1.177,1.177h-0.795v8.382
                  c0,0.271-0.222,0.493-0.493,0.493c-0.271,0-0.493-0.222-0.493-0.493v-8.378h-13.799v3.943h7.885v-2.464v-0.493h0.986v0.493v5.914
                  c0,0.816-0.662,1.479-1.479,1.479h-6.9c-0.816,0-1.479-0.662-1.479-1.479v-7.393h-0.795
                  C474.691,201.632,474.164,201.105,474.164,200.456z M476.629,200.647h14.785h1.288c0.104,0,0.191-0.086,0.191-0.191
                  c0-0.031-0.009-0.065-0.025-0.092l-2.39-4.389c-0.086-0.157-0.253-0.256-0.431-0.256h-12.044c-0.182,0-0.346,0.098-0.431,0.256
                  l-2.397,4.389c-0.015,0.027-0.025,0.058-0.025,0.092c0,0.104,0.086,0.191,0.191,0.191H476.629z M477.121,209.025
                  c0,0.271,0.222,0.493,0.493,0.493h6.9c0.271,0,0.493-0.222,0.493-0.493v-2.464h-7.885V209.025z"
                />
              </g>
            </g>
            <g id="d-circle_d-leased-3" data-name="circle_d-leased">
              <path
                id="d-circle-20"
                data-name="circle"
                fill="#A1E6BD"
                d="M402.684,131.282L402.684,131.282
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C361.542,149.702,379.962,131.282,402.684,131.282z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M404.408,159.16c0.952,0,1.725,0.773,1.725,1.725c0,0.265-0.059,0.514-0.166,0.739h0.172l2.917-1.737
                  c0.259-0.154,0.548-0.234,0.847-0.234h0.04c0.89,0,1.611,0.721,1.611,1.611c0,0.545-0.277,1.053-0.736,1.349l-3.684,2.396
                  c-0.557,0.364-1.211,0.558-1.879,0.558h-10.95c-0.271,0-0.493-0.222-0.493-0.493s0.222-0.493,0.493-0.493h10.95
                  c0.477,0,0.942-0.139,1.343-0.397l3.687-2.397c0.175-0.114,0.283-0.311,0.283-0.524c0-0.345-0.28-0.625-0.625-0.625h-0.04
                  c-0.12,0-0.237,0.031-0.342,0.092l-3.034,1.805c-0.077,0.046-0.163,0.07-0.253,0.07h-1.867h-0.739h-1.971
                  c-0.271,0-0.493-0.222-0.493-0.493c0-0.271,0.222-0.493,0.493-0.493h1.971h0.739c0.41,0,0.739-0.329,0.739-0.739
                  c0-0.409-0.329-0.739-0.739-0.739h-4.577c-0.293,0-0.576,0.086-0.819,0.25l-2.461,1.642c-0.083,0.056-0.176,0.083-0.274,0.083
                  h-1.971c-0.271,0-0.493-0.222-0.493-0.493s0.222-0.493,0.493-0.493h1.823l2.335-1.559c0.406-0.268,0.881-0.412,1.368-0.412
                  H404.408z M404.655,149.796h2.464c0.816,0,1.479,0.662,1.479,1.479v4.928c0,0.816-0.662,1.479-1.479,1.479h-8.871
                  c-0.816,0-1.479-0.662-1.479-1.479v-4.928c0-0.816,0.662-1.479,1.479-1.479h2.464H404.655z M398.248,150.782
                  c-0.271,0-0.493,0.222-0.493,0.493v4.928c0,0.271,0.222,0.493,0.493,0.493h8.871c0.271,0,0.493-0.222,0.493-0.493v-4.928
                  c0-0.271-0.222-0.493-0.493-0.493h-1.971v2.957c0,0.169-0.089,0.329-0.234,0.419c-0.145,0.089-0.326,0.098-0.48,0.021
                  l-1.75-0.875l-1.75,0.875c-0.154,0.077-0.335,0.068-0.48-0.021c-0.145-0.09-0.234-0.25-0.234-0.419v-2.957H398.248z
                  M401.205,152.941l1.26-0.629c0.139-0.071,0.302-0.071,0.44,0l1.257,0.629v-2.16h-2.957V152.941z"
                />
              </g>
            </g>
            <g id="d-circle_d-investments-3" data-name="circle_d-investments">
              <path
                id="d-circle-21"
                data-name="circle"
                fill="#A1E6BD"
                d="M325.079,194.833L325.079,194.833
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C283.938,213.252,302.357,194.833,325.079,194.833z"
              />
              <g>
                <path
                  fill="#121212"
                  d="M332.835,219.992c0.181,0.2,0.169,0.514-0.034,0.696l-5.421,4.928c-0.194,0.175-0.493,0.169-0.681-0.015
                  l-3.641-3.644l-5.082,3.693c-0.219,0.161-0.53,0.111-0.69-0.108c-0.16-0.218-0.111-0.53,0.108-0.69l5.421-3.943
                  c0.197-0.142,0.468-0.12,0.637,0.05l3.613,3.613l5.073-4.611c0.2-0.181,0.515-0.169,0.696,0.034V219.992z M319.165,228.703
                  c0.816,0,1.479,0.662,1.479,1.479v1.971c0,0.816-0.662,1.479-1.479,1.479c-0.816,0-1.479-0.662-1.479-1.479v-1.971
                  C317.686,229.365,318.349,228.703,319.165,228.703z M319.658,232.153v-1.971c0-0.271-0.222-0.493-0.493-0.493
                  c-0.271,0-0.493,0.222-0.493,0.493v1.971c0,0.271,0.222,0.493,0.493,0.493C319.436,232.646,319.658,232.424,319.658,232.153z
                  M321.629,227.225c0-0.816,0.662-1.479,1.479-1.479c0.816,0,1.479,0.662,1.479,1.479v4.928c0,0.816-0.662,1.479-1.479,1.479
                  c-0.816,0-1.479-0.662-1.479-1.479V227.225z M323.6,227.225c0-0.271-0.222-0.493-0.493-0.493c-0.271,0-0.493,0.222-0.493,0.493
                  v4.928c0,0.271,0.222,0.493,0.493,0.493c0.271,0,0.493-0.222,0.493-0.493V227.225z M327.05,227.717
                  c0.816,0,1.479,0.662,1.479,1.479v2.957c0,0.816-0.662,1.479-1.479,1.479c-0.816,0-1.479-0.662-1.479-1.479v-2.957
                  C325.572,228.38,326.234,227.717,327.05,227.717z M327.543,232.153v-2.957c0-0.271-0.222-0.493-0.493-0.493
                  c-0.271,0-0.493,0.222-0.493,0.493v2.957c0,0.271,0.222,0.493,0.493,0.493C327.321,232.646,327.543,232.424,327.543,232.153z
                  M329.514,227.225c0-0.816,0.662-1.479,1.479-1.479c0.816,0,1.479,0.662,1.479,1.479v4.928c0,0.816-0.662,1.479-1.479,1.479
                  c-0.816,0-1.479-0.662-1.479-1.479V227.225z M331.486,227.225c0-0.271-0.222-0.493-0.493-0.493c-0.271,0-0.493,0.222-0.493,0.493
                  v4.928c0,0.271,0.222,0.493,0.493,0.493c0.271,0,0.493-0.222,0.493-0.493V227.225z"
                />
              </g>
            </g>
            <g id="u-circle_u-fuel-3" data-name="circle_u-fuel">
              <path
                id="circle:svg-17"
                data-name="circle"
                fill="#BFC9FF"
                d="M76.69,169.705L76.69,169.705
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C35.549,188.125,53.968,169.705,76.69,169.705z"
              />
              <g id="icon:svg-17" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M79.241,175.904c0.142-0.127,0.323-0.194,0.511-0.194c0.53,0,0.899,0.527,0.721,1.026l-2.098,5.874h3.398
                  c0.459,0,0.832,0.373,0.832,0.832c0,0.24-0.102,0.465-0.28,0.625l-8.187,7.223c-0.139,0.123-0.32,0.191-0.508,0.191
                  c-0.53,0-0.899-0.527-0.724-1.026l2.101-5.874h-3.434c-0.438,0-0.795-0.358-0.795-0.795c0-0.228,0.098-0.443,0.268-0.595
                  L79.241,175.904z M79.256,177.21l-7.183,6.385h3.632c0.16,0,0.311,0.077,0.403,0.21s0.114,0.299,0.062,0.449l-2.048,5.736
                  l7.245-6.395h-3.69c-0.16,0-0.311-0.077-0.403-0.21s-0.114-0.299-0.062-0.449l2.045-5.729V177.21z"
                />
              </g>
            </g>
            <g id="u-circle_u-transportation-3" data-name="circle_u-transportation">
              <path
                id="circle:svg-18"
                data-name="circle"
                fill="#BFC9FF"
                d="M74.564,265.299L74.564,265.299
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C33.423,283.719,51.842,265.299,74.564,265.299z"
              />
              <g id="icon:svg-18" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M66.679,294.239c-1.087,0-1.971-0.884-1.971-1.971v-8.871c0-1.087,0.884-1.971,1.971-1.971h8.871
                  c1.087,0,1.971,0.884,1.971,1.971v0.986h2.012c0.431,0,0.841,0.188,1.121,0.518l2.424,2.828c0.231,0.268,0.357,0.609,0.357,0.961
                  v4.565h0.493c0.271,0,0.493,0.222,0.493,0.493c0,0.271-0.222,0.493-0.493,0.493H82.45c0,1.633-1.325,2.957-2.957,2.957
                  c-1.633,0-2.957-1.324-2.957-2.957h-3.943c0,1.633-1.325,2.957-2.957,2.957C68.003,297.196,66.679,295.872,66.679,294.239z
                  M66.679,282.411c-0.545,0-0.986,0.441-0.986,0.986v8.871c0,0.545,0.441,0.986,0.986,0.986h0.169
                  c0.406-1.149,1.5-1.971,2.788-1.971s2.384,0.822,2.788,1.971h4.112v-9.857c0-0.545-0.441-0.986-0.986-0.986H66.679z
                  M71.607,294.239c0-0.704-0.376-1.355-0.986-1.708c-0.61-0.352-1.361-0.352-1.971,0c-0.61,0.352-0.986,1.003-0.986,1.708
                  s0.376,1.355,0.986,1.708c0.61,0.352,1.361,0.352,1.971,0C71.231,295.594,71.607,294.944,71.607,294.239z M77.521,288.325h4.771
                  l-2.387-2.784c-0.092-0.108-0.231-0.173-0.373-0.173h-2.012V288.325z M77.521,289.311v2.723c0.524-0.468,1.214-0.751,1.971-0.751
                  c1.288,0,2.384,0.822,2.788,1.971h0.169v-3.943H77.521z M79.492,296.21c0.704,0,1.355-0.376,1.707-0.986s0.352-1.361,0-1.971
                  s-1.003-0.986-1.707-0.986s-1.355,0.376-1.707,0.986s-0.352,1.361,0,1.971S78.788,296.21,79.492,296.21z"
                />
              </g>
            </g>
            <g id="u-circle_u-operational-3" data-name="circle_u-operational">
              <path
                id="circle:svg-19"
                data-name="circle"
                fill="#BFC9FF"
                d="M141.193,324.844L141.193,324.844
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C100.052,343.263,118.471,324.844,141.193,324.844z"
              />
              <g id="icon:svg-19" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M143.873,342.138l0.798,1.275h1.451h0.986h0.493c0.271,0,0.493,0.222,0.493,0.493
                  c0,0.271-0.222,0.493-0.493,0.493h-0.493v10.35c0,1.361-1.103,2.464-2.464,2.464h-6.9c-1.361,0-2.464-1.103-2.464-2.464v-10.35
                  h-0.493c-0.271,0-0.493-0.222-0.493-0.493c0-0.271,0.222-0.493,0.493-0.493h0.493h0.986h1.451l0.798-1.275
                  c0.271-0.435,0.745-0.696,1.254-0.696h2.849c0.512,0,0.983,0.262,1.254,0.696H143.873z M136.265,344.398v10.35
                  c0,0.816,0.662,1.479,1.479,1.479h6.9c0.816,0,1.479-0.662,1.479-1.479v-10.35H136.265z M138.729,346.863v6.9
                  c0,0.271-0.222,0.493-0.493,0.493s-0.493-0.222-0.493-0.493v-6.9c0-0.271,0.222-0.493,0.493-0.493
                  S138.729,346.591,138.729,346.863z M139.351,342.658l-0.471,0.755h4.626l-0.471-0.755c-0.089-0.145-0.25-0.231-0.419-0.231
                  h-2.849c-0.169,0-0.326,0.086-0.419,0.231H139.351z M141.686,346.863v6.9c0,0.271-0.222,0.493-0.493,0.493
                  s-0.493-0.222-0.493-0.493v-6.9c0-0.271,0.222-0.493,0.493-0.493S141.686,346.591,141.686,346.863z M144.643,346.863v6.9
                  c0,0.271-0.222,0.493-0.493,0.493s-0.493-0.222-0.493-0.493v-6.9c0-0.271,0.222-0.493,0.493-0.493
                  S144.643,346.591,144.643,346.863z"
                />
              </g>
            </g>
            <g>
              <path
                id="circle:svg-20"
                data-name="circle"
                fill="#BFC9FF"
                d="M219.838,283.702L219.838,283.702
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C178.697,302.122,197.116,283.702,219.838,283.702z"
              />
              <g id="icon:svg-20" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M221.562,310.424c0.952,0,1.725,0.773,1.725,1.725c0,0.265-0.059,0.514-0.166,0.739h0.172l2.917-1.737
                  c0.259-0.154,0.548-0.234,0.847-0.234h0.04c0.89,0,1.611,0.721,1.611,1.611c0,0.545-0.277,1.053-0.736,1.349l-3.684,2.396
                  c-0.557,0.364-1.211,0.558-1.879,0.558h-10.95c-0.271,0-0.493-0.222-0.493-0.493c0-0.271,0.222-0.493,0.493-0.493h10.95
                  c0.477,0,0.942-0.139,1.343-0.397l3.687-2.397c0.175-0.114,0.283-0.311,0.283-0.524c0-0.345-0.28-0.625-0.625-0.625h-0.04
                  c-0.12,0-0.237,0.031-0.342,0.092l-3.034,1.805c-0.077,0.046-0.163,0.07-0.253,0.07h-1.867h-0.739h-1.971
                  c-0.271,0-0.493-0.222-0.493-0.493c0-0.271,0.222-0.493,0.493-0.493h1.971h0.739c0.41,0,0.739-0.329,0.739-0.739
                  c0-0.409-0.329-0.739-0.739-0.739h-4.577c-0.293,0-0.576,0.086-0.819,0.25l-2.461,1.642c-0.083,0.056-0.176,0.083-0.274,0.083
                  h-1.971c-0.271,0-0.493-0.222-0.493-0.493c0-0.271,0.222-0.493,0.493-0.493h1.823l2.335-1.559
                  c0.406-0.268,0.881-0.412,1.368-0.412H221.562z M221.809,301.061h2.464c0.816,0,1.479,0.662,1.479,1.479v4.928
                  c0,0.816-0.662,1.479-1.479,1.479h-8.871c-0.816,0-1.479-0.662-1.479-1.479v-4.928c0-0.816,0.662-1.479,1.479-1.479h2.464
                  H221.809z M215.402,302.046c-0.271,0-0.493,0.222-0.493,0.493v4.928c0,0.271,0.222,0.493,0.493,0.493h8.871
                  c0.271,0,0.493-0.222,0.493-0.493v-4.928c0-0.271-0.222-0.493-0.493-0.493h-1.971v2.957c0,0.169-0.089,0.329-0.234,0.419
                  c-0.145,0.089-0.326,0.098-0.48,0.021l-1.75-0.875l-1.75,0.875c-0.154,0.077-0.335,0.068-0.48-0.021
                  c-0.145-0.09-0.234-0.25-0.234-0.419v-2.957H215.402z M218.359,304.206l1.26-0.629c0.139-0.071,0.302-0.071,0.44,0l1.257,0.629
                  v-2.16h-2.957V304.206z"
                />
              </g>
            </g>
            <g id="u-circle_u-capital-3" data-name="circle_u-capital">
              <path
                id="circle:svg-21"
                data-name="circle"
                fill="#BFC9FF"
                d="M151.087,219.503L151.087,219.503
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C109.946,237.922,128.365,219.503,151.087,219.503z"
              />
              <g id="icon:svg-21" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M143.201,244.423c0-0.471,0.265-0.853,0.598-1.14c0.336-0.289,0.791-0.527,1.315-0.714
                  c1.047-0.385,2.461-0.61,4.001-0.61s2.954,0.225,4.001,0.607c0.521,0.191,0.979,0.429,1.315,0.714
                  c0.336,0.287,0.598,0.672,0.598,1.14v3.203v3.509c0,0.474-0.252,0.868-0.588,1.17c-0.336,0.302-0.792,0.551-1.315,0.751
                  c-1.05,0.404-2.47,0.641-4.01,0.641s-2.96-0.237-4.007-0.637c-0.524-0.2-0.98-0.45-1.315-0.752
                  c-0.335-0.301-0.591-0.696-0.591-1.17v-3.508V244.423z M144.187,244.423c0,0.074,0.04,0.21,0.256,0.394
                  c0.212,0.181,0.548,0.37,1.01,0.536c0.912,0.333,2.209,0.548,3.662,0.548s2.751-0.216,3.665-0.548
                  c0.459-0.166,0.795-0.354,1.01-0.536c0.216-0.185,0.255-0.321,0.255-0.394s-0.04-0.21-0.255-0.394
                  c-0.213-0.181-0.548-0.37-1.01-0.536c-0.915-0.333-2.212-0.548-3.665-0.548s-2.751,0.216-3.665,0.548
                  c-0.459,0.166-0.795,0.354-1.01,0.536c-0.216,0.185-0.255,0.321-0.255,0.394H144.187z M154.044,245.843
                  c-0.271,0.166-0.585,0.311-0.927,0.434c-1.047,0.385-2.461,0.61-4.001,0.61s-2.954-0.225-4.001-0.607
                  c-0.342-0.123-0.656-0.268-0.927-0.435v1.781c0,0.096,0.049,0.246,0.262,0.437c0.213,0.191,0.548,0.388,1.007,0.56
                  c0.915,0.348,2.206,0.573,3.659,0.573s2.744-0.225,3.659-0.573c0.459-0.175,0.795-0.37,1.007-0.56
                  c0.213-0.191,0.262-0.342,0.262-0.437V245.843z M144.187,251.135c0,0.096,0.049,0.246,0.262,0.438
                  c0.213,0.191,0.548,0.388,1.007,0.56c0.915,0.348,2.206,0.576,3.659,0.576s2.744-0.225,3.659-0.573
                  c0.459-0.175,0.795-0.37,1.007-0.56s0.262-0.342,0.262-0.437v-2.042c-0.268,0.173-0.579,0.323-0.921,0.453
                  c-1.047,0.4-2.467,0.635-4.007,0.635s-2.96-0.237-4.007-0.637c-0.339-0.129-0.65-0.281-0.921-0.453v2.039V251.135z
                  M148.13,240.48c0,0.074,0.04,0.21,0.256,0.394c0.043,0.037,0.089,0.074,0.142,0.11c-0.474,0.019-0.936,0.059-1.383,0.121v-0.625
                  c0-0.471,0.265-0.853,0.598-1.14c0.336-0.289,0.791-0.527,1.315-0.714c1.047-0.385,2.461-0.61,4.001-0.61
                  s2.954,0.225,4.001,0.607c0.521,0.191,0.979,0.429,1.315,0.714c0.333,0.29,0.598,0.672,0.598,1.143v3.203v3.508
                  c0,0.475-0.252,0.869-0.588,1.17c-0.336,0.302-0.792,0.552-1.315,0.752c-0.32,0.12-0.671,0.228-1.05,0.317v-1.016
                  c0.253-0.068,0.487-0.142,0.702-0.222c0.459-0.175,0.794-0.37,1.007-0.56s0.262-0.342,0.262-0.437v-2.042
                  c-0.268,0.173-0.579,0.323-0.921,0.453c-0.32,0.121-0.671,0.228-1.05,0.317v-1.016c0.253-0.068,0.487-0.141,0.702-0.222
                  c0.459-0.175,0.794-0.37,1.007-0.56s0.262-0.342,0.262-0.437v-1.787c-0.271,0.166-0.585,0.311-0.927,0.434
                  c-0.533,0.194-1.158,0.348-1.848,0.45c-0.059-0.059-0.117-0.117-0.175-0.169c-0.311-0.281-0.669-0.506-1.041-0.693
                  c1.072-0.071,2.015-0.259,2.726-0.518c0.459-0.166,0.795-0.354,1.01-0.536c0.216-0.185,0.255-0.321,0.255-0.394
                  c0-0.074-0.04-0.21-0.255-0.394c-0.213-0.181-0.548-0.37-1.01-0.536c-0.915-0.327-2.212-0.542-3.665-0.542
                  s-2.751,0.216-3.665,0.548c-0.459,0.166-0.795,0.354-1.01,0.536c-0.216,0.185-0.255,0.321-0.255,0.394H148.13z"
                />
              </g>
            </g>
            <g id="u-circle_u-employee-3" data-name="circle_u-employee">
              <path
                id="circle:svg-22"
                data-name="circle"
                fill="#BFC9FF"
                d="M235.225,194.833L235.225,194.833
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C194.084,213.252,212.503,194.833,235.225,194.833z"
              />
              <g id="icon:svg-22" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M239.168,209.153c1.633,0,2.957,1.325,2.957,2.957v7.885c0,1.417-0.998,2.599-2.329,2.889l1.198,1.198
                  c0.191,0.191,0.191,0.506,0,0.696c-0.191,0.191-0.505,0.191-0.696,0l-1.826-1.827h-6.493l-1.826,1.827
                  c-0.191,0.191-0.505,0.191-0.696,0c-0.191-0.191-0.191-0.506,0-0.696l1.198-1.198c-1.331-0.29-2.329-1.472-2.329-2.889v-7.885
                  c0-1.633,1.325-2.957,2.957-2.957H239.168z M231.283,210.139c-1.087,0-1.971,0.884-1.971,1.971v3.943h11.828v-3.943
                  c0-1.087-0.884-1.971-1.971-1.971H231.283z M231.283,221.967h7.885c1.087,0,1.971-0.884,1.971-1.971v-2.957h-11.828v2.957
                  C229.311,221.083,230.195,221.967,231.283,221.967z M234.24,219.503c0-0.544,0.441-0.986,0.986-0.986
                  c0.544,0,0.986,0.441,0.986,0.986c0,0.544-0.441,0.986-0.986,0.986C234.681,220.488,234.24,220.047,234.24,219.503z"
                />
              </g>
            </g>
            <g id="u-circle_u-business-3" data-name="circle_u-business">
              <path
                id="circle:svg-23"
                data-name="circle"
                fill="#BFC9FF"
                d="M159.845,131.282L159.845,131.282
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C118.704,149.702,137.123,131.282,159.845,131.282z"
              />
              <g id="icon:svg-23" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M168.306,156.609c0.234,0.293,0.41,0.656,0.41,1.072c0,0.828-0.665,1.451-1.288,1.823
                  c-0.65,0.391-1.457,0.641-2.091,0.641h-3.093l-2.674,4.676c-0.262,0.462-0.755,0.745-1.284,0.745h-1.731
                  c-0.656,0-1.127-0.625-0.949-1.257l1.192-4.164h-1.636l-1.183,1.577c-0.185,0.25-0.477,0.394-0.788,0.394h-1.294
                  c-0.511,0-0.924-0.412-0.924-0.924c0-0.086,0.012-0.173,0.037-0.252l0.93-3.259l-0.93-3.256
                  c-0.024-0.083-0.037-0.169-0.037-0.256c0-0.512,0.413-0.924,0.924-0.924h1.294c0.311,0,0.604,0.145,0.788,0.394l1.183,1.577
                  h1.636l-1.192-4.164c-0.179-0.631,0.296-1.257,0.949-1.257h1.731c0.53,0,1.019,0.283,1.284,0.745l2.674,4.676h3.093
                  c0.637,0,1.444,0.258,2.095,0.653C167.761,156.07,168.072,156.317,168.306,156.609z M166.92,156.711
                  c-0.533-0.323-1.167-0.512-1.58-0.512h-3.382c-0.175,0-0.339-0.095-0.428-0.249l-2.815-4.919l0.428-0.244l-0.428,0.244
                  c-0.086-0.154-0.253-0.25-0.428-0.25h-1.731l1.371,4.793c0.043,0.147,0.012,0.308-0.08,0.431
                  c-0.092,0.123-0.24,0.197-0.394,0.197h-2.535c-0.154,0-0.302-0.074-0.394-0.197l-1.331-1.774h-1.214l0.949,3.315
                  c0.024,0.089,0.024,0.181,0,0.271l-0.949,3.315h1.214l1.331-1.774c0.092-0.123,0.24-0.197,0.394-0.197h2.535
                  c0.154,0,0.302,0.074,0.394,0.197s0.123,0.284,0.08,0.431l-1.371,4.793h1.731c0.175,0,0.339-0.096,0.428-0.25l2.815-4.925
                  c0.089-0.154,0.253-0.25,0.428-0.25h3.379c0.419,0,1.053-0.181,1.583-0.499c0.558-0.333,0.81-0.696,0.81-0.976
                  c0-0.127-0.052-0.277-0.194-0.456C167.394,157.046,167.182,156.871,166.92,156.711z"
                />
              </g>
            </g>
            <g id="u-circle_u-purchased-3" data-name="circle_u-purchased">
              <path
                id="circle:svg-24"
                data-name="circle"
                fill="#BFC9FF"
                d="M243,105.963L243,105.963
                c22.722,0,41.141,18.42,41.141,41.141l0,0c0,22.722-18.42,41.141-41.141,41.141l0,0c-22.722,0-41.141-18.42-41.141-41.141l0,0
                C201.858,124.383,220.278,105.963,243,105.963z"
              />
              <g id="icon:svg-24" data-name="icon:svg">
                <path
                  fill="#121212"
                  d="M235.114,121.978c0-2.449,3.53-4.436,7.885-4.436c4.356,0,7.885,1.987,7.885,4.436v0.986v2.464
                  c0,2.178-3.53,3.943-7.885,3.943c-4.356,0-7.885-1.765-7.885-3.943v-2.464V121.978z M243,125.428
                  c2.039,0,3.838-0.468,5.092-1.174c1.284-0.721,1.808-1.564,1.808-2.276c0-0.712-0.524-1.556-1.808-2.276
                  c-1.254-0.706-3.053-1.174-5.092-1.174s-3.838,0.468-5.092,1.174c-1.284,0.721-1.808,1.564-1.808,2.276
                  c0,0.712,0.524,1.556,1.808,2.276C239.162,124.96,240.961,125.428,243,125.428z M236.1,124.128v1.3
                  c0,0.397,0.262,0.921,0.986,1.442v-1.959c-0.376-0.24-0.708-0.502-0.986-0.785V124.128z M248.914,121.855
                  c0,0.474-0.252,0.872-0.585,1.18c-0.336,0.305-0.791,0.56-1.315,0.761c-1.051,0.406-2.471,0.647-4.011,0.647
                  c-1.54,0-2.96-0.24-4.01-0.647c-0.524-0.204-0.983-0.456-1.315-0.761c-0.335-0.305-0.585-0.706-0.585-1.18
                  s0.253-0.872,0.585-1.18c0.336-0.305,0.792-0.56,1.315-0.761c1.05-0.406,2.47-0.647,4.01-0.647c1.54,0,2.96,0.24,4.011,0.647
                  c0.524,0.204,0.982,0.456,1.315,0.761C248.664,120.981,248.914,121.381,248.914,121.855z M243,120.253
                  c-1.451,0-2.744,0.228-3.656,0.579c-0.456,0.175-0.795,0.376-1.007,0.57c-0.213,0.197-0.265,0.348-0.265,0.453
                  s0.052,0.256,0.265,0.453c0.213,0.194,0.548,0.394,1.007,0.57c0.912,0.352,2.205,0.579,3.656,0.579s2.744-0.228,3.656-0.579
                  c0.456-0.175,0.795-0.376,1.007-0.57s0.265-0.348,0.265-0.453s-0.052-0.256-0.265-0.453c-0.213-0.194-0.548-0.394-1.007-0.57
                  C245.744,120.481,244.45,120.253,243,120.253z M239.55,125.967c-0.53-0.145-1.023-0.323-1.479-0.527v1.993
                  c0.437,0.2,0.933,0.378,1.479,0.524V125.967z M240.535,126.192v1.981c0.616,0.11,1.278,0.178,1.971,0.203v-1.971
                  C241.823,126.38,241.161,126.309,240.535,126.192z M243.493,126.408v1.971c0.693-0.021,1.355-0.092,1.971-0.204v-1.981
                  C244.838,126.312,244.176,126.383,243.493,126.408z M246.45,125.967v1.99c0.545-0.145,1.041-0.323,1.479-0.524v-1.993
                  C247.472,125.647,246.979,125.823,246.45,125.967z M249.899,124.128c-0.277,0.283-0.61,0.545-0.986,0.785v1.959
                  c0.724-0.52,0.986-1.047,0.986-1.441v-1.3V124.128z"
                />
              </g>
            </g>
          </g>
        </svg>

        <div class="viz-scope-3-header">
          <div
            id="g-ai2-1"
            class="g-bg g-aiAbs"
            style="top: 3.8961%; left: 49.9625%; margin-left: -7.3214%; width: 14.6429%"
          >
            <p class="g-pstyle0">Scope 3</p>
          </div>

          <div
            id="g-ai2-2"
            class="g-bg g-aiAbs"
            style="top: 9.0909%; left: 49.9933%; margin-left: -23.0357%; width: 46.0714%"
          >
            <p class="g-pstyle1">
              Indirect emissions from the value chain typically make up 90% of a company's emissions
            </p>
          </div>
        </div>

        <div class="viz-scope-3-bubbles upstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-purchased')"
            @mouseover="handleMouseover('u-purchased')"
            @mouseleave="handleMouseleave"
            style="top: 19.6%; left: 36.2%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-purchased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle3">Purchased goods & services</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-business')"
            @mouseover="handleMouseover('u-business')"
            @mouseleave="handleMouseleave"
            style="top: 24.5%; left: 21.1%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-business"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Business travel</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-fuel')"
            @mouseover="handleMouseover('u-fuel')"
            @mouseleave="handleMouseleave"
            style="top: 31.4%; left: 6.4%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-fuel"
          >
            <div class="g-aiAbs circle-label" style="width: 92%">
              <p class="g-pstyle3">Fuel & energy-related activities</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-capital')"
            @mouseover="handleMouseover('u-capital')"
            @mouseleave="handleMouseleave"
            style="top: 40.6%; left: 19.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-capital"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Capital goods</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-employee')"
            @mouseover="handleMouseover('u-employee')"
            @mouseleave="handleMouseleave"
            style="top: 36.1%; left: 34.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-employee"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Employee commuting</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-leased')"
            @mouseover="handleMouseover('u-leased')"
            @mouseleave="handleMouseleave"
            style="top: 52.6%; left: 31.9%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-leased"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-operational')"
            @mouseover="handleMouseover('u-operational')"
            @mouseleave="handleMouseleave"
            style="top: 60.3%; left: 17.9%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-operational"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Operational waste</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('u-transportation')"
            @mouseover="handleMouseover('u-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 49.1%; left: 6%"
            class="g-aiAbs circle-wrapper dtm-button circle-upstream u-transportation"
          >
            <div class="g-aiAbs circle-label">
              <p class="g-pstyle3">Transportation & distribution</p>
            </div>
          </div>
        </div>

        <div class="viz-scope-3-bubbles downstream">
          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-investments')"
            @mouseover="handleMouseover('d-investments')"
            @mouseleave="handleMouseleave"
            style="top: 36.1%; left: 50.8%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-investments"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Investments</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-leased')"
            @mouseover="handleMouseover('d-leased')"
            @mouseleave="handleMouseleave"
            style="top: 24.2%; left: 64.5%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-leased"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Leased assets</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-processing')"
            @mouseover="handleMouseover('d-processing')"
            @mouseleave="handleMouseleave"
            style="top: 40.8%; left: 65.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-processing"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 80%">
              <p class="g-pstyle3">Processing of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-franchises')"
            @mouseover="handleMouseover('d-franchises')"
            @mouseleave="handleMouseleave"
            style="top: 31.6%; left: 79.2%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-franchises"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 85%">
              <p class="g-pstyle2">Franchises</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-use')"
            @mouseover="handleMouseover('d-use')"
            @mouseleave="handleMouseleave"
            style="top: 60.3%; left: 67.7%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-use"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle2">Use of sold products</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-transportation')"
            @mouseover="handleMouseover('d-transportation')"
            @mouseleave="handleMouseleave"
            style="top: 49.1%; left: 79.4%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-transportation"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label">
              <p class="g-pstyle3">Transportation & distribution</p>
            </div>
          </div>

          <div
            type="button"
            button_name="emissions"
            data-toggle="modal"
            data-target="#bubbleModal"
            @click="handleModal('d-end')"
            @mouseover="handleMouseover('d-end')"
            @mouseleave="handleMouseleave"
            style="top: 52.7%; left: 53.5%"
            class="g-aiAbs circle-wrapper dtm-button circle-downstream d-end"
          >
            <!-- <div class="g-aiAbs circle-bg circle-bg-downstream" /> -->

            <div class="g-aiAbs circle-label" style="width: 79%">
              <p class="g-pstyle3">End-of-life treatment of sold products</p>
            </div>
          </div>
        </div>

        <div class="viz-scope-3-footer">
          <div
            id="g-ai2-18"
            class="g-bg g-aiAbs"
            style="top: 76.4378%; left: 49.9995%; margin-left: -15.1786%; width: 30.3571%"
          >
            <p class="g-pstyle0">Reporting company</p>
          </div>
          <div
            id="g-ai2-19"
            class="g-bg g-aiAbs g-aiPointText"
            style="top: 81.4948%; margin-top: -10.3px; left: 75.9079%; width: 112px"
          >
            <p class="g-pstyle4">Downstream</p>
          </div>
          <div id="g-ai2-20" class="g-bg g-aiAbs" style="top: 82.1892%; left: 8.6011%; width: 12.3214%">
            <p class="g-pstyle5">Upstream</p>
          </div>
          <div
            id="g-ai2-21"
            class="g-bg g-aiAbs"
            style="top: 82.1892%; left: 36.666%; margin-left: -7.6786%; width: 15.3571%"
          >
            <p class="g-pstyle6">Scope 2</p>
          </div>
          <div id="g-ai2-22" class="g-bg g-aiAbs" style="top: 82.1892%; left: 50.3591%; width: 25.5357%">
            <p class="g-pstyle6">Scope 1</p>
          </div>
          <div id="g-ai2-23" class="g-bg g-aiAbs" style="top: 83.859%; left: 78.5214%; width: 17.6786%">
            <p class="g-pstyle7">&bull; Distribution & storage</p>
          </div>
          <div id="g-ai2-24" class="g-bg g-aiAbs" style="top: 86.4564%; left: 6.2818%; width: 16.7857%">
            <p class="g-pstyle7">&bull; Raw materials</p>
          </div>
          <div id="g-ai2-25" class="g-bg g-aiAbs" style="top: 86.6419%; left: 19.5%; width: 35.8929%">
            <p class="g-pstyle8">Indirect emissions</p>
          </div>
          <div
            id="g-ai2-26"
            class="g-bg g-aiAbs"
            style="top: 86.6419%; left: 63.3692%; margin-left: -11.0714%; width: 22.1429%"
          >
            <p class="g-pstyle8">Direct emissions</p>
          </div>
          <div id="g-ai2-27" class="g-bg g-aiAbs" style="top: 89.4249%; left: 78.5172%; width: 17.3214%">
            <p class="g-pstyle7">&bull; Use of products</p>
          </div>
          <div id="g-ai2-28" class="g-bg g-aiAbs" style="top: 89.4249%; left: 6.2818%; width: 17.6786%">
            <p class="g-pstyle7">&bull; Pre-processing</p>
          </div>
          <div id="g-ai2-29" class="g-bg g-aiAbs" style="top: 91.2801%; left: 26.6926%; width: 19.8214%">
            <p class="g-pstyle7">&bull; Purchased energy</p>
          </div>
          <div id="g-ai2-30" class="g-bg g-aiAbs" style="top: 91.2801%; left: 52.5201%; width: 21.6071%">
            <p class="g-pstyle7">&bull; Company facilities</p>
          </div>
          <div id="g-ai2-31" class="g-bg g-aiAbs" style="top: 92.2078%; left: 78.5209%; width: 22.6071%">
            <p class="g-pstyle7">&bull; End-of-life</p>
          </div>
          <div id="g-ai2-32" class="g-bg g-aiAbs" style="top: 94.8052%; left: 52.5201%; width: 21.25%">
            <p class="g-pstyle7">&bull; Company vehicles</p>
          </div>
        </div>
      </div>

      <!-- Artboard: _395px -->
      <div
        id="g-UOB-2023-2-_395px"
        class="g-artboard"
        style="width: 395px; height: 542px"
        data-aspect-ratio="0.729"
        data-min-width="395"
        data-max-width="559"
      >
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-2-_395px-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-2-_395px-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 542"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g id="bg-395px" data-name="bg-395px">
              <circle fill="#121212" cx="91.2" cy="210.924" r="82.815" />
              <circle fill="#F1F1F1" stroke="#005EB8" stroke-dasharray="2,2" cx="197.5" cy="198.677" r="195.18" />
              <path fill="#BFC9FF" d="M198.051,342.58H22.513L0.666,378.97l21.847,36.389h175.538V378.97V342.58z" />
              <path fill="#A1E6BD" d="M198.051,342.58h175.538l21.847,36.389l-21.847,36.389H198.051V378.97V342.58z" />
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M382.409,428.316h-97.244c0-48.416-39.249-87.665-87.665-87.665
          s-87.665,39.249-87.665,87.665H12.693c-6.09,0-11.027,5.142-11.027,11.485v89.583c0,6.343,4.937,11.485,11.027,11.485h369.716
          c6.09,0,11.027-5.142,11.027-11.485v-89.583C393.436,433.458,388.499,428.316,382.409,428.316z"
              />
              <rect x="79.881" y="27.753" fill="none" width="235.235" height="22.071" />

              <path
                fill="#005EB8"
                d="M172.689,308.081c0-1.59,1.327-2.993,3.032-2.993h6.065c1.611,0,3.032,1.403,3.032,2.993v14.217
          l14.783-7.951c1.516-0.748,3.412,0.281,3.412,2.058v5.893l14.783-7.951c1.516-0.748,3.412,0.281,3.412,2.058v14.124v11.973
          c0,2.525-2.085,4.489-4.549,4.489h-39.422c-2.558,0-4.549-1.964-4.549-4.489v-7.483v-4.49V308.081z M194.675,331.278
          c-0.854,0-1.517,0.749-1.517,1.496v4.49c0,0.841,0.664,1.496,1.517,1.496h4.548c0.759,0,1.517-0.655,1.517-1.496v-4.49
          c0-0.748-0.759-1.496-1.517-1.496H194.675z M181.028,332.774v4.49c0,0.841,0.664,1.496,1.517,1.496h4.548
          c0.759,0,1.517-0.655,1.517-1.496v-4.49c0-0.748-0.759-1.496-1.517-1.496h-4.548C181.692,331.278,181.028,332.026,181.028,332.774
          z M206.805,331.278c-0.854,0-1.517,0.749-1.517,1.496v4.49c0,0.841,0.664,1.496,1.517,1.496h4.548
          c0.759,0,1.517-0.655,1.517-1.496v-4.49c0-0.748-0.759-1.496-1.517-1.496H206.805z"
              />
              <path
                fill="#005EB8"
                d="M181.676,279.123c1.524,0,2.921,0.947,3.477,2.356l0.198,0.501l0.485-0.234
          c0.374-0.18,0.835-0.28,1.299-0.28c1.731,0,3.139,1.352,3.139,3.014c0,0.318-0.062,0.597-0.144,0.852
          c-0.253,0.063-0.502,0.15-0.737,0.258c-1.088-1.027-2.553-1.609-4.077-1.609c-2.902,0-5.355,1.985-5.886,4.687h-1.998
          c-1.731,0-3.139-1.352-3.139-3.014c0-1.662,1.408-3.014,3.176-3.014h0.437l0.058-0.433
          C178.2,280.448,179.796,279.123,181.676,279.123 M185.315,286.153c1.373,0,2.644,0.744,3.317,1.942l0.351,0.625l0.465-0.545
          c0.461-0.54,1.165-0.85,1.932-0.85c1.396,0,2.532,1.09,2.532,2.43c0,0.172-0.032,0.323-0.065,0.482l-0.127,0.603h0.616h0.076
          c1.731,0,3.139,1.352,3.139,3.014c0,1.663-1.408,3.015-3.139,3.015h-12.13c-1.731,0-3.139-1.353-3.139-3.015
          c0-1.289,0.852-2.437,2.121-2.857l0.408-0.135l-0.072-0.424c-0.03-0.178-0.03-0.413-0.03-0.684
          C181.57,287.768,183.25,286.153,185.315,286.153 M181.676,278.623c-2.16,0-3.942,1.538-4.208,3.515h-0.037
          c-2.009,0-3.639,1.574-3.639,3.514c0,1.941,1.63,3.514,3.639,3.514h2.426c0.303-2.635,2.616-4.687,5.458-4.687
          c1.554,0,2.995,0.659,3.98,1.721c0.379-0.219,0.796-0.366,1.213-0.439c0.152-0.404,0.266-0.806,0.266-1.282
          c0-1.94-1.63-3.514-3.639-3.514c-0.53,0-1.062,0.11-1.516,0.33C185.012,279.758,183.458,278.623,181.676,278.623L181.676,278.623z
          M185.315,285.653c-2.35,0-4.245,1.867-4.245,4.101c0,0.292,0,0.549,0.037,0.769c-1.44,0.476-2.463,1.794-2.463,3.331
          c0,1.941,1.63,3.515,3.639,3.515h12.13c2.009,0,3.639-1.575,3.639-3.515c0-1.94-1.63-3.514-3.639-3.514c-0.038,0-0.076,0-0.076,0
          c0.039-0.183,0.076-0.366,0.076-0.586c0-1.611-1.365-2.93-3.032-2.93c-0.947,0-1.782,0.404-2.312,1.026
          C188.348,286.568,186.945,285.653,185.315,285.653L185.315,285.653z"
              />
              <path
                fill="#005EB8"
                d="M200.781,262.583c1.601,0,3.07,1.009,3.655,2.511l0.197,0.506l0.488-0.238
          c0.399-0.195,0.871-0.298,1.366-0.298c1.822,0,3.304,1.445,3.304,3.222c0,0.348-0.068,0.651-0.157,0.927
          c-0.273,0.068-0.539,0.163-0.791,0.28c-1.135-1.089-2.666-1.707-4.258-1.707c-3.032,0-5.594,2.104-6.136,4.962h-2.107
          c-1.822,0-3.304-1.445-3.304-3.222s1.482-3.222,3.344-3.222h0.438l0.057-0.434C197.125,263.996,198.803,262.583,200.781,262.583
          M204.585,270.026c1.442,0,2.778,0.793,3.486,2.068l0.352,0.634l0.467-0.555c0.486-0.577,1.227-0.907,2.035-0.907
          c1.472,0,2.67,1.167,2.67,2.602c0,0.181-0.032,0.338-0.069,0.52l-0.123,0.6h0.613h0.079c1.822,0,3.304,1.445,3.304,3.222
          s-1.482,3.222-3.304,3.222h-12.681c-1.822,0-3.304-1.445-3.304-3.222c0-1.379,0.898-2.606,2.235-3.053l0.406-0.136l-0.072-0.422
          c-0.033-0.191-0.033-0.441-0.033-0.73C200.646,271.75,202.413,270.026,204.585,270.026 M200.781,262.083
          c-2.258,0-4.122,1.629-4.399,3.722h-0.04c-2.101,0-3.804,1.667-3.804,3.722s1.704,3.722,3.804,3.722h2.536
          c0.316-2.791,2.735-4.962,5.707-4.962c1.624,0,3.131,0.698,4.161,1.822c0.397-0.233,0.833-0.387,1.268-0.465
          c0.159-0.426,0.278-0.852,0.278-1.356c0-2.054-1.704-3.722-3.804-3.722c-0.555,0-1.109,0.116-1.586,0.348
          C204.267,263.285,202.643,262.083,200.781,262.083L200.781,262.083z M204.585,269.526c-2.457,0-4.438,1.977-4.438,4.342
          c0,0.31,0,0.581,0.04,0.814c-1.506,0.504-2.576,1.899-2.576,3.528c0,2.054,1.704,3.722,3.804,3.722h12.681
          c2.101,0,3.804-1.667,3.804-3.722s-1.704-3.722-3.804-3.722c-0.04,0-0.079,0-0.079,0c0.04-0.194,0.079-0.388,0.079-0.62
          c0-1.706-1.427-3.102-3.17-3.102c-0.99,0-1.862,0.427-2.417,1.085C207.755,270.495,206.289,269.526,204.585,269.526
          L204.585,269.526z"
              />
              <line
                fill="none"
                stroke="#A7A8A9"
                stroke-dasharray="2,2"
                x1="197.551"
                y1="433.83"
                x2="197.551"
                y2="535.409"
              />
            </g>
            <g id="downstream-button" data-name="downstream-button">
              <circle
                id="circle-xs:svg"
                data-name="circle-xs:svg"
                fill="#A1E6BD"
                cx="302.809"
                cy="211.036"
                r="82.703"
              />
              <g id="icons:svg" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M248.442,174.629c0-1.036,0.839-1.875,1.875-1.875h23.25c1.036,0,1.875,0.839,1.875,1.875v0.75
                c0,0.952-0.708,1.734-1.627,1.856v0.019l-1.144,13.749c-0.131,1.556-1.43,2.751-2.99,2.751h-15.479
                c-1.561,0-2.859-1.195-2.99-2.751l-1.148-13.749v-0.019c-0.914-0.122-1.622-0.905-1.622-1.856V174.629z M250.317,174.254
                c-0.206,0-0.375,0.169-0.375,0.375v0.75c0,0.206,0.169,0.375,0.375,0.375h1.13h20.99h1.13c0.206,0,0.375-0.169,0.375-0.375
                v-0.75c0-0.206-0.169-0.375-0.375-0.375H250.317z M254.202,192.254h15.479c0.782,0,1.43-0.595,1.495-1.374l1.135-13.626
                h-20.738l1.135,13.626C252.773,191.654,253.424,192.254,254.202,192.254z M257.91,183.863c0.37,0.234,0.464,0.731,0.206,1.083
                l-1.294,1.753c-0.084,0.117-0.131,0.253-0.131,0.394c0,0.366,0.295,0.661,0.661,0.661h3.089c0.412,0,0.75,0.337,0.75,0.75
                s-0.338,0.75-0.75,0.75h-3.089c-1.195,0-2.161-0.966-2.161-2.161c0-0.464,0.15-0.914,0.422-1.284l1.289-1.749
                c0.234-0.319,0.67-0.398,1.003-0.192L257.91,183.863z M261.351,180.554l-1.453,1.974c-0.234,0.319-0.67,0.398-1.003,0.192
                c-0.37-0.234-0.464-0.731-0.206-1.083l1.453-1.974c0.422-0.572,1.087-0.909,1.8-0.909s1.378,0.337,1.8,0.909l1.453,1.974
                c0.258,0.352,0.164,0.853-0.206,1.083c-0.333,0.206-0.769,0.122-1.003-0.192l-1.453-1.974c-0.136-0.188-0.356-0.3-0.591-0.3
                S261.491,180.366,261.351,180.554z M263.442,187.754h3.084c0.366,0,0.661-0.295,0.661-0.661c0-0.141-0.042-0.281-0.126-0.394
                l-1.294-1.753c-0.258-0.352-0.164-0.854,0.206-1.083c0.333-0.206,0.769-0.122,1.003,0.192l1.294,1.753
                c0.276,0.375,0.422,0.825,0.422,1.284c0,1.195-0.966,2.161-2.161,2.161h-3.089c-0.412,0-0.75-0.337-0.75-0.75
                S263.029,187.754,263.442,187.754z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M289.87,190.753c-1.654,0-3-1.345-3-3v-13.5c0-1.655,1.346-3,3-3h13.5c1.654,0,3,1.345,3,3v1.5h3.061
                c0.656,0,1.28,0.286,1.707,0.788l3.688,4.303c0.352,0.408,0.544,0.928,0.544,1.462v6.947h0.75c0.412,0,0.75,0.337,0.75,0.75
                s-0.338,0.75-0.75,0.75h-2.25c0,2.484-2.016,4.5-4.5,4.5s-4.5-2.016-4.5-4.5h-6c0,2.484-2.016,4.5-4.5,4.5
                S289.87,193.238,289.87,190.753z M289.87,172.753c-0.83,0-1.5,0.67-1.5,1.5v13.5c0,0.83,0.67,1.5,1.5,1.5h0.258
                c0.619-1.749,2.283-3,4.242-3s3.628,1.251,4.242,3h6.258v-15c0-0.83-0.67-1.5-1.5-1.5H289.87z M297.37,190.753
                c0-1.072-0.572-2.062-1.5-2.598c-0.928-0.536-2.072-0.536-3,0c-0.928,0.536-1.5,1.526-1.5,2.598s0.572,2.062,1.5,2.598
                c0.928,0.536,2.072,0.536,3,0C296.798,192.815,297.37,191.825,297.37,190.753z M306.37,181.753h7.261l-3.633-4.237
                c-0.141-0.164-0.352-0.263-0.567-0.263h-3.061V181.753z M306.37,183.253v4.144c0.797-0.712,1.847-1.144,3-1.144
                c1.959,0,3.628,1.251,4.242,3h0.258v-6H306.37z M309.37,193.753c1.072,0,2.062-0.572,2.598-1.5c0.536-0.928,0.536-2.072,0-3
                c-0.535-0.928-1.525-1.5-2.598-1.5s-2.062,0.572-2.598,1.5c-0.536,0.928-0.536,2.072,0,3
                C307.308,193.182,308.298,193.753,309.37,193.753z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M342.737,180.122l11.236-1.303c0.66-0.075,1.289,0.291,1.551,0.9l1.5,3.501
                c0.46,1.073-0.164,2.301-1.303,2.564l-7.463,1.729c-0.886,0.202-1.809-0.145-2.339-0.886l-3.183-4.458l-3.183,4.449
                c-0.53,0.741-1.453,1.092-2.339,0.886l-7.463-1.72c-1.139-0.263-1.763-1.491-1.299-2.56l1.5-3.501
                c0.263-0.609,0.891-0.975,1.552-0.9L342.737,180.122z M331.327,180.314l-1.5,3.501c-0.089,0.211,0.032,0.459,0.263,0.511
                l7.467,1.721c0.295,0.065,0.6-0.047,0.778-0.295l3.052-4.275l-10.055-1.163H331.327z M353.241,187.599l1.5-0.426v3.328
                c0,1.036-0.703,1.936-1.706,2.184l-9.75,2.438c-0.361,0.089-0.736,0.089-1.093,0l-9.75-2.438
                c-1.003-0.253-1.706-1.153-1.706-2.184v-3.328l1.5,0.426v2.897c0,0.347,0.234,0.647,0.567,0.727l9.183,2.297v-6.516
                c0-0.413,0.338-0.75,0.75-0.75s0.75,0.337,0.75,0.75v6.516l9.183-2.297c0.333-0.084,0.567-0.384,0.567-0.727v-2.897H353.241z
                M335.237,177.253c0,0.413-0.338,0.75-0.75,0.75s-0.75-0.337-0.75-0.75c0-3.314,2.686-6,6-6s6,2.686,6,6
                c0,0.413-0.338,0.75-0.75,0.75s-0.75-0.337-0.75-0.75c0-2.484-2.016-4.5-4.5-4.5S335.237,174.769,335.237,177.253z
                M344.091,181.477l3.052,4.275c0.174,0.249,0.482,0.366,0.778,0.295l7.458-1.721c0.229-0.051,0.355-0.295,0.262-0.511
                l-1.5-3.501l-10.055,1.163H344.091z M349.449,177.493c-0.132,0.394-0.554,0.604-0.947,0.473s-0.604-0.553-0.474-0.947l1.5-4.5
                c0.132-0.394,0.554-0.604,0.947-0.474c0.394,0.131,0.604,0.553,0.474,0.947L349.449,177.493z"
                    />
                  </g>
                </g>
              </g>
              <g id="icons:svg-2" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M231.216,214.676c0-0.3,0.075-0.595,0.221-0.858l3.642-6.68c0.394-0.722,1.148-1.172,1.974-1.172
                h18.328c0.825,0,1.58,0.45,1.974,1.172l3.642,6.675c0.146,0.263,0.221,0.558,0.221,0.858c0,0.989-0.802,1.791-1.791,1.791
                h-1.209v12.755c0,0.413-0.338,0.75-0.75,0.75s-0.75-0.337-0.75-0.75v-12.75h-21v6h12v-3.75v-0.75h1.5v0.75v9
                c0,1.242-1.008,2.25-2.25,2.25h-10.5c-1.242,0-2.25-1.008-2.25-2.25v-11.25h-1.209
                C232.018,216.466,231.216,215.665,231.216,214.676z M234.966,214.966h22.5h1.959c0.16,0,0.291-0.131,0.291-0.291
                c0-0.047-0.014-0.099-0.037-0.141l-3.638-6.68c-0.132-0.239-0.385-0.389-0.656-0.389h-18.328c-0.276,0-0.525,0.15-0.656,0.389
                l-3.647,6.68c-0.023,0.042-0.037,0.089-0.037,0.141c0,0.159,0.131,0.291,0.291,0.291H234.966z M235.716,227.716
                c0,0.413,0.338,0.75,0.75,0.75h10.5c0.412,0,0.75-0.337,0.75-0.75v-3.75h-12V227.716z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M301.194,205.967c0.412,0,0.75,0.337,0.75,0.75s-0.338,0.75-0.75,0.75h-9
                c-1.242,0-2.25,1.008-2.25,2.25v14.021l1.678-0.455l0.023-0.004c0.624-2.199,2.648-3.811,5.049-3.811
                c2.901,0,5.25,2.349,5.25,5.25s-2.349,5.25-5.25,5.25c-2.846,0-5.161-2.259-5.245-5.081l-18.558,5.053
                c-0.398,0.113-0.807-0.126-0.919-0.525s0.126-0.811,0.524-0.918l15.966-4.355c-0.009-0.056-0.019-0.112-0.019-0.173v-14.25
                c0-2.072,1.678-3.75,3.75-3.75H301.194z M281.333,211.925c0.802-0.216,1.622,0.258,1.838,1.059l1.936,7.247
                c0.216,0.801-0.258,1.622-1.059,1.837l-7.242,1.94c-0.802,0.216-1.622-0.258-1.838-1.059l-1.94-7.247
                c-0.216-0.801,0.258-1.622,1.06-1.837L281.333,211.925z M275.923,214.925l-1.448,0.389l1.94,7.247l7.247-1.94l-1.94-7.242
                l-1.448,0.389l0.68,2.536c0.159,0.6-0.197,1.219-0.797,1.378l-2.176,0.582c-0.6,0.159-1.219-0.197-1.378-0.797l-0.68-2.536
                V214.925z M277.377,214.54l0.581,2.175l1.449-0.389l-0.586-2.175l-1.449,0.389H277.377z M293.446,222.842
                c-0.669,1.16-0.669,2.59,0,3.75c0.67,1.16,1.908,1.875,3.248,1.875s2.578-0.715,3.248-1.875c0.669-1.16,0.669-2.59,0-3.75
                c-0.67-1.16-1.908-1.875-3.248-1.875S294.116,221.682,293.446,222.842z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M336.476,207.71c0.277,0.305,0.258,0.783-0.051,1.06l-8.25,7.5c-0.296,0.267-0.75,0.258-1.036-0.023
                l-5.541-5.545l-7.734,5.62c-0.333,0.244-0.806,0.169-1.05-0.164c-0.244-0.333-0.169-0.806,0.164-1.05l8.25-6
                c0.3-0.216,0.713-0.183,0.971,0.075l5.498,5.498l7.721-7.017c0.305-0.276,0.782-0.258,1.059,0.052V207.71z M315.673,220.967
                c1.242,0,2.25,1.008,2.25,2.25v3c0,1.242-1.008,2.25-2.25,2.25s-2.25-1.008-2.25-2.25v-3
                C313.423,221.975,314.431,220.967,315.673,220.967z M316.423,226.217v-3c0-0.413-0.338-0.75-0.75-0.75s-0.75,0.337-0.75,0.75v3
                c0,0.413,0.338,0.75,0.75,0.75S316.423,226.629,316.423,226.217z M319.423,218.717c0-1.242,1.008-2.25,2.25-2.25
                s2.25,1.008,2.25,2.25v7.5c0,1.242-1.008,2.25-2.25,2.25s-2.25-1.008-2.25-2.25V218.717z M322.423,218.717
                c0-0.413-0.338-0.75-0.75-0.75s-0.75,0.337-0.75,0.75v7.5c0,0.413,0.338,0.75,0.75,0.75s0.75-0.337,0.75-0.75V218.717z
                M327.673,219.467c1.242,0,2.25,1.008,2.25,2.25v4.5c0,1.242-1.008,2.25-2.25,2.25s-2.25-1.008-2.25-2.25v-4.5
                C325.423,220.475,326.431,219.467,327.673,219.467z M328.423,226.217v-4.5c0-0.413-0.338-0.75-0.75-0.75s-0.75,0.337-0.75,0.75
                v4.5c0,0.413,0.338,0.75,0.75,0.75S328.423,226.629,328.423,226.217z M331.423,218.717c0-1.242,1.008-2.25,2.25-2.25
                s2.25,1.008,2.25,2.25v7.5c0,1.242-1.008,2.25-2.25,2.25s-2.25-1.008-2.25-2.25V218.717z M334.423,218.717
                c0-0.413-0.338-0.75-0.75-0.75s-0.75,0.337-0.75,0.75v7.5c0,0.413,0.338,0.75,0.75,0.75s0.75-0.337,0.75-0.75V218.717z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M363.526,220.217c1.448,0,2.625,1.177,2.625,2.625c0,0.403-0.089,0.783-0.253,1.125h0.263l4.438-2.644
                c0.394-0.234,0.835-0.356,1.289-0.356h0.062c1.354,0,2.451,1.097,2.451,2.452c0,0.83-0.422,1.603-1.12,2.053l-5.606,3.646
                c-0.849,0.553-1.842,0.849-2.859,0.849h-16.664c-0.412,0-0.75-0.337-0.75-0.75s0.338-0.75,0.75-0.75h16.664
                c0.727,0,1.435-0.211,2.044-0.604l5.61-3.647c0.268-0.173,0.432-0.474,0.432-0.797c0-0.525-0.427-0.952-0.951-0.952h-0.062
                c-0.183,0-0.36,0.047-0.521,0.141l-4.617,2.747c-0.117,0.07-0.248,0.107-0.384,0.107h-2.841h-1.125h-3
                c-0.412,0-0.75-0.337-0.75-0.75c0-0.412,0.338-0.75,0.75-0.75h3h1.125c0.623,0,1.125-0.501,1.125-1.125
                c0-0.623-0.502-1.125-1.125-1.125h-6.966c-0.445,0-0.876,0.131-1.247,0.38l-3.745,2.499c-0.126,0.084-0.267,0.126-0.417,0.126
                h-3c-0.412,0-0.75-0.337-0.75-0.75s0.338-0.75,0.75-0.75h2.775l3.553-2.372c0.619-0.408,1.341-0.628,2.081-0.628H363.526z
                M363.901,205.967h3.75c1.242,0,2.25,1.008,2.25,2.25v7.5c0,1.242-1.008,2.25-2.25,2.25h-13.5c-1.242,0-2.25-1.008-2.25-2.25
                v-7.5c0-1.242,1.008-2.25,2.25-2.25h3.75H363.901z M354.151,207.467c-0.412,0-0.75,0.337-0.75,0.75v7.5
                c0,0.413,0.338,0.75,0.75,0.75h13.5c0.412,0,0.75-0.337,0.75-0.75v-7.5c0-0.413-0.338-0.75-0.75-0.75h-3v4.5
                c0,0.258-0.136,0.501-0.356,0.638c-0.22,0.136-0.497,0.15-0.731,0.033l-2.662-1.332l-2.662,1.332
                c-0.234,0.117-0.512,0.103-0.731-0.033c-0.221-0.136-0.356-0.38-0.356-0.638v-4.5H354.151z M358.651,210.753l1.917-0.957
                c0.211-0.108,0.46-0.108,0.671,0l1.912,0.957v-3.286h-4.5V210.753z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="upstream-button" data-name="upstream-button">
              <circle
                id="circle-xs:svg-2"
                data-name="circle-xs:svg"
                fill="#BFC9FF"
                cx="91.089"
                cy="211.036"
                r="82.703"
              />
              <g id="icons:svg-3" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M53.457,181.327c0.355,0.445,0.623,0.999,0.623,1.631c0,1.261-1.013,2.208-1.959,2.775
                c-0.989,0.595-2.218,0.975-3.184,0.975h-4.706l-4.068,7.116c-0.398,0.703-1.148,1.134-1.955,1.134h-2.634
                c-0.999,0-1.716-0.952-1.444-1.913l1.814-6.337h-2.489l-1.8,2.4c-0.281,0.38-0.727,0.6-1.2,0.6h-1.969
                c-0.778,0-1.406-0.628-1.406-1.406c0-0.131,0.019-0.263,0.057-0.384l1.415-4.959l-1.415-4.955
                c-0.038-0.126-0.057-0.258-0.057-0.389c0-0.778,0.628-1.406,1.406-1.406h1.969c0.474,0,0.919,0.22,1.2,0.6l1.8,2.4h2.489
                l-1.814-6.337c-0.271-0.961,0.45-1.913,1.444-1.913h2.634c0.807,0,1.552,0.431,1.955,1.134l4.068,7.116h4.706
                c0.971,0,2.199,0.394,3.188,0.994C52.627,180.506,53.101,180.881,53.457,181.327z M51.348,181.481
                c-0.812-0.492-1.777-0.778-2.405-0.778h-5.146c-0.268,0-0.516-0.145-0.651-0.379l-4.285-7.486l0.652-0.371l-0.652,0.371
                c-0.131-0.234-0.384-0.38-0.651-0.38h-2.634l2.086,7.294c0.065,0.225,0.019,0.469-0.122,0.656s-0.366,0.3-0.601,0.3H33.08
                c-0.234,0-0.459-0.112-0.6-0.3l-2.025-2.7h-1.847l1.443,5.044c0.038,0.136,0.038,0.276,0,0.412l-1.443,5.044h1.847l2.025-2.7
                c0.141-0.188,0.365-0.3,0.6-0.3h3.857c0.234,0,0.46,0.112,0.601,0.3s0.188,0.432,0.122,0.656l-2.086,7.294h2.634
                c0.268,0,0.516-0.146,0.651-0.38l4.285-7.495c0.136-0.234,0.384-0.38,0.651-0.38h5.142c0.638,0,1.604-0.276,2.41-0.759
                c0.848-0.506,1.232-1.059,1.232-1.486c0-0.192-0.08-0.422-0.295-0.694C52.069,181.992,51.746,181.725,51.348,181.481z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M63.752,180.708c0-3.727,5.372-6.75,12-6.75s12,3.023,12,6.75v1.5v3.75c0,3.314-5.372,6-12,6
                s-12-2.686-12-6v-3.75V180.708z M75.752,185.958c3.104,0,5.841-0.712,7.748-1.786c1.955-1.097,2.752-2.381,2.752-3.464
                s-0.797-2.367-2.752-3.464c-1.907-1.074-4.645-1.786-7.748-1.786s-5.841,0.712-7.748,1.786
                c-1.955,1.097-2.752,2.381-2.752,3.464s0.797,2.367,2.752,3.464C69.912,185.245,72.649,185.958,75.752,185.958z M65.252,183.98
                v1.978c0,0.604,0.398,1.401,1.5,2.194v-2.981c-0.572-0.366-1.078-0.764-1.5-1.195V183.98z M84.752,180.52
                c0,0.722-0.385,1.327-0.891,1.795c-0.511,0.464-1.205,0.853-2.002,1.158c-1.598,0.619-3.759,0.984-6.103,0.984
                s-4.505-0.366-6.104-0.984c-0.797-0.31-1.495-0.694-2.001-1.158c-0.512-0.464-0.891-1.074-0.891-1.795s0.384-1.327,0.891-1.795
                c0.511-0.464,1.204-0.853,2.001-1.158c1.599-0.619,3.76-0.984,6.104-0.984s4.505,0.366,6.103,0.984
                c0.797,0.31,1.496,0.694,2.002,1.158C84.373,179.189,84.752,179.799,84.752,180.52z M75.752,178.083
                c-2.208,0-4.177,0.347-5.564,0.881c-0.693,0.267-1.209,0.572-1.532,0.867c-0.323,0.3-0.403,0.53-0.403,0.689
                s0.08,0.389,0.403,0.689c0.323,0.295,0.834,0.6,1.532,0.867c1.388,0.535,3.356,0.881,5.564,0.881s4.177-0.347,5.564-0.881
                c0.693-0.267,1.209-0.572,1.532-0.867s0.403-0.53,0.403-0.689s-0.08-0.389-0.403-0.689c-0.323-0.295-0.834-0.6-1.532-0.867
                C79.929,178.43,77.96,178.083,75.752,178.083z M70.502,186.778c-0.807-0.22-1.557-0.492-2.25-0.802v3.033
                c0.666,0.305,1.42,0.576,2.25,0.797V186.778z M72.002,187.12v3.014c0.938,0.168,1.945,0.271,3,0.309v-3
                C73.961,187.406,72.954,187.299,72.002,187.12z M76.502,187.449v3c1.055-0.033,2.062-0.141,3-0.31v-3.014
                C78.551,187.303,77.543,187.411,76.502,187.449z M81.002,186.778v3.028c0.83-0.221,1.584-0.492,2.25-0.797v-3.033
                C82.559,186.291,81.809,186.558,81.002,186.778z M86.252,183.98c-0.422,0.431-0.928,0.83-1.5,1.195v2.981
                c1.102-0.792,1.5-1.594,1.5-2.193v-1.979V183.98z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M115.925,170.959c2.484,0,4.5,2.016,4.5,4.5v12c0,2.156-1.519,3.956-3.544,4.397l1.823,1.823
                c0.291,0.291,0.291,0.769,0,1.06c-0.29,0.291-0.769,0.291-1.059,0l-2.78-2.78h-9.881l-2.78,2.78
                c-0.29,0.291-0.769,0.291-1.059,0c-0.291-0.291-0.291-0.769,0-1.06l1.823-1.823c-2.025-0.441-3.544-2.241-3.544-4.397v-12
                c0-2.484,2.016-4.5,4.5-4.5H115.925z M103.925,172.459c-1.654,0-3,1.345-3,3v6h18v-6c0-1.655-1.346-3-3-3H103.925z
                M103.925,190.459h12c1.654,0,3-1.345,3-3v-4.5h-18v4.5C100.925,189.114,102.27,190.459,103.925,190.459z M108.425,186.709
                c0-0.829,0.672-1.5,1.5-1.5s1.5,0.671,1.5,1.5s-0.672,1.5-1.5,1.5S108.425,187.538,108.425,186.709z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M131.097,180.778c0-0.717,0.403-1.298,0.909-1.734c0.511-0.44,1.205-0.802,2.002-1.087
                c1.594-0.586,3.745-0.928,6.089-0.928s4.495,0.342,6.089,0.923c0.792,0.291,1.491,0.652,2.002,1.087
                c0.511,0.436,0.909,1.022,0.909,1.734v4.875v5.339c0,0.722-0.385,1.322-0.896,1.781s-1.204,0.839-2.001,1.144
                c-1.599,0.614-3.76,0.975-6.104,0.975s-4.505-0.361-6.099-0.97c-0.797-0.305-1.49-0.685-2.001-1.144
                c-0.512-0.459-0.9-1.059-0.9-1.781v-5.339V180.778z M132.597,180.778c0,0.112,0.061,0.319,0.389,0.6
                c0.324,0.276,0.835,0.562,1.538,0.815c1.388,0.506,3.36,0.834,5.573,0.834s4.186-0.328,5.578-0.834
                c0.698-0.253,1.209-0.539,1.537-0.815c0.328-0.281,0.39-0.488,0.39-0.6s-0.062-0.319-0.39-0.6
                c-0.323-0.276-0.834-0.562-1.537-0.815c-1.393-0.506-3.365-0.834-5.578-0.834s-4.186,0.328-5.578,0.834
                c-0.698,0.253-1.209,0.539-1.537,0.815c-0.328,0.281-0.39,0.488-0.39,0.6H132.597z M147.597,182.939
                c-0.412,0.253-0.891,0.473-1.411,0.661c-1.594,0.586-3.745,0.928-6.089,0.928s-4.495-0.342-6.089-0.923
                c-0.521-0.188-0.999-0.408-1.411-0.661v2.709c0,0.146,0.075,0.375,0.398,0.666s0.834,0.591,1.533,0.853
                c1.392,0.53,3.355,0.872,5.568,0.872s4.177-0.342,5.568-0.872c0.699-0.267,1.21-0.562,1.533-0.853s0.398-0.52,0.398-0.666
                V182.939z M132.597,190.992c0,0.146,0.075,0.375,0.398,0.666c0.323,0.291,0.834,0.59,1.533,0.853
                c1.392,0.53,3.355,0.876,5.568,0.876s4.177-0.342,5.568-0.872c0.699-0.267,1.21-0.562,1.533-0.853s0.398-0.52,0.398-0.666
                v-3.108c-0.408,0.263-0.881,0.492-1.401,0.689c-1.594,0.609-3.755,0.966-6.099,0.966s-4.505-0.361-6.099-0.97
                c-0.516-0.197-0.989-0.427-1.401-0.689v3.103V190.992z M138.597,174.778c0,0.112,0.061,0.319,0.389,0.6
                c0.066,0.056,0.137,0.112,0.216,0.168c-0.722,0.028-1.425,0.089-2.104,0.183v-0.952c0-0.717,0.403-1.298,0.909-1.734
                c0.511-0.44,1.205-0.802,2.002-1.087c1.594-0.586,3.745-0.928,6.089-0.928s4.495,0.342,6.089,0.923
                c0.792,0.291,1.491,0.652,2.002,1.087c0.506,0.441,0.909,1.022,0.909,1.739v4.875v5.339c0,0.722-0.385,1.322-0.896,1.781
                c-0.511,0.459-1.204,0.839-2.001,1.144c-0.488,0.183-1.022,0.347-1.599,0.483v-1.547c0.384-0.104,0.74-0.216,1.068-0.338
                c0.698-0.267,1.21-0.562,1.533-0.853s0.398-0.52,0.398-0.666v-3.108c-0.408,0.263-0.882,0.492-1.401,0.689
                c-0.488,0.183-1.022,0.347-1.599,0.483v-1.547c0.384-0.103,0.74-0.215,1.068-0.337c0.698-0.267,1.21-0.562,1.533-0.853
                s0.398-0.521,0.398-0.666v-2.719c-0.413,0.253-0.891,0.473-1.411,0.661c-0.811,0.295-1.763,0.53-2.812,0.685
                c-0.089-0.089-0.178-0.178-0.268-0.258c-0.473-0.427-1.017-0.769-1.584-1.055c1.631-0.108,3.065-0.394,4.148-0.788
                c0.698-0.253,1.209-0.539,1.537-0.815c0.328-0.281,0.39-0.488,0.39-0.6c0-0.113-0.062-0.319-0.39-0.6
                c-0.323-0.276-0.834-0.562-1.537-0.815c-1.393-0.497-3.365-0.825-5.578-0.825s-4.186,0.328-5.578,0.834
                c-0.698,0.253-1.209,0.539-1.537,0.815c-0.328,0.281-0.39,0.488-0.39,0.6H138.597z"
                    />
                  </g>
                </g>
              </g>
              <g id="icons:svg-4" data-name="icons:svg">
                <g>
                  <path
                    d="M36.647,206.262c0.216-0.192,0.492-0.295,0.778-0.295c0.807,0,1.369,0.802,1.097,1.561l-3.191,8.939h5.17
              c0.698,0,1.266,0.567,1.266,1.266c0,0.366-0.154,0.708-0.427,0.952L28.88,229.676c-0.211,0.188-0.487,0.291-0.773,0.291
              c-0.807,0-1.369-0.802-1.102-1.561l3.196-8.939h-5.227c-0.665,0-1.209-0.544-1.209-1.209c0-0.347,0.15-0.675,0.408-0.905
              L36.647,206.262z M36.67,208.25l-10.931,9.717h5.526c0.244,0,0.474,0.117,0.614,0.319c0.141,0.202,0.173,0.455,0.094,0.684
              l-3.117,8.729l11.024-9.731h-5.615c-0.244,0-0.474-0.117-0.614-0.319s-0.173-0.455-0.094-0.684l3.112-8.719V208.25z"
                  />
                </g>
                <g>
                  <path
                    d="M69.226,207.027l1.214,1.94h2.208h1.5h0.75c0.412,0,0.75,0.337,0.75,0.75s-0.338,0.75-0.75,0.75h-0.75v15.75
              c0,2.072-1.678,3.75-3.75,3.75h-10.5c-2.072,0-3.75-1.678-3.75-3.75v-15.75h-0.75c-0.412,0-0.75-0.337-0.75-0.75
              s0.338-0.75,0.75-0.75h0.75h1.5h2.208l1.214-1.94c0.412-0.661,1.135-1.06,1.908-1.06h4.336c0.777,0,1.495,0.398,1.907,1.06
              H69.226z M57.648,210.467v15.75c0,1.242,1.008,2.25,2.25,2.25h10.5c1.242,0,2.25-1.008,2.25-2.25v-15.75H57.648z
              M61.398,214.217v10.5c0,0.413-0.338,0.75-0.75,0.75s-0.75-0.337-0.75-0.75v-10.5c0-0.413,0.338-0.75,0.75-0.75
              S61.398,213.804,61.398,214.217z M62.345,207.819l-0.718,1.148h7.041l-0.718-1.148c-0.136-0.22-0.379-0.352-0.637-0.352h-4.336
              c-0.258,0-0.497,0.131-0.638,0.352H62.345z M65.898,214.217v10.5c0,0.413-0.338,0.75-0.75,0.75s-0.75-0.337-0.75-0.75v-10.5
              c0-0.413,0.338-0.75,0.75-0.75S65.898,213.804,65.898,214.217z M70.398,214.217v10.5c0,0.413-0.338,0.75-0.75,0.75
              s-0.75-0.337-0.75-0.75v-10.5c0-0.413,0.338-0.75,0.75-0.75S70.398,213.804,70.398,214.217z"
                  />
                </g>
                <g>
                  <path
                    d="M91.529,225.467c-1.654,0-3-1.345-3-3v-13.5c0-1.655,1.346-3,3-3h13.5c1.654,0,3,1.345,3,3v1.5h3.061
              c0.656,0,1.28,0.286,1.707,0.788l3.688,4.303c0.352,0.408,0.544,0.928,0.544,1.462v6.947h0.75c0.412,0,0.75,0.337,0.75,0.75
              s-0.338,0.75-0.75,0.75h-2.25c0,2.484-2.016,4.5-4.5,4.5s-4.5-2.016-4.5-4.5h-6c0,2.484-2.016,4.5-4.5,4.5
              S91.529,227.951,91.529,225.467z M91.529,207.467c-0.83,0-1.5,0.67-1.5,1.5v13.5c0,0.83,0.67,1.5,1.5,1.5h0.258
              c0.619-1.749,2.283-3,4.242-3s3.628,1.251,4.242,3h6.258v-15c0-0.83-0.67-1.5-1.5-1.5H91.529z M99.029,225.467
              c0-1.072-0.572-2.062-1.5-2.598c-0.928-0.536-2.072-0.536-3,0c-0.928,0.536-1.5,1.526-1.5,2.598s0.572,2.062,1.5,2.598
              c0.928,0.536,2.072,0.536,3,0C98.457,227.529,99.029,226.539,99.029,225.467z M108.029,216.467h7.261l-3.633-4.237
              c-0.141-0.164-0.352-0.263-0.567-0.263h-3.061V216.467z M108.029,217.967v4.144c0.797-0.712,1.847-1.144,3-1.144
              c1.959,0,3.628,1.251,4.242,3h0.258v-6H108.029z M111.029,228.467c1.072,0,2.062-0.572,2.598-1.5c0.536-0.928,0.536-2.072,0-3
              c-0.535-0.928-1.525-1.5-2.598-1.5s-2.062,0.572-2.598,1.5c-0.536,0.928-0.536,2.072,0,3
              C108.967,227.895,109.957,228.467,111.029,228.467z"
                  />
                </g>
                <g>
                  <path
                    fill="#121212"
                    d="M147.536,220.217c1.448,0,2.625,1.177,2.625,2.625c0,0.403-0.089,0.783-0.253,1.125h0.263l4.438-2.644
              c0.394-0.234,0.835-0.356,1.289-0.356h0.062c1.354,0,2.451,1.097,2.451,2.452c0,0.83-0.422,1.603-1.12,2.053l-5.606,3.646
              c-0.849,0.553-1.842,0.849-2.859,0.849h-16.664c-0.412,0-0.75-0.337-0.75-0.75s0.338-0.75,0.75-0.75h16.664
              c0.727,0,1.435-0.211,2.044-0.604l5.61-3.647c0.268-0.173,0.432-0.474,0.432-0.797c0-0.525-0.427-0.952-0.951-0.952h-0.062
              c-0.183,0-0.36,0.047-0.521,0.141l-4.617,2.747c-0.117,0.07-0.248,0.107-0.384,0.107h-2.841h-1.125h-3
              c-0.412,0-0.75-0.337-0.75-0.75c0-0.412,0.338-0.75,0.75-0.75h3h1.125c0.623,0,1.125-0.501,1.125-1.125
              c0-0.623-0.502-1.125-1.125-1.125h-6.966c-0.445,0-0.876,0.131-1.247,0.38l-3.745,2.499c-0.126,0.084-0.267,0.126-0.417,0.126
              h-3c-0.412,0-0.75-0.337-0.75-0.75s0.338-0.75,0.75-0.75h2.775l3.553-2.372c0.619-0.408,1.341-0.628,2.081-0.628H147.536z
              M147.911,205.967h3.75c1.242,0,2.25,1.008,2.25,2.25v7.5c0,1.242-1.008,2.25-2.25,2.25h-13.5c-1.242,0-2.25-1.008-2.25-2.25
              v-7.5c0-1.242,1.008-2.25,2.25-2.25h3.75H147.911z M138.161,207.467c-0.412,0-0.75,0.337-0.75,0.75v7.5
              c0,0.413,0.338,0.75,0.75,0.75h13.5c0.412,0,0.75-0.337,0.75-0.75v-7.5c0-0.413-0.338-0.75-0.75-0.75h-3v4.5
              c0,0.258-0.136,0.501-0.356,0.638c-0.22,0.136-0.497,0.15-0.731,0.033l-2.662-1.332l-2.662,1.332
              c-0.234,0.117-0.512,0.103-0.731-0.033c-0.221-0.136-0.356-0.38-0.356-0.638v-4.5H138.161z M142.661,210.753l1.917-0.957
              c0.211-0.108,0.46-0.108,0.671,0l1.912,0.957v-3.286h-4.5V210.753z"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>

        <div
          id="g-ai3-1"
          class="g-bg g-aiAbs"
          style="top: 4.797%; left: 49.9699%; margin-left: -29.7468%; width: 59.4937%"
        >
          <p class="g-pstyle0 font-weight-bold">Scope 3</p>
        </div>
        <div
          id="g-ai3-2"
          class="g-bg g-aiAbs"
          style="top: 10.3321%; left: 49.9603%; margin-left: -29.8734%; width: 59.7468%"
        >
          <p style="text-align: center">
            Indirect emissions from the value chain typically make up 90% of a company&rsquo;s emissions
          </p>
        </div>

        <div
          type="button"
          button_name="emissions"
          data-toggle="modal"
          data-target="#bubbleModal"
          @click="handleModalMobile('upstream')"
          style="top: 23.8%; left: 2.2%"
          class="g-aiAbs circle-wrapper dtm-button circle-upstream"
        >
          <div class="g-aiAbs circle-label">
            <p class="g-pstyle4">Learn more +</p>
          </div>
        </div>

        <div
          type="button"
          button_name="emissions"
          data-toggle="modal"
          data-target="#bubbleModal"
          @click="handleModalMobile('downstream')"
          style="top: 23.7%; left: 55.6%"
          class="g-aiAbs circle-wrapper dtm-button circle-downstream"
        >
          <div class="g-aiAbs circle-label">
            <p class="g-pstyle4">Learn more +</p>
          </div>
        </div>

        <div
          id="g-ai3-5"
          class="g-bg g-aiAbs"
          style="top: 68.0812%; left: 50.1489%; margin-left: -13.038%; width: 26.0759%"
        >
          <p class="g-pstyle3 font-weight-bold">Reporting company</p>
        </div>
        <div id="g-ai3-6" class="g-bg g-aiAbs" style="top: 68.4502%; left: 8.3314%; width: 17.9747%">
          <p>Upstream</p>
        </div>
        <div id="g-ai3-7" class="g-bg g-aiAbs" style="top: 68.4502%; left: 71.5942%; width: 23.2911%">
          <p>Downstream</p>
        </div>
        <div
          id="g-ai3-8"
          class="g-bg g-aiAbs"
          style="top: 81.5498%; left: 25.3397%; margin-left: -19.2405%; width: 38.481%"
        >
          <p class="g-pstyle4 font-weight-bold">Scope 2</p>
        </div>
        <div id="g-ai3-9" class="g-bg g-aiAbs" style="top: 81.5498%; left: 46.5614%; width: 57.7215%">
          <p class="g-pstyle4 font-weight-bold">Scope 1</p>
        </div>
        <div
          id="g-ai3-10"
          class="g-bg g-aiAbs"
          style="top: 85.9779%; left: 25.3397%; margin-left: -19.2405%; width: 38.481%"
        >
          <p class="g-pstyle1">Indirect emissions</p>
        </div>
        <div
          id="g-ai3-11"
          class="g-bg g-aiAbs"
          style="top: 85.9779%; left: 74.5614%; margin-left: -18.8608%; width: 37.7215%"
        >
          <p class="g-pstyle1">Direct emissions</p>
        </div>
        <div
          id="g-ai3-12"
          class="g-bg g-aiAbs"
          style="top: 90.5904%; left: 25.3308%; margin-left: -19.2405%; width: 38.481%"
        >
          <p class="g-pstyle2">&bull; Purchased energy</p>
        </div>
        <div
          id="g-ai3-13"
          class="g-bg g-aiAbs"
          style="top: 90.5904%; left: 74.5614%; margin-left: -18.8608%; width: 37.7215%"
        >
          <p class="g-pstyle2">&bull; Company facilities</p>
          <p class="g-pstyle2">&bull; Company vehicles</p>
        </div>
      </div>

      <!-- Artboard: _320px -->
      <div
        id="g-UOB-2023-2-_320px"
        class="g-artboard"
        style="max-width: 320px; max-height: 427px"
        data-aspect-ratio="0.749"
        data-min-width="0"
        data-max-width="394"
      >
        <div style="padding: 0 0 133.4375% 0"></div>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-2-_320px-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-2-_320px-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 427"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g id="bg-320px" data-name="bg-320px">
              <circle fill="#F1F1F1" stroke="#005EB8" stroke-dasharray="2,2" cx="160" cy="155.965" r="154.965" />
              <path fill="#BFC9FF" d="M160,269.697H17.709L0,298.457l17.709,28.76H160v-28.76V269.697z" />
              <path fill="#A1E6BD" d="M160,269.697h142.291L320,298.457l-17.709,28.76H160v-28.76V269.697z" />
              <path
                fill="#F1F1F1"
                stroke="#005EB8"
                stroke-dasharray="2,2"
                d="M306.099,337.457h-76.855c0-38.265-31.02-69.285-69.285-69.285
          s-69.285,31.02-69.285,69.285H13.901c-4.813,0-8.715,4.064-8.715,9.077v70.8c0,5.013,3.902,9.077,8.715,9.077h292.199
          c4.813,0,8.715-4.064,8.715-9.077v-70.8C314.814,341.521,310.913,337.457,306.099,337.457z"
              />
              <path
                fill="#005EB8"
                d="M140.827,242.431c0-1.257,1.048-2.365,2.397-2.365h4.793c1.273,0,2.397,1.109,2.397,2.365v11.236
          l11.683-6.284c1.198-0.591,2.696,0.222,2.696,1.626v4.657l11.683-6.284c1.198-0.591,2.696,0.222,2.696,1.626v11.162v9.463
          c0,1.996-1.648,3.548-3.595,3.548h-31.156c-2.022,0-3.595-1.552-3.595-3.548v-5.914v-3.549V242.431z M158.203,260.764
          c-0.675,0-1.199,0.592-1.199,1.183v3.549c0,0.665,0.525,1.183,1.199,1.183h3.594c0.6,0,1.199-0.518,1.199-1.183v-3.549
          c0-0.591-0.6-1.183-1.199-1.183H158.203z M147.417,261.947v3.549c0,0.665,0.525,1.183,1.199,1.183h3.594
          c0.6,0,1.199-0.518,1.199-1.183v-3.549c0-0.591-0.6-1.183-1.199-1.183h-3.594C147.942,260.764,147.417,261.356,147.417,261.947z
          M167.79,260.764c-0.675,0-1.199,0.592-1.199,1.183v3.549c0,0.665,0.525,1.183,1.199,1.183h3.594c0.6,0,1.199-0.518,1.199-1.183
          v-3.549c0-0.591-0.6-1.183-1.199-1.183H167.79z"
              />
              <path
                fill="#005EB8"
                d="M149.058,219.65c1.162,0,2.227,0.722,2.651,1.796l0.198,0.501l0.485-0.234
          c0.281-0.136,0.63-0.211,0.981-0.211c1.31,0,2.376,1.022,2.376,2.277c0,0.216-0.039,0.409-0.092,0.586
          c-0.164,0.044-0.324,0.1-0.479,0.167c-0.874-0.8-2.035-1.253-3.243-1.253c-2.314,0-4.275,1.564-4.738,3.704h-1.494
          c-1.31,0-2.376-1.022-2.376-2.278c0-1.256,1.066-2.277,2.406-2.277h0.437l0.058-0.433
          C146.408,220.658,147.624,219.65,149.058,219.65 M151.934,225.205c1.047,0,2.016,0.568,2.53,1.481l0.351,0.625l0.465-0.545
          c0.344-0.403,0.872-0.635,1.447-0.635c1.046,0,1.897,0.814,1.897,1.816c0,0.117-0.02,0.218-0.049,0.36l-0.127,0.603h0.617h0.06
          c1.31,0,2.376,1.022,2.376,2.278c0,1.256-1.066,2.278-2.376,2.278h-9.587c-1.31,0-2.376-1.022-2.376-2.278
          c0-0.974,0.645-1.841,1.604-2.158l0.408-0.135l-0.072-0.424c-0.022-0.132-0.022-0.313-0.022-0.523
          C149.079,226.435,150.36,225.205,151.934,225.205 M149.058,219.15c-1.707,0-3.116,1.216-3.326,2.778h-0.03
          c-1.588,0-2.876,1.244-2.876,2.777c0,1.534,1.288,2.778,2.876,2.778h1.917c0.24-2.083,2.067-3.704,4.314-3.704
          c1.228,0,2.367,0.521,3.145,1.36c0.3-0.173,0.629-0.289,0.959-0.347c0.12-0.319,0.21-0.637,0.21-1.014
          c0-1.533-1.288-2.777-2.876-2.777c-0.419,0-0.839,0.087-1.198,0.261C151.694,220.046,150.466,219.15,149.058,219.15
          L149.058,219.15z M151.934,224.705c-1.857,0-3.355,1.475-3.355,3.241c0,0.231,0,0.434,0.03,0.607
          c-1.138,0.376-1.947,1.418-1.947,2.633c0,1.534,1.288,2.778,2.876,2.778h9.587c1.588,0,2.876-1.245,2.876-2.778
          c0-1.533-1.288-2.778-2.876-2.778c-0.03,0-0.06,0-0.06,0c0.031-0.145,0.06-0.289,0.06-0.463c0-1.273-1.079-2.316-2.397-2.316
          c-0.749,0-1.408,0.319-1.828,0.81C154.331,225.429,153.222,224.705,151.934,224.705L151.934,224.705z"
              />
              <path
                fill="#005EB8"
                d="M164.157,206.577c1.222,0,2.344,0.771,2.791,1.918l0.197,0.506l0.488-0.238
          c0.301-0.147,0.658-0.225,1.034-0.225c1.382,0,2.507,1.095,2.507,2.441c0,0.239-0.043,0.451-0.102,0.646
          c-0.179,0.048-0.354,0.11-0.522,0.184c-0.911-0.849-2.125-1.329-3.386-1.329c-2.417,0-4.463,1.657-4.936,3.922h-1.579
          c-1.382,0-2.507-1.095-2.507-2.441c0-1.346,1.125-2.441,2.538-2.441h0.438l0.057-0.434
          C161.365,207.655,162.647,206.577,164.157,206.577 M167.164,212.46c1.102,0,2.122,0.606,2.664,1.581l0.352,0.634l0.467-0.555
          c0.364-0.432,0.921-0.68,1.528-0.68c1.106,0,2.006,0.875,2.006,1.952c0,0.133-0.024,0.252-0.053,0.389l-0.123,0.6h0.613h0.063
          c1.382,0,2.507,1.095,2.507,2.441c0,1.346-1.125,2.441-2.507,2.441h-10.022c-1.382,0-2.507-1.095-2.507-2.441
          c0-1.045,0.681-1.975,1.694-2.314l0.406-0.136l-0.072-0.422c-0.024-0.142-0.024-0.335-0.024-0.559
          C164.156,213.775,165.505,212.46,167.164,212.46 M164.157,206.077c-1.785,0-3.258,1.287-3.476,2.941h-0.031
          c-1.66,0-3.007,1.318-3.007,2.941s1.346,2.941,3.007,2.941h2.004c0.25-2.206,2.161-3.922,4.51-3.922
          c1.284,0,2.474,0.552,3.288,1.44c0.314-0.184,0.658-0.306,1.002-0.368c0.126-0.336,0.22-0.674,0.22-1.072
          c0-1.624-1.346-2.941-3.007-2.941c-0.438,0-0.877,0.091-1.253,0.275C166.913,207.027,165.629,206.077,164.157,206.077
          L164.157,206.077z M167.164,211.96c-1.942,0-3.508,1.563-3.508,3.432c0,0.245,0,0.459,0.031,0.643
          c-1.19,0.398-2.036,1.501-2.036,2.788c0,1.624,1.346,2.941,3.007,2.941h10.022c1.66,0,3.007-1.318,3.007-2.941
          s-1.346-2.941-3.007-2.941c-0.031,0-0.063,0-0.063,0c0.031-0.153,0.063-0.307,0.063-0.49c0-1.348-1.128-2.452-2.506-2.452
          c-0.783,0-1.472,0.337-1.91,0.858C169.669,212.726,168.51,211.96,167.164,211.96L167.164,211.96z"
              />
              <g>
                <rect x="22.35" y="348.088" fill="none" width="120.279" height="14.173" />
                <rect x="12.873" y="368.261" fill="none" width="139.233" height="14.173" />
                <rect x="22.35" y="387.434" fill="none" width="120.335" height="14.173" />
              </g>
              <line fill="none" stroke="#A7A8A9" stroke-dasharray="2,2" x1="160" y1="341.814" x2="160" y2="422.096" />
              <rect x="179.57" y="348.088" fill="none" width="117.527" height="14.173" />
              <rect x="168.139" y="368.261" fill="none" width="140.389" height="14.173" />
              <rect x="67.043" y="20.878" fill="none" width="185.914" height="17.444" />
            </g>
            <g id="downstream-button-2" data-name="downstream-button">
              <circle
                id="circle-xs:svg-3"
                data-name="circle-xs:svg"
                fill="#A1E6BD"
                cx="243.165"
                cy="165.733"
                r="65.363"
              />
              <g id="icons:svg-5" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M200.197,136.959c0-0.819,0.663-1.482,1.482-1.482h18.375c0.819,0,1.482,0.663,1.482,1.482v0.593
                c0,0.752-0.56,1.371-1.286,1.467v0.015l-0.904,10.866c-0.103,1.23-1.13,2.175-2.363,2.175h-12.233
                c-1.233,0-2.26-0.945-2.363-2.175l-0.908-10.866v-0.015c-0.722-0.096-1.282-0.715-1.282-1.467V136.959z M201.678,136.663
                c-0.163,0-0.296,0.134-0.296,0.296v0.593c0,0.163,0.134,0.296,0.296,0.296h0.893h16.589h0.893c0.163,0,0.296-0.134,0.296-0.296
                v-0.593c0-0.163-0.134-0.296-0.296-0.296H201.678z M204.749,150.889h12.233c0.618,0,1.13-0.47,1.182-1.086l0.897-10.769h-16.39
                l0.897,10.769C203.62,150.415,204.134,150.889,204.749,150.889z M207.68,144.258c0.293,0.185,0.367,0.578,0.163,0.856
                l-1.023,1.385c-0.066,0.093-0.103,0.2-0.103,0.311c0,0.289,0.233,0.523,0.523,0.523h2.441c0.326,0,0.593,0.267,0.593,0.593
                c0,0.326-0.267,0.593-0.593,0.593h-2.441c-0.945,0-1.708-0.763-1.708-1.708c0-0.367,0.119-0.722,0.333-1.015l1.019-1.382
                c0.185-0.252,0.529-0.315,0.793-0.152L207.68,144.258z M210.399,141.642l-1.148,1.56c-0.185,0.252-0.529,0.315-0.793,0.152
                c-0.293-0.185-0.367-0.578-0.163-0.856l1.148-1.56c0.333-0.452,0.859-0.719,1.422-0.719c0.563,0,1.089,0.267,1.422,0.719
                l1.148,1.56c0.204,0.278,0.13,0.674-0.163,0.856c-0.263,0.163-0.607,0.096-0.793-0.152l-1.148-1.56
                c-0.107-0.148-0.282-0.237-0.467-0.237C210.681,141.405,210.51,141.494,210.399,141.642z M212.052,147.332h2.437
                c0.289,0,0.523-0.233,0.523-0.523c0-0.111-0.033-0.222-0.1-0.311l-1.023-1.385c-0.204-0.278-0.13-0.675,0.163-0.856
                c0.263-0.163,0.607-0.096,0.793,0.152l1.023,1.385c0.218,0.296,0.333,0.652,0.333,1.015c0,0.945-0.763,1.708-1.708,1.708
                h-2.441c-0.326,0-0.593-0.267-0.593-0.593C211.459,147.599,211.726,147.332,212.052,147.332z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M232.939,149.703c-1.307,0-2.371-1.063-2.371-2.371v-10.67c0-1.308,1.064-2.371,2.371-2.371h10.67
                c1.307,0,2.371,1.063,2.371,2.371v1.186h2.419c0.519,0,1.012,0.226,1.349,0.622l2.915,3.401c0.278,0.322,0.43,0.733,0.43,1.156
                v5.49h0.593c0.326,0,0.593,0.267,0.593,0.593c0,0.326-0.267,0.593-0.593,0.593h-1.778c0,1.963-1.593,3.557-3.557,3.557
                s-3.557-1.593-3.557-3.557h-4.742c0,1.963-1.593,3.557-3.557,3.557S232.939,151.667,232.939,149.703z M232.939,135.477
                c-0.656,0-1.186,0.53-1.186,1.186v10.67c0,0.656,0.529,1.186,1.186,1.186h0.204c0.489-1.382,1.804-2.371,3.353-2.371
                s2.867,0.989,3.353,2.371h4.946v-11.855c0-0.656-0.529-1.186-1.186-1.186H232.939z M238.867,149.703
                c0-0.847-0.452-1.63-1.186-2.053c-0.733-0.423-1.638-0.423-2.371,0c-0.733,0.424-1.186,1.206-1.186,2.053
                s0.452,1.63,1.186,2.053c0.733,0.423,1.638,0.423,2.371,0C238.414,151.333,238.867,150.55,238.867,149.703z M245.98,142.59
                h5.738l-2.871-3.349c-0.111-0.13-0.278-0.208-0.448-0.208h-2.419V142.59z M245.98,143.776v3.275
                c0.63-0.563,1.459-0.904,2.371-0.904c1.548,0,2.867,0.989,3.353,2.371h0.204v-4.742H245.98z M248.351,152.074
                c0.847,0,1.63-0.452,2.053-1.186c0.424-0.734,0.424-1.637,0-2.371c-0.423-0.734-1.206-1.186-2.053-1.186
                c-0.847,0-1.63,0.452-2.053,1.186c-0.424,0.734-0.424,1.637,0,2.371C246.72,151.622,247.503,152.074,248.351,152.074z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M274.721,141.301l8.88-1.03c0.522-0.059,1.019,0.23,1.226,0.712l1.186,2.767
                c0.364,0.848-0.13,1.819-1.03,2.026l-5.898,1.367c-0.7,0.159-1.429-0.115-1.849-0.7l-2.515-3.523l-2.515,3.516
                c-0.419,0.585-1.148,0.863-1.848,0.7l-5.898-1.36c-0.9-0.208-1.393-1.178-1.026-2.023l1.185-2.767
                c0.208-0.482,0.704-0.771,1.226-0.711L274.721,141.301z M265.704,141.453l-1.185,2.767c-0.07,0.167,0.025,0.363,0.208,0.404
                l5.901,1.36c0.233,0.052,0.474-0.037,0.615-0.233l2.412-3.379l-7.947-0.919H265.704z M283.023,147.21l1.185-0.337v2.63
                c0,0.819-0.556,1.53-1.348,1.726l-7.706,1.926c-0.286,0.071-0.582,0.071-0.864,0l-7.706-1.926
                c-0.793-0.2-1.348-0.911-1.348-1.726v-2.63l1.186,0.337v2.29c0,0.274,0.185,0.511,0.448,0.574l7.257,1.815v-5.15
                c0-0.326,0.267-0.593,0.593-0.593s0.593,0.267,0.593,0.593v5.15l7.257-1.815c0.263-0.067,0.448-0.304,0.448-0.574v-2.29
                H283.023z M268.794,139.034c0,0.326-0.267,0.593-0.593,0.593c-0.326,0-0.593-0.267-0.593-0.593
                c0-2.619,2.122-4.742,4.742-4.742c2.62,0,4.742,2.123,4.742,4.742c0,0.326-0.267,0.593-0.593,0.593
                c-0.326,0-0.593-0.267-0.593-0.593c0-1.963-1.593-3.557-3.557-3.557C270.387,135.477,268.794,137.07,268.794,139.034z
                M275.792,142.372l2.412,3.379c0.137,0.196,0.381,0.289,0.615,0.233l5.894-1.36c0.181-0.041,0.281-0.233,0.207-0.404
                l-1.185-2.767l-7.947,0.919H275.792z M280.026,139.223c-0.104,0.311-0.438,0.478-0.749,0.374s-0.478-0.437-0.374-0.748
                l1.186-3.557c0.104-0.311,0.438-0.478,0.749-0.374c0.311,0.104,0.478,0.437,0.374,0.749L280.026,139.223z"
                    />
                  </g>
                </g>
              </g>
              <g id="icons:svg-6" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M186.583,168.61c0-0.237,0.059-0.47,0.174-0.678l2.878-5.279c0.311-0.57,0.908-0.926,1.56-0.926h14.485
                c0.652,0,1.249,0.356,1.56,0.926l2.878,5.275c0.115,0.208,0.174,0.441,0.174,0.678c0,0.782-0.634,1.415-1.416,1.415h-0.955
                v10.081c0,0.326-0.267,0.593-0.593,0.593c-0.326,0-0.593-0.267-0.593-0.593v-10.077H190.14v4.742h9.484v-2.964v-0.593h1.186
                v0.593v7.113c0,0.982-0.797,1.778-1.778,1.778h-8.299c-0.982,0-1.778-0.797-1.778-1.778v-8.891h-0.955
                C187.217,170.025,186.583,169.391,186.583,168.61z M189.547,168.839h17.783h1.548c0.127,0,0.23-0.104,0.23-0.23
                c0-0.037-0.011-0.078-0.029-0.111l-2.875-5.279c-0.104-0.189-0.304-0.308-0.519-0.308h-14.485
                c-0.218,0-0.415,0.118-0.519,0.308l-2.883,5.279c-0.019,0.033-0.029,0.07-0.029,0.111c0,0.126,0.103,0.23,0.23,0.23H189.547z
                M190.14,178.916c0,0.326,0.267,0.593,0.593,0.593h8.299c0.326,0,0.593-0.267,0.593-0.593v-2.964h-9.484V178.916z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M241.889,161.727c0.326,0,0.593,0.267,0.593,0.593c0,0.326-0.267,0.593-0.593,0.593h-7.113
                c-0.982,0-1.778,0.797-1.778,1.778v11.081l1.326-0.36l0.019-0.003c0.493-1.738,2.093-3.012,3.99-3.012
                c2.293,0,4.149,1.856,4.149,4.149s-1.856,4.149-4.149,4.149c-2.249,0-4.079-1.786-4.145-4.016l-14.667,3.993
                c-0.315,0.089-0.638-0.1-0.726-0.415c-0.089-0.315,0.1-0.641,0.414-0.726l12.618-3.442c-0.007-0.044-0.015-0.089-0.015-0.137
                V164.69c0-1.637,1.326-2.964,2.964-2.964H241.889z M226.192,166.436c0.634-0.171,1.282,0.204,1.453,0.837l1.53,5.728
                c0.171,0.633-0.204,1.282-0.837,1.452l-5.724,1.534c-0.634,0.171-1.282-0.204-1.453-0.837l-1.534-5.728
                c-0.171-0.633,0.204-1.282,0.837-1.452L226.192,166.436z M221.916,168.807l-1.145,0.307l1.534,5.728l5.728-1.534l-1.534-5.724
                l-1.145,0.307l0.537,2.004c0.126,0.474-0.156,0.963-0.63,1.089l-1.72,0.46c-0.474,0.126-0.963-0.156-1.089-0.63l-0.537-2.004
                V168.807z M223.065,168.502l0.459,1.719l1.145-0.308l-0.463-1.719l-1.145,0.307H223.065z M235.765,175.064
                c-0.529,0.917-0.529,2.047,0,2.964c0.529,0.917,1.508,1.482,2.567,1.482c1.059,0,2.038-0.565,2.567-1.482
                c0.529-0.917,0.529-2.047,0-2.964c-0.529-0.917-1.508-1.482-2.567-1.482C237.273,173.582,236.295,174.147,235.765,175.064z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M269.773,163.105c0.219,0.241,0.204,0.619-0.04,0.837l-6.52,5.928
                c-0.234,0.211-0.593,0.204-0.819-0.019l-4.379-4.383l-6.113,4.442c-0.263,0.193-0.637,0.134-0.83-0.13
                c-0.193-0.263-0.134-0.637,0.13-0.83l6.52-4.742c0.237-0.171,0.563-0.144,0.767,0.059l4.345,4.345l6.102-5.546
                c0.241-0.218,0.618-0.204,0.837,0.041V163.105z M253.332,173.582c0.982,0,1.778,0.797,1.778,1.778v2.371
                c0,0.982-0.796,1.778-1.778,1.778c-0.982,0-1.778-0.797-1.778-1.778v-2.371C251.554,174.378,252.351,173.582,253.332,173.582z
                M253.925,177.731v-2.371c0-0.326-0.267-0.593-0.593-0.593s-0.593,0.267-0.593,0.593v2.371c0,0.326,0.267,0.593,0.593,0.593
                S253.925,178.057,253.925,177.731z M256.296,171.803c0-0.982,0.797-1.778,1.778-1.778s1.778,0.797,1.778,1.778v5.928
                c0,0.982-0.797,1.778-1.778,1.778s-1.778-0.797-1.778-1.778V171.803z M258.667,171.803c0-0.326-0.267-0.593-0.593-0.593
                s-0.593,0.267-0.593,0.593v5.928c0,0.326,0.267,0.593,0.593,0.593s0.593-0.267,0.593-0.593V171.803z M262.816,172.396
                c0.982,0,1.778,0.797,1.778,1.778v3.557c0,0.982-0.797,1.778-1.778,1.778s-1.778-0.797-1.778-1.778v-3.557
                C261.038,173.193,261.835,172.396,262.816,172.396z M263.409,177.731v-3.557c0-0.326-0.267-0.593-0.593-0.593
                s-0.593,0.267-0.593,0.593v3.557c0,0.326,0.267,0.593,0.593,0.593S263.409,178.057,263.409,177.731z M265.78,171.803
                c0-0.982,0.797-1.778,1.778-1.778c0.982,0,1.778,0.797,1.778,1.778v5.928c0,0.982-0.797,1.778-1.778,1.778
                c-0.982,0-1.778-0.797-1.778-1.778V171.803z M268.151,171.803c0-0.326-0.267-0.593-0.593-0.593
                c-0.326,0-0.593,0.267-0.593,0.593v5.928c0,0.326,0.267,0.593,0.593,0.593c0.326,0,0.593-0.267,0.593-0.593V171.803z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M291.152,172.989c1.145,0,2.075,0.93,2.075,2.075c0,0.319-0.07,0.619-0.2,0.889h0.208l3.508-2.089
                c0.311-0.185,0.66-0.282,1.019-0.282h0.049c1.07,0,1.937,0.867,1.937,1.938c0,0.656-0.333,1.267-0.885,1.623l-4.431,2.882
                c-0.671,0.437-1.456,0.671-2.26,0.671H279c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h13.17
                c0.574,0,1.134-0.167,1.615-0.478l4.434-2.882c0.211-0.137,0.341-0.374,0.341-0.63c0-0.415-0.337-0.752-0.752-0.752h-0.049
                c-0.144,0-0.285,0.037-0.411,0.111l-3.649,2.171c-0.093,0.056-0.196,0.085-0.303,0.085h-2.245h-0.889h-2.371
                c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h2.371h0.889c0.492,0,0.889-0.396,0.889-0.889
                c0-0.492-0.397-0.889-0.889-0.889h-5.505c-0.352,0-0.692,0.104-0.986,0.3l-2.96,1.975c-0.1,0.067-0.211,0.1-0.33,0.1H279
                c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h2.193l2.808-1.875c0.489-0.322,1.06-0.496,1.645-0.496
                H291.152z M291.448,161.727h2.964c0.982,0,1.778,0.797,1.778,1.778v5.928c0,0.982-0.797,1.778-1.778,1.778h-10.669
                c-0.982,0-1.778-0.797-1.778-1.778v-5.928c0-0.982,0.797-1.778,1.778-1.778h2.964H291.448z M283.742,162.912
                c-0.326,0-0.593,0.267-0.593,0.593v5.928c0,0.326,0.267,0.593,0.593,0.593h10.669c0.326,0,0.593-0.267,0.593-0.593v-5.928
                c0-0.326-0.267-0.593-0.593-0.593h-2.371v3.557c0,0.204-0.107,0.396-0.282,0.504c-0.174,0.107-0.393,0.118-0.578,0.026
                l-2.104-1.052l-2.104,1.052c-0.185,0.093-0.404,0.081-0.578-0.026c-0.174-0.108-0.282-0.3-0.282-0.504v-3.557H283.742z
                M287.299,165.509l1.515-0.756c0.167-0.085,0.364-0.085,0.53,0l1.511,0.756v-2.597h-3.557V165.509z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="upstream-button-2" data-name="upstream-button">
              <circle
                id="circle-xs:svg-4"
                data-name="circle-xs:svg"
                fill="#BFC9FF"
                cx="76.835"
                cy="165.733"
                r="65.363"
              />
              <g id="icons:svg-7" data-name="icons:svg">
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M47.094,142.253c0.281,0.352,0.492,0.789,0.492,1.289c0,0.996-0.8,1.745-1.548,2.193
                c-0.782,0.47-1.753,0.771-2.516,0.771h-3.719l-3.215,5.624c-0.315,0.556-0.908,0.896-1.545,0.896H32.96
                c-0.79,0-1.356-0.752-1.142-1.512l1.434-5.009h-1.967l-1.422,1.897c-0.222,0.3-0.574,0.474-0.949,0.474h-1.556
                c-0.615,0-1.111-0.496-1.111-1.111c0-0.104,0.015-0.208,0.045-0.304l1.118-3.92l-1.118-3.916
                c-0.03-0.1-0.045-0.204-0.045-0.308c0-0.615,0.496-1.111,1.111-1.111h1.556c0.374,0,0.726,0.174,0.949,0.474l1.422,1.897h1.967
                l-1.434-5.009c-0.215-0.759,0.356-1.512,1.142-1.512h2.082c0.638,0,1.226,0.341,1.545,0.896l3.215,5.624h3.719
                c0.767,0,1.738,0.311,2.519,0.785C46.438,141.604,46.812,141.901,47.094,142.253z M45.427,142.375
                c-0.641-0.389-1.405-0.615-1.901-0.615h-4.067c-0.211,0-0.408-0.115-0.515-0.3l-3.387-5.916l0.516-0.293l-0.516,0.293
                c-0.103-0.185-0.303-0.3-0.515-0.3H32.96l1.649,5.765c0.052,0.178,0.015,0.37-0.096,0.519
                c-0.111,0.148-0.289,0.237-0.475,0.237h-3.049c-0.185,0-0.363-0.089-0.474-0.237l-1.601-2.134h-1.459l1.141,3.986
                c0.03,0.107,0.03,0.218,0,0.326l-1.141,3.986h1.459l1.601-2.134c0.111-0.148,0.289-0.237,0.474-0.237h3.049
                c0.185,0,0.364,0.089,0.475,0.237c0.111,0.148,0.148,0.341,0.096,0.519l-1.649,5.765h2.082c0.211,0,0.408-0.115,0.515-0.3
                l3.387-5.924c0.107-0.185,0.303-0.3,0.515-0.3h4.064c0.504,0,1.267-0.218,1.905-0.6c0.67-0.4,0.974-0.837,0.974-1.174
                c0-0.152-0.063-0.333-0.233-0.548C45.997,142.779,45.742,142.568,45.427,142.375z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M55.231,141.764c0-2.945,4.246-5.335,9.484-5.335s9.484,2.39,9.484,5.335v1.186v2.964
                c0,2.619-4.246,4.742-9.484,4.742s-9.484-2.123-9.484-4.742v-2.964V141.764z M64.715,145.913c2.453,0,4.616-0.563,6.124-1.412
                c1.545-0.867,2.175-1.882,2.175-2.738c0-0.856-0.63-1.871-2.175-2.738c-1.507-0.849-3.671-1.412-6.124-1.412
                s-4.616,0.563-6.124,1.412c-1.545,0.867-2.175,1.882-2.175,2.738c0,0.856,0.63,1.871,2.175,2.738
                C60.098,145.35,62.262,145.913,64.715,145.913z M56.416,144.35v1.563c0,0.478,0.315,1.108,1.186,1.734v-2.356
                c-0.452-0.289-0.852-0.604-1.186-0.945V144.35z M71.828,141.615c0,0.57-0.304,1.048-0.704,1.419
                c-0.404,0.367-0.952,0.674-1.582,0.915c-1.263,0.489-2.971,0.778-4.823,0.778c-1.852,0-3.56-0.289-4.824-0.778
                c-0.63-0.245-1.182-0.548-1.581-0.915c-0.404-0.367-0.704-0.849-0.704-1.419c0-0.57,0.303-1.049,0.704-1.419
                c0.404-0.367,0.952-0.674,1.581-0.915c1.263-0.489,2.971-0.778,4.824-0.778c1.852,0,3.56,0.289,4.823,0.778
                c0.63,0.245,1.182,0.548,1.582,0.915C71.527,140.564,71.828,141.045,71.828,141.615z M64.715,139.689
                c-1.745,0-3.301,0.274-4.398,0.697c-0.548,0.211-0.956,0.452-1.211,0.685c-0.255,0.237-0.319,0.419-0.319,0.545
                c0,0.126,0.063,0.308,0.319,0.545c0.255,0.233,0.659,0.474,1.211,0.685c1.097,0.423,2.653,0.697,4.398,0.697
                s3.301-0.274,4.398-0.697c0.548-0.211,0.955-0.452,1.211-0.685s0.319-0.419,0.319-0.545c0-0.126-0.063-0.308-0.319-0.545
                c-0.255-0.233-0.659-0.474-1.211-0.685C68.016,139.963,66.46,139.689,64.715,139.689z M60.565,146.561
                c-0.638-0.174-1.23-0.389-1.778-0.634v2.397c0.526,0.241,1.122,0.455,1.778,0.63V146.561z M61.751,146.832v2.382
                c0.741,0.133,1.537,0.215,2.371,0.244v-2.371C63.299,147.058,62.503,146.973,61.751,146.832z M65.307,147.091v2.371
                c0.834-0.026,1.63-0.111,2.371-0.245v-2.382C66.927,146.976,66.13,147.061,65.307,147.091z M68.864,146.561v2.393
                c0.656-0.174,1.252-0.389,1.778-0.63v-2.397C70.094,146.176,69.501,146.387,68.864,146.561z M73.013,144.35
                c-0.333,0.341-0.733,0.656-1.186,0.945v2.356c0.871-0.626,1.186-1.26,1.186-1.733v-1.564V144.35z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M96.464,134.059c1.963,0,3.557,1.593,3.557,3.557v9.484c0,1.704-1.2,3.127-2.801,3.475l1.441,1.441
                c0.23,0.23,0.23,0.608,0,0.837c-0.229,0.23-0.607,0.23-0.837,0l-2.197-2.197h-7.809l-2.197,2.197
                c-0.229,0.23-0.607,0.23-0.837,0c-0.23-0.23-0.23-0.608,0-0.837l1.441-1.441c-1.601-0.348-2.801-1.771-2.801-3.475v-9.484
                c0-1.963,1.593-3.557,3.557-3.557H96.464z M86.98,135.244c-1.307,0-2.371,1.063-2.371,2.371v4.742h14.226v-4.742
                c0-1.308-1.064-2.371-2.371-2.371H86.98z M86.98,149.47h9.484c1.307,0,2.371-1.063,2.371-2.371v-3.557H84.609v3.557
                C84.609,148.407,85.673,149.47,86.98,149.47z M90.536,146.507c0-0.655,0.531-1.186,1.186-1.186s1.186,0.531,1.186,1.186
                s-0.531,1.186-1.186,1.186S90.536,147.161,90.536,146.507z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#121212"
                      d="M108.455,141.819c0-0.567,0.319-1.026,0.719-1.371c0.404-0.348,0.952-0.634,1.582-0.859
                c1.26-0.463,2.96-0.734,4.812-0.734c1.852,0,3.553,0.271,4.812,0.73c0.626,0.23,1.179,0.515,1.582,0.859
                c0.404,0.345,0.719,0.808,0.719,1.371v3.853v4.22c0,0.57-0.304,1.045-0.708,1.408c-0.404,0.363-0.952,0.663-1.581,0.904
                c-1.263,0.485-2.971,0.771-4.824,0.771c-1.852,0-3.56-0.285-4.82-0.767c-0.63-0.241-1.178-0.541-1.581-0.904
                c-0.404-0.363-0.712-0.837-0.712-1.408v-4.219V141.819z M109.641,141.819c0,0.089,0.048,0.252,0.307,0.474
                c0.256,0.218,0.66,0.445,1.216,0.644c1.097,0.4,2.656,0.66,4.405,0.66c1.749,0,3.308-0.259,4.409-0.66
                c0.552-0.2,0.955-0.426,1.215-0.644c0.259-0.222,0.308-0.386,0.308-0.474s-0.049-0.252-0.308-0.474
                c-0.255-0.218-0.659-0.445-1.215-0.644c-1.101-0.4-2.66-0.66-4.409-0.66c-1.749,0-3.308,0.259-4.409,0.66
                c-0.552,0.2-0.955,0.426-1.215,0.644c-0.259,0.222-0.308,0.386-0.308,0.474H109.641z M121.496,143.527
                c-0.326,0.2-0.704,0.374-1.115,0.522c-1.26,0.463-2.96,0.734-4.812,0.734c-1.852,0-3.553-0.271-4.812-0.73
                c-0.411-0.148-0.79-0.322-1.115-0.523v2.141c0,0.115,0.059,0.296,0.315,0.526s0.659,0.467,1.212,0.674
                c1.1,0.419,2.652,0.689,4.401,0.689c1.749,0,3.301-0.271,4.401-0.689c0.553-0.211,0.956-0.445,1.212-0.674
                c0.255-0.23,0.315-0.411,0.315-0.526V143.527z M109.641,149.892c0,0.115,0.059,0.296,0.315,0.526
                c0.255,0.23,0.659,0.467,1.212,0.674c1.1,0.419,2.652,0.693,4.401,0.693c1.749,0,3.301-0.271,4.401-0.689
                c0.553-0.211,0.956-0.445,1.212-0.674c0.255-0.23,0.315-0.411,0.315-0.526v-2.456c-0.323,0.208-0.696,0.389-1.108,0.545
                c-1.26,0.482-2.968,0.763-4.82,0.763c-1.852,0-3.56-0.285-4.82-0.767c-0.408-0.156-0.782-0.337-1.108-0.545v2.452V149.892z
                M114.383,137.077c0,0.089,0.048,0.252,0.307,0.474c0.052,0.044,0.108,0.089,0.171,0.133c-0.57,0.022-1.126,0.071-1.663,0.145
                v-0.752c0-0.567,0.319-1.026,0.719-1.371c0.404-0.348,0.952-0.634,1.582-0.859c1.26-0.463,2.96-0.734,4.812-0.734
                c1.852,0,3.553,0.271,4.812,0.73c0.626,0.23,1.179,0.515,1.582,0.859c0.4,0.348,0.719,0.808,0.719,1.375v3.853v4.219
                c0,0.571-0.304,1.045-0.708,1.408c-0.404,0.363-0.952,0.663-1.581,0.904c-0.386,0.144-0.808,0.274-1.263,0.382v-1.223
                c0.303-0.082,0.585-0.171,0.844-0.267c0.552-0.211,0.956-0.445,1.212-0.674s0.315-0.411,0.315-0.526v-2.456
                c-0.323,0.208-0.697,0.389-1.108,0.545c-0.386,0.145-0.808,0.274-1.263,0.382v-1.223c0.303-0.081,0.585-0.17,0.844-0.267
                c0.552-0.211,0.956-0.445,1.212-0.674c0.255-0.23,0.315-0.411,0.315-0.526v-2.149c-0.326,0.2-0.704,0.374-1.115,0.522
                c-0.641,0.233-1.393,0.419-2.223,0.541c-0.07-0.071-0.14-0.141-0.211-0.204c-0.374-0.337-0.803-0.608-1.252-0.834
                c1.289-0.085,2.423-0.311,3.279-0.622c0.552-0.2,0.956-0.426,1.215-0.644c0.259-0.222,0.308-0.386,0.308-0.474
                c0-0.089-0.049-0.252-0.308-0.474c-0.255-0.218-0.659-0.445-1.215-0.644c-1.101-0.393-2.66-0.652-4.409-0.652
                s-3.308,0.259-4.409,0.66c-0.552,0.2-0.956,0.426-1.215,0.644c-0.259,0.222-0.308,0.386-0.308,0.474H114.383z"
                    />
                  </g>
                </g>
              </g>
              <g id="icons:svg-8" data-name="icons:svg">
                <g>
                  <path
                    d="M33.808,161.96c0.171-0.152,0.389-0.233,0.615-0.233c0.638,0,1.082,0.634,0.867,1.234l-2.522,7.065h4.086
              c0.552,0,1,0.448,1,1c0,0.289-0.122,0.56-0.337,0.752l-9.847,8.687c-0.167,0.148-0.385,0.23-0.611,0.23
              c-0.638,0-1.082-0.634-0.871-1.234l2.526-7.065h-4.131c-0.526,0-0.956-0.43-0.956-0.956c0-0.274,0.119-0.533,0.323-0.715
              L33.808,161.96z M33.826,163.531l-8.639,7.68h4.368c0.193,0,0.374,0.093,0.485,0.252s0.137,0.359,0.074,0.541l-2.464,6.898
              l8.713-7.691h-4.438c-0.193,0-0.374-0.093-0.485-0.252c-0.111-0.159-0.137-0.359-0.074-0.541l2.46-6.891V163.531z"
                  />
                </g>
                <g>
                  <path
                    d="M59.556,162.564l0.959,1.534h1.745h1.186h0.593c0.326,0,0.593,0.267,0.593,0.593c0,0.326-0.267,0.593-0.593,0.593
              h-0.593v12.448c0,1.637-1.326,2.964-2.964,2.964h-8.299c-1.638,0-2.964-1.326-2.964-2.964v-12.448h-0.593
              c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h0.593h1.186h1.745l0.959-1.534
              c0.326-0.523,0.897-0.837,1.508-0.837h3.427c0.614,0,1.182,0.315,1.507,0.837H59.556z M50.406,165.283v12.448
              c0,0.982,0.797,1.778,1.778,1.778h8.299c0.982,0,1.778-0.797,1.778-1.778v-12.448H50.406z M53.369,168.247v8.299
              c0,0.326-0.267,0.593-0.593,0.593c-0.326,0-0.593-0.267-0.593-0.593v-8.299c0-0.326,0.267-0.593,0.593-0.593
              C53.102,167.654,53.369,167.921,53.369,168.247z M54.118,163.19l-0.567,0.908h5.565l-0.567-0.908
              c-0.107-0.174-0.299-0.278-0.503-0.278h-3.427c-0.204,0-0.393,0.104-0.504,0.278H54.118z M56.926,168.247v8.299
              c0,0.326-0.267,0.593-0.593,0.593c-0.326,0-0.593-0.267-0.593-0.593v-8.299c0-0.326,0.267-0.593,0.593-0.593
              C56.659,167.654,56.926,167.921,56.926,168.247z M60.482,168.247v8.299c0,0.326-0.267,0.593-0.593,0.593
              s-0.593-0.267-0.593-0.593v-8.299c0-0.326,0.267-0.593,0.593-0.593S60.482,167.921,60.482,168.247z"
                  />
                </g>
                <g>
                  <path
                    d="M77.184,177.138c-1.307,0-2.371-1.063-2.371-2.371v-10.669c0-1.308,1.064-2.371,2.371-2.371h10.67
              c1.307,0,2.371,1.063,2.371,2.371v1.186h2.419c0.519,0,1.012,0.226,1.349,0.622l2.915,3.401c0.278,0.322,0.43,0.733,0.43,1.156
              v5.49h0.593c0.326,0,0.593,0.267,0.593,0.593c0,0.326-0.267,0.593-0.593,0.593h-1.778c0,1.963-1.593,3.557-3.556,3.557
              c-1.963,0-3.557-1.593-3.557-3.557h-4.742c0,1.963-1.593,3.557-3.557,3.557C78.777,180.695,77.184,179.102,77.184,177.138z
              M77.184,162.912c-0.656,0-1.186,0.53-1.186,1.186v10.669c0,0.656,0.529,1.186,1.186,1.186h0.204
              c0.489-1.382,1.804-2.371,3.353-2.371c1.548,0,2.867,0.989,3.353,2.371h4.946v-11.855c0-0.656-0.529-1.186-1.186-1.186H77.184z
              M83.111,177.138c0-0.847-0.452-1.63-1.186-2.053c-0.733-0.423-1.638-0.423-2.371,0c-0.733,0.424-1.186,1.206-1.186,2.053
              s0.452,1.63,1.186,2.053c0.733,0.423,1.638,0.423,2.371,0C82.659,178.768,83.111,177.985,83.111,177.138z M90.224,170.025h5.738
              l-2.871-3.349c-0.111-0.13-0.278-0.208-0.448-0.208h-2.419V170.025z M90.224,171.211v3.275c0.63-0.563,1.459-0.904,2.371-0.904
              c1.548,0,2.867,0.989,3.353,2.371h0.204v-4.742H90.224z M92.595,179.509c0.847,0,1.63-0.452,2.053-1.186
              c0.424-0.734,0.424-1.637,0-2.371c-0.423-0.734-1.206-1.186-2.053-1.186c-0.847,0-1.63,0.452-2.053,1.186
              c-0.424,0.734-0.424,1.637,0,2.371C90.965,179.057,91.748,179.509,92.595,179.509z"
                  />
                </g>
                <g>
                  <path
                    fill="#121212"
                    d="M121.448,172.989c1.145,0,2.075,0.93,2.075,2.075c0,0.319-0.07,0.619-0.2,0.889h0.208l3.508-2.089
              c0.311-0.185,0.66-0.282,1.019-0.282h0.049c1.07,0,1.937,0.867,1.937,1.938c0,0.656-0.333,1.267-0.885,1.623l-4.431,2.882
              c-0.671,0.437-1.456,0.671-2.26,0.671h-13.17c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h13.17
              c0.574,0,1.134-0.167,1.615-0.478l4.434-2.882c0.211-0.137,0.341-0.374,0.341-0.63c0-0.415-0.337-0.752-0.752-0.752h-0.049
              c-0.144,0-0.285,0.037-0.411,0.111l-3.649,2.171c-0.093,0.056-0.196,0.085-0.303,0.085h-2.245h-0.889h-2.371
              c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h2.371h0.889c0.492,0,0.889-0.396,0.889-0.889
              c0-0.492-0.397-0.889-0.889-0.889h-5.505c-0.352,0-0.692,0.104-0.986,0.3l-2.96,1.975c-0.1,0.067-0.211,0.1-0.33,0.1h-2.371
              c-0.326,0-0.593-0.267-0.593-0.593c0-0.326,0.267-0.593,0.593-0.593h2.193l2.808-1.875c0.489-0.322,1.06-0.496,1.645-0.496
              H121.448z M121.744,161.727h2.964c0.982,0,1.778,0.797,1.778,1.778v5.928c0,0.982-0.797,1.778-1.778,1.778h-10.67
              c-0.982,0-1.778-0.797-1.778-1.778v-5.928c0-0.982,0.797-1.778,1.778-1.778h2.964H121.744z M114.038,162.912
              c-0.326,0-0.593,0.267-0.593,0.593v5.928c0,0.326,0.267,0.593,0.593,0.593h10.67c0.326,0,0.593-0.267,0.593-0.593v-5.928
              c0-0.326-0.267-0.593-0.593-0.593h-2.371v3.557c0,0.204-0.107,0.396-0.282,0.504c-0.174,0.107-0.393,0.118-0.578,0.026
              l-2.104-1.052l-2.104,1.052c-0.185,0.093-0.404,0.081-0.578-0.026c-0.174-0.108-0.282-0.3-0.282-0.504v-3.557H114.038z
              M117.595,165.509l1.515-0.756c0.167-0.085,0.364-0.085,0.53,0l1.511,0.756v-2.597h-3.556V165.509z"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>

        <div
          id="g-ai4-1"
          class="g-bg g-aiAbs"
          style="top: 4.4496%; left: 50.0134%; margin-left: -29.0625%; width: 58.125%"
        >
          <p class="g-pstyle0 font-weight-bold">Scope 3</p>
        </div>
        <div
          id="g-ai4-2"
          class="g-bg g-aiAbs"
          style="top: 10.0703%; left: 50.0365%; margin-left: -29.2187%; width: 58.4375%"
        >
          <p class="g-pstyle1">
            Indirect emissions from the value chain typically make up 90% of a company&rsquo;s emissions
          </p>
        </div>

        <div
          type="button"
          button_name="emissions"
          data-toggle="modal"
          data-target="#bubbleModal"
          @click="handleModalMobile('upstream')"
          style="top: 23.8%; left: 4.2%"
          class="g-aiAbs circle-wrapper dtm-button circle-upstream"
        >
          <div class="g-aiAbs circle-label">
            <p class="g-pstyle4">Learn more +</p>
          </div>
        </div>

        <div
          type="button"
          button_name="emissions"
          data-toggle="modal"
          data-target="#bubbleModal"
          @click="handleModalMobile('downstream')"
          style="top: 23.7%; left: 55.6%"
          class="g-aiAbs circle-wrapper dtm-button circle-downstream"
        >
          <div class="g-aiAbs circle-label">
            <p class="g-pstyle4">Learn more +</p>
          </div>
        </div>

        <div
          id="g-ai4-5"
          class="g-bg g-aiAbs"
          style="top: 68.3841%; left: 17.0149%; margin-left: -10.9375%; width: 21.875%"
        >
          <p class="g-pstyle3">Upstream</p>
        </div>
        <div
          id="g-ai4-6"
          class="g-bg g-aiAbs"
          style="top: 68.3841%; left: 82.8778%; margin-left: -14.375%; width: 28.75%"
        >
          <p class="g-pstyle3">Downstream</p>
        </div>
        <div
          id="g-ai4-7"
          class="g-bg g-aiAbs"
          style="top: 68.8525%; left: 49.9459%; margin-left: -12.6562%; width: 25.3125%"
        >
          <p class="g-pstyle3 font-weight-bold">Reporting company</p>
        </div>
        <div
          id="g-ai4-8"
          class="g-bg g-aiAbs"
          style="top: 81.2646%; left: 25.7343%; margin-left: -18.75%; width: 37.5%"
        >
          <p class="g-pstyle4 font-weight-bold">Scope 2</p>
        </div>
        <div id="g-ai4-9" class="g-bg g-aiAbs" style="top: 81.2646%; left: 41.5531%; width: 66.875%">
          <p class="g-pstyle4 font-weight-bold">Scope 1</p>
        </div>
        <div
          id="g-ai4-10"
          class="g-bg g-aiAbs"
          style="top: 85.9485%; left: 22.7416%; margin-left: -21.7187%; width: 50%"
        >
          <p class="g-pstyle3">Indirect emissions</p>
        </div>
        <div
          id="g-ai4-11"
          class="g-bg g-aiAbs"
          style="top: 85.9485%; left: 74.4184%; margin-left: -21.875%; width: 43.75%"
        >
          <p class="g-pstyle3">Direct emissions</p>
        </div>
        <div
          id="g-ai4-12"
          class="g-bg g-aiAbs"
          style="top: 90.3981%; left: 25.7343%; margin-left: -18.75%; width: 37.5%"
        >
          <p class="g-pstyle5">&bull; Purchased energy</p>
        </div>
        <div
          id="g-ai4-13"
          class="g-bg g-aiAbs"
          style="top: 90.3981%; left: 74.5531%; margin-left: -18.4375%; width: 36.875%"
        >
          <p class="g-pstyle5">&bull; Company facilities</p>
          <p class="g-pstyle5">&bull; Company vehicles</p>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="bubbleModal" tabindex="-1" role="dialog" aria-labelledby="bubbleModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button class="close-button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12" v-if="desktopModal">
                <h3 class="text-body--large font-weight-bold mb-15">
                  <img
                    :src="`/assets/web-resources/techecosystem/fintech/2023/images/${selectedBubble.id}.svg`"
                    :alt="'icon of ' + selectedBubble.title"
                    style="margin-right: 5px; vertical-align: text-top"
                  />
                  {{ selectedBubble.title }}
                </h3>

                <p class="text-legend text--primary font-weight-bold">Scope 3 {{ selectedBubble.stream }} activity</p>

                <p class="text-body mb-0">
                  {{ selectedBubble.desc }}
                </p>
              </div>

              <!-- Mobile modal content with exapnsion panels  -->
              <div class="col-sm-12" v-else>
                <h3 class="text-body--large text--primary font-weight-bold mb-15">Scope 3 {{ streamType }} activity</h3>

                <p class="mb-15">
                  {{ streamTypeDesc[streamType] }}
                </p>

                <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                  <div :class="['panel panel-default', streamType]" v-for="item in selectedStream" :key="item.id">
                    <div :class="['panel-heading', streamType]" role="tab" :id="item.label">
                      <h4 class="panel-title">
                        <a
                          class="collapsed text-body text--base accordion-toggle legend"
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          :href="'#' + item.id"
                          aria-expanded="false"
                          :aria-controls="item.id"
                        >
                          <img
                            :src="`/assets/web-resources/techecosystem/fintech/2023/images/${item.id}.svg`"
                            :alt="'icon of ' + item.title"
                            style="margin-right: 5px; vertical-align: text-top"
                          />
                          {{ item.title }}
                        </a>
                      </h4>
                    </div>

                    <div :id="item.id" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="item.label">
                      <div class="panel-body">
                        <p class="text-small mb-0">{{ item.desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { select, json as fetchJson } from 'd3';

export default {
  name: 'VizScope3',
  computed: {
    vizScopes() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'viz-scopes') : {};
    },
    streamTypeDesc() {
      return this.vizScopes ? this.vizScopes.data.streamTypeDesc : {};
    },
    bubbleData() {
      return this.vizScopes ? this.vizScopes.data.bubbleData : [];
    },
    streamType() {
      return this.selectedStream.length === 8 ? 'upstream' : 'downstream';
    },
  },
  data() {
    return {
      content: {},
      selectedBubble: {
        name: '',
      },
      selectedStream: [],
      desktopModal: true,
    };
  },
  async created() {
    window.addEventListener('resize', this.resizer);
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizer);
  },
  mounted() {
    this.resizer();
  },
  methods: {
    resizer() {
      const elements = Array.prototype.slice.call(document.querySelectorAll('.g-artboard'));
      const widthById = {};
      elements.forEach(function (el) {
        const parent = el.parentNode;
        const width = widthById[parent.id] || parent.getBoundingClientRect().width;
        const minwidth = el.getAttribute('data-min-width');
        const maxwidth = el.getAttribute('data-max-width');
        widthById[parent.id] = width;

        if (+minwidth <= width && (+maxwidth >= width || maxwidth === null)) {
          el.style.display = 'block';
        } else {
          el.style.display = 'none';
        }
      });
    },
    handleModal(selected) {
      this.desktopModal = true;
      this.selectedBubble = this.bubbleData.find((d) => d.id === selected);
    },
    handleModalMobile(selected) {
      this.desktopModal = false;
      this.selectedStream = this.bubbleData.filter((d) => d.stream === selected);
    },
    handleMouseover(selected) {
      // select('.sff-2023-interactive-viz-2').selectAll(`g[data-name="circle_${selected}"]`).select('path[data-name="circle"]').attr('stroke', 'black');
      select('.sff-2023-interactive-viz-2')
        .selectAll(`g[data-name="circle_${selected}"]`)
        .selectAll('path[data-name="circle"]')
        .attr('fill-opacity', 0.5);
    },
    handleMouseleave() {
      // select('.sff-2023-interactive-viz-2').selectAll('path[data-name="circle"]').attr('stroke', 'none');/
      select('.sff-2023-interactive-viz-2').selectAll('path[data-name="circle"]').attr('fill-opacity', 1);
    },
  },
};
</script>

<style scoped lang="scss">
.sff-2023-interactive-viz-2 {
  #g-UOB-2023-2-box,
  #g-UOB-2023-2-box .g-artboard {
    margin: 0 auto;
  }
  #g-UOB-2023-2-box p {
    margin: 0;
  }
  #g-UOB-2023-2-box .g-aiAbs {
    position: absolute;
  }
  #g-UOB-2023-2-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
  }
  #g-UOB-2023-2-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-UOB-2023-2-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-UOB-2023-2-_1140px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-2-_1140px p {
    font-weight: 400;
    font-family: 'Noto Sans Regular';
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-UOB-2023-2-_1140px .g-pstyle0 {
    font-weight: 700;
    line-height: 22px;
    font-size: 18px;
    font-family: 'Noto Sans Bold', sans-serif;
    text-align: center;
  }
  #g-UOB-2023-2-_1140px .g-pstyle1 {
    line-height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-UOB-2023-2-_1140px .g-pstyle2 {
    text-align: center;
  }
  #g-UOB-2023-2-_1140px .g-pstyle3 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 24px;
    font-size: 20px;
    text-align: center;
  }
  #g-UOB-2023-2-_1140px .g-pstyle4 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
  }
  #g-UOB-2023-2-_1140px .g-pstyle5 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 22px;
    font-size: 18px;
  }
  #g-UOB-2023-2-_1140px .g-pstyle6 {
    line-height: 18px;
    height: 18px;
    font-size: 15px;
  }
  #g-UOB-2023-2-_1140px .g-pstyle7 {
    font-family: 'Noto Sans Bold', sans-serif;
    font-weight: 700;
    line-height: 18px;
    font-size: 15px;
  }
  #g-UOB-2023-2-_1140px .g-pstyle8 {
    line-height: 18px;
    font-size: 15px;
  }
  #g-UOB-2023-2-_720px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-2-_720px p {
    font-weight: 500;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-UOB-2023-2-_720px .g-pstyle0 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 20px;
    font-size: 17px;
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle1 {
    // font-weight: 700;
    // font-family: 'Noto Sans Bold', sans-serif;
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle2 {
    line-height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle3 {
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle4 {
    line-height: 15px;
    font-size: 12px;
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle5 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 19px;
    font-size: 16px;
    text-align: center;
  }
  #g-UOB-2023-2-_720px .g-pstyle6 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-UOB-2023-2-_720px .g-pstyle7 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 15px;
    height: 15px;
  }
  #g-UOB-2023-2-_720px .g-pstyle8 {
    height: 16px;
  }
  #g-UOB-2023-2-_720px .g-pstyle9 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
  }
  #g-UOB-2023-2-_720px .g-cstyle0 {
    font-weight: 500;
  }
  #g-UOB-2023-2-_560px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-2-_560px p {
    font-weight: 500;
    line-height: 12px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 10px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-UOB-2023-2-_560px .g-pstyle0 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-pstyle1 {
    line-height: 16px;
    font-size: 14px;
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-pstyle2 {
    line-height: 13px;
    font-size: 11px;
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-pstyle3 {
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-pstyle4 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-UOB-2023-2-_560px .g-pstyle5 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 17px;
    font-size: 14px;
  }
  #g-UOB-2023-2-_560px .g-pstyle6 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-pstyle7 {
    line-height: 14px;
    font-size: 12px;
  }
  #g-UOB-2023-2-_560px .g-pstyle8 {
    font-weight: 700;
    font-family: 'Noto Sans Bold', sans-serif;
    line-height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-UOB-2023-2-_560px .g-cstyle0 {
    font-weight: 500;
  }
  #g-UOB-2023-2-_395px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-2-_395px p {
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-UOB-2023-2-_395px .g-pstyle0 {
    line-height: 21px;
    font-size: 18px;
    text-align: center;
  }
  #g-UOB-2023-2-_395px .g-pstyle1 {
    text-align: center;
    font-family: 'Noto Sans Bold';
    font-weight: 700;
  }
  #g-UOB-2023-2-_395px .g-pstyle2 {
    font-weight: 500;
    text-align: center;
  }
  #g-UOB-2023-2-_395px .g-pstyle3 {
    line-height: 21px;
    font-size: 17px;
    text-align: center;
  }
  #g-UOB-2023-2-_395px .g-pstyle4 {
    line-height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-UOB-2023-2-_320px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-2-_320px p {
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-UOB-2023-2-_320px .g-pstyle0 {
    line-height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-UOB-2023-2-_320px .g-pstyle1 {
    text-align: center;
  }
  #g-UOB-2023-2-_320px .g-pstyle2 {
    font-weight: 500;
    text-align: center;
  }
  #g-UOB-2023-2-_320px .g-pstyle3 {
    line-height: 14px;
    font-size: 12px;
    text-align: center;
    font-weight: 700;
    font-family: 'Noto Sans Bold';
  }
  #g-UOB-2023-2-_320px .g-pstyle4 {
    line-height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-UOB-2023-2-_320px .g-pstyle5 {
    font-weight: 500;
    line-height: 14px;
    font-size: 12px;
    text-align: center;
  }
}

// Dialog box styling
.modal-dialog {
  margin: auto !important;
  .modal-body {
    padding: 30px;
    padding-top: 40px;
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    width: auto;
    margin: 64px 24px;

    .modal-body {
      padding: 20px 20px;
      padding-top: 50px;
    }
  }

  width: 570px;
  height: 100% !important;

  .modal-nav {
    border: unset;
    display: flex;
    justify-content: start;
    margin-top: 40px;
    margin-bottom: 25px;
    position: relative;
    z-index: 5;
    padding: 0 25px;

    @media #{map-get($media-breakpoints, 'mobile')} {
      padding: 0 15px;
    }

    p {
      color: #005eb8;
      font-weight: 700;
      font-family: 'Noto Sans Bold', sans-serif;
    }
  }

  .modal-content {
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 570px;
    transform: translate(-50%, -50%);
    max-height: 85vh;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    @media only screen and (max-width: 559px) {
      width: 350px;
    }
  }

  .close-button {
    top: -5px;
    right: 15px;
    font-size: 4rem;
    position: absolute;
    z-index: 5;
    color: #005eb8;
  }
}
a {
  color: #121212;
  font-family: 'Noto Sans Bold';
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

// Accordian styles
.upstream {
  background: #bfc9ff;
}
.downstream {
  background: #a1e6bd;
}
.panel-collapse {
  // background-color: #BFC9FF;

  .panel-body {
    padding: 10px;
    border-top: none !important;
    padding-top: 0;
  }
}
.panel-default {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 5px;
}
.panel-default .panel-heading {
  padding: 10px;
}
.panel.panel-default.upstream:has(.panel-collapse.collapse.in) {
  border: 1px solid #4262ff;
}
.panel.panel-default.downstream:has(.panel-collapse.collapse.in) {
  border: 1px solid #6cd999;
}
.panel-heading .accordion-toggle:after {
  /* symbol for "opening" panels */
  font-family: 'Glyphicons Halflings'; /* essential for enabling glyphicon */
  content: '\e260'; /* adjust as needed, taken from bootstrap.css */
  float: right; /* adjust as needed */
  color: #121212; /* adjust as needed */
}
.panel-heading .accordion-toggle.collapsed:after {
  /* symbol for "collapsed" panels */
  content: '\e259'; /* adjust as needed, taken from bootstrap.css */
}

// Circle button styling
.circle-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  text-align: center;
  border: 2px solid transparent;
}

#g-UOB-2023-2-_720px {
  .circle-wrapper {
    width: 105px;
    height: 105px;
  }

  .circle-label {
    width: 85%;
  }
}

#g-UOB-2023-2-_560px {
  .circle-wrapper {
    width: 82px;
    height: 82px;
  }

  .circle-label {
    width: 85%;
  }
}

#g-UOB-2023-2-_395px {
  .circle-wrapper {
    width: 165px;
    height: 165px;
  }

  .circle-label {
    width: 85%;
    top: 76%;
  }
}

#g-UOB-2023-2-_320px {
  .circle-wrapper {
    width: 130px;
    height: 130px;
  }

  .circle-label {
    width: 85%;
    top: 76%;
  }
}
// Circle labels
.circle-label {
  position: absolute;
  top: 60%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
}

// Circle animation

.circle-bg {
  left: -5px;
  top: -5px;
  position: absolute;
  width: 125px;
  height: 125px;
  border-radius: 50%;
  transform-origin: center;
  -webkit-animation: pulse 2s infinite;
  animation: pulse 2s infinite;
}
.circle-bg-upstream {
  border: 1px solid #bfc9ff;
}
.circle-bg-downstream {
  border: 1px solid #6cd999;
}

@media (hover: none) {
  .circle-wrapper:hover {
    border: 2px solid transparent;
  }
}

path[data-name='circle'] {
  stroke-width: 1;
  // stroke: #bfc9ff;
  stroke-opacity: 0.8;
  animation-name: grow;
  animation-duration: 1s;
  animation-timing-function: ease-out;
  animation-delay: 0;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-fill-mode: none;
  animation-play-state: running;
  transform-origin: center;
}

path[id*='d-circle'] {
  stroke: #a1e6bd;
}

path[id*='u-circle'] {
  stroke: #bfc9ff;
}

@keyframes grow {
  0% {
    stroke-width: 1;
  }
  25% {
    stroke-width: 3;
  }
  50% {
    stroke-width: 5;
  }
  75% {
    stroke-width: 3;
  }
  100% {
    stroke-width: 1;
  }
}

.legend {
  display: grid;
  grid-template-columns: 30px auto 20px;
  align-items: center;
  column-gap: 10px;

  img {
    max-width: 28px;
  }
}

.mb-0 {
  margin-bottom: 0;
}

.mb-15 {
    margin-bottom: 15px;
}
.mb-30 {
    margin-bottom: 30px;
}

h3.text-body--large {
  font-size: 20px;
  line-height: 1.35;
  font-weight: 700;
}

h4.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}
</style>


<style>
  @font-face {
    font-family: "Glyphicons Halflings";
    src: url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.eot);
    src: url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.eot?#iefix) format("embedded-opentype"),
      url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.woff2) format("woff2"),
      url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.woff) format("woff"),
      url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.ttf) format("truetype"),
      url(/assets/web-resources/techecosystem/fintech/2023/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular) format("svg")}
</style>